import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

/** 접속 로그 정보 */
export type AccessLogDto = {
  __typename?: 'AccessLogDto';
  /** 접속 일시 */
  createdAt: Scalars['DateTime']['output'];
  /** 에러 메시지 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** 클라이언트 IP 주소 */
  ipAddress: Scalars['String']['output'];
  /** HTTP 메서드 */
  method: Scalars['String']['output'];
  /** 접속 URL/경로 */
  path: Scalars['String']['output'];
  /** 쿼리 파라미터 */
  queryString?: Maybe<Scalars['String']['output']>;
  /** 요청 추적 ID */
  requestId?: Maybe<Scalars['String']['output']>;
  /** 응답 시간 (ms) */
  responseTime?: Maybe<Scalars['Int']['output']>;
  /** 접속 결과 (SUCCESS, FAILED, ERROR) */
  result: Scalars['String']['output'];
  /** seq */
  seq: Scalars['Int']['output'];
  /** HTTP 상태 코드 */
  statusCode: Scalars['Int']['output'];
  /** 클라이언트 User-Agent */
  userAgent?: Maybe<Scalars['String']['output']>;
  /** 사용자 ID/계정 */
  userId?: Maybe<Scalars['String']['output']>;
};

export type AccessLogListOptions = {
  /** 접속 일시 */
  createdAt?: InputMaybe<SearchDateInput>;
  /** IP 주소 */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** HTTP 메서드 */
  method?: InputMaybe<Scalars['String']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 접속 경로 */
  path?: InputMaybe<Scalars['String']['input']>;
  /** 접속 결과 (SUCCESS, FAILED, ERROR) */
  result?: InputMaybe<Scalars['String']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 사용자 ID/계정 */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Activity log create input */
export type ActivityLogCreateInput = {
  /** Activity type */
  activityType: Scalars['String']['input'];
  /** Barcode */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description: Scalars['String']['input'];
  /** Detail log payload (stringified) */
  detailLog?: InputMaybe<Scalars['String']['input']>;
  /** Device sequence */
  deviceSeq?: InputMaybe<Scalars['Int']['input']>;
  /** Hospital room sequence */
  hospitalRoomSeq?: InputMaybe<Scalars['Int']['input']>;
  /** Hospital sequence */
  hospitalSeq?: InputMaybe<Scalars['Int']['input']>;
  /** Reason */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Target entity sequence */
  targetEntitySeq?: InputMaybe<Scalars['Int']['input']>;
  /** Target entity type */
  targetEntityType?: InputMaybe<Scalars['String']['input']>;
};

/** 작업 로그 정보 */
export type ActivityLogDto = {
  __typename?: 'ActivityLogDto';
  /** 작업 유형 */
  activityType?: Maybe<Scalars['String']['output']>;
  /** 처리자 */
  actorIdentity?: Maybe<Scalars['String']['output']>;
  /** 바코드 */
  barcode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 내역 */
  description?: Maybe<Scalars['String']['output']>;
  /** 상세내역 */
  detailLog?: Maybe<Scalars['String']['output']>;
  /** 장비 seq */
  deviceSeq?: Maybe<Scalars['Float']['output']>;
  /** 진료실 seq */
  hospitalRoomSeq?: Maybe<Scalars['Float']['output']>;
  /** 병원 seq */
  hospitalSeq?: Maybe<Scalars['Float']['output']>;
  /** 클라이언트 IP 주소 */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** 사유 */
  reason?: Maybe<Scalars['String']['output']>;
  /** 요청 추적 ID */
  requestId?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Float']['output']>;
  /** 대상 엔티티 seq */
  targetEntitySeq?: Maybe<Scalars['Float']['output']>;
  /** 대상 엔티티 타입 */
  targetEntityType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** 클라이언트 User-Agent */
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogListOptions = {
  /** 작업시각 */
  createdAt?: InputMaybe<SearchDateInput>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 유형 */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** 관리자 정보 */
export type AdminUserDto = {
  __typename?: 'AdminUserDto';
  createdAt: Scalars['DateTime']['output'];
  /** 로그인 허용 여부 */
  enabledFlag: Scalars['Boolean']['output'];
  seq: Scalars['ID']['output'];
  /** 슈퍼 관리자 여부 */
  superFlag: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** 관리자 이름 */
  userDisplayName: Scalars['String']['output'];
  /** 관리자 이메일 */
  userEmail: Scalars['String']['output'];
};

export type AdminUserListOptions = {
  enabledFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
};

export type AgentSshInfo = {
  __typename?: 'AgentSshInfo';
  action?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AgentStateDto = {
  __typename?: 'AgentStateDto';
  agentSsh?: Maybe<AgentSshInfo>;
  agentVersion?: Maybe<Scalars['String']['output']>;
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthFlowInfo = {
  __typename?: 'AuthFlowInfo';
  /** 현재 인증 모드 */
  authMode: Scalars['String']['output'];
  /** Google OAuth 인증 사용 여부 */
  googleEnabled: Scalars['Boolean']['output'];
  /** 숨김 키 로그인 사용 여부 */
  keyLoginEnabled: Scalars['Boolean']['output'];
  keycloakAuthServerUrl?: Maybe<Scalars['String']['output']>;
  keycloakClientId?: Maybe<Scalars['String']['output']>;
  /** Keycloak 인증 사용 여부 */
  keycloakEnabled: Scalars['Boolean']['output'];
  keycloakIssuer?: Maybe<Scalars['String']['output']>;
  keycloakJwksUri?: Maybe<Scalars['String']['output']>;
  keycloakRealm?: Maybe<Scalars['String']['output']>;
  /** 서버 내부 JWT 알고리즘 */
  serverJwtAlgorithm: Scalars['String']['output'];
  /** 서버 내부 JWT 사용 여부 */
  serverJwtEnabled: Scalars['Boolean']['output'];
  /** 서버 내부 JWT 만료 시간 */
  serverJwtExpiresIn: Scalars['String']['output'];
  /** 서버 내부 JWT 토큰 버전 */
  serverJwtTokenVersion: Scalars['Float']['output'];
};

export type BabyAiListDto = {
  __typename?: 'BabyAiListDto';
  babyMagicImageS3FileKey?: Maybe<Scalars['String']['output']>;
  babyMagicUrl?: Maybe<Scalars['String']['output']>;
  babySeq?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  billableVisibleFlag: Scalars['Boolean']['output'];
  captureImageS3FileKey: Scalars['String']['output'];
  captureUrl: Scalars['String']['output'];
  capturedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deviceSeq: Scalars['Float']['output'];
  fileId: Scalars['String']['output'];
  hiddenBabyImageS3FileKey?: Maybe<Scalars['String']['output']>;
  hiddenBabyUrl?: Maybe<Scalars['String']['output']>;
  /** 병원 정보 */
  hospital?: Maybe<HospitalDto>;
  /** 병실 정보 */
  hospitalRoom?: Maybe<HospitalRoomDto>;
  hospitalRoomSeq: Scalars['Float']['output'];
  hospitalSeq: Scalars['Float']['output'];
  seq: Scalars['Float']['output'];
  signedBabyMagicUrl?: Maybe<Scalars['String']['output']>;
  signedCaptureUrl?: Maybe<Scalars['String']['output']>;
  signedHiddenBabyUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userSeq?: Maybe<Scalars['Float']['output']>;
  visibleFlag: Scalars['Boolean']['output'];
  webhookSentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BabyAiListOptions = {
  /** 녹화시각 */
  capturedAt?: InputMaybe<SearchDateInput>;
  /** 생성일시 */
  createdAt?: InputMaybe<SearchDateInput>;
  /** 병실 번호 */
  hospitalRoomSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 병원 번호 */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 공개/비공개 여부 */
  visibleFlag?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** 디바이스 일괄 등록 래퍼 Input */
export type BatchCreateDevicesInput = {
  /** 등록할 디바이스 목록 (최대 100개) */
  devices: Array<BatchDeviceInput>;
};

export type BatchCreateFailure = {
  __typename?: 'BatchCreateFailure';
  /** 실패한 설명 */
  description: Scalars['String']['output'];
  /** 실패한 장비명 */
  deviceName: Scalars['String']['output'];
  /** 에러 메시지 */
  errorMessage: Scalars['String']['output'];
};

export type BatchCreateResult = {
  __typename?: 'BatchCreateResult';
  /** 실패 건수 */
  failureCount: Scalars['Int']['output'];
  /** 실패 목록 */
  failures: Array<BatchCreateFailure>;
  /** 전체 메시지 */
  message?: Maybe<Scalars['String']['output']>;
  /** 전체 작업 성공 여부 */
  success: Scalars['Boolean']['output'];
  /** 성공 건수 */
  successCount: Scalars['Int']['output'];
};

export type BatchCreateSpecialBarcodeFailure = {
  __typename?: 'BatchCreateSpecialBarcodeFailure';
  /** 실패한 바코드 */
  barcode: Scalars['String']['output'];
  /** 에러 메시지 */
  errorMessage: Scalars['String']['output'];
};

export type BatchCreateSpecialBarcodesInput = {
  /** 등록할 바코드 목록 (최대 100개) */
  barcodes: Array<Scalars['String']['input']>;
  /** True이면 연관된 recording의 deleteFlag를 1로 업데이트 */
  blindRecording?: InputMaybe<Scalars['Boolean']['input']>;
  /** True이면 연관된 class voucher를 만료 처리 */
  expireClassVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  /** 예외 바코드 사유 */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** 예외 바코드 유형 */
  type: Scalars['String']['input'];
};

export type BatchCreateSpecialBarcodesResult = {
  __typename?: 'BatchCreateSpecialBarcodesResult';
  /** 실패 건수 */
  failureCount: Scalars['Int']['output'];
  /** 실패 목록 */
  failures: Array<BatchCreateSpecialBarcodeFailure>;
  /** 전체 메시지 */
  message?: Maybe<Scalars['String']['output']>;
  /** 전체 작업 성공 여부 */
  success: Scalars['Boolean']['output'];
  /** 성공 건수 */
  successCount: Scalars['Int']['output'];
};

/** 일괄 디바이스 등록 Input */
export type BatchDeviceInput = {
  /** 설명 */
  description: Scalars['String']['input'];
  /** 장비명(기번) */
  deviceName: Scalars['String']['input'];
  /** 병실 시퀀스 */
  hospitalRoomSeq: Scalars['Float']['input'];
  /** 병원 시퀀스 */
  hospitalSeq: Scalars['Float']['input'];
};

/** 시스템 설정 일괄 업데이트 입력 */
export type BatchUpdateSystemSettingsInputDto = {
  /** 업데이트할 설정들 */
  settings: Array<UpdateSystemSettingInputDto>;
  /** 수정자 */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** 마미박스 로그 */
export type BoxLogDto = {
  __typename?: 'BoxLogDto';
  /** 전체로그 */
  rawLog?: Maybe<Scalars['String']['output']>;
  /** 세션로그 */
  sessionLogs?: Maybe<Array<SessionLogDto>>;
};

/** 채널톡 요청 일괄 처리 결과 */
export type BulkChannelTalkRequestActionResult = {
  __typename?: 'BulkChannelTalkRequestActionResult';
  failureCount: Scalars['Int']['output'];
  results: Array<ChannelTalkRequestActionResult>;
  successCount: Scalars['Int']['output'];
};

/** 캡쳐 업로드 정보 Input */
export type CaptureUploadInput = {
  /** 바코드 번호 */
  barcode: Scalars['String']['input'];
  /** 업로드할 파일 (base64, data URL, 또는 파일 경로). 지원 형식: JPG, JPEG, PNG, GIF, WEBP */
  captureFile: Scalars['String']['input'];
  /** 캡쳐 시간 */
  capturedAt: Scalars['String']['input'];
  /** 녹화 영상 seq */
  recordingSeq: Scalars['Float']['input'];
};

/** 채널톡 상세 대화 내역 */
export type ChannelTalkConversation = {
  __typename?: 'ChannelTalkConversation';
  messages: Array<ChannelTalkConversationMessage>;
  userChatId?: Maybe<Scalars['String']['output']>;
};

/** 채널톡 상세 대화 메시지 전송 결과 */
export type ChannelTalkConversationActionResult = {
  __typename?: 'ChannelTalkConversationActionResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** 채널톡 상세 대화 메시지 */
export type ChannelTalkConversationMessage = {
  __typename?: 'ChannelTalkConversationMessage';
  actorKind?: Maybe<Scalars['String']['output']>;
  badge?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  senderType: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum ChannelTalkDecisionSource {
  ADMIN = 'ADMIN',
  SLACK = 'SLACK',
  SYSTEM = 'SYSTEM'
}

export enum ChannelTalkExecutionMode {
  AUTO = 'AUTO',
  REVIEW = 'REVIEW'
}

/** 채널톡 영상 요청 로그 */
export type ChannelTalkRequest = {
  __typename?: 'ChannelTalkRequest';
  channelId: Scalars['String']['output'];
  channelTalkUserId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  decisionAt?: Maybe<Scalars['DateTime']['output']>;
  decisionBy?: Maybe<Scalars['String']['output']>;
  decisionSource?: Maybe<ChannelTalkDecisionSource>;
  editDurationSeconds?: Maybe<Scalars['Int']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executedBy?: Maybe<Scalars['String']['output']>;
  executionMode: ChannelTalkExecutionMode;
  hospitalName?: Maybe<Scalars['String']['output']>;
  hospitalRoomName?: Maybe<Scalars['String']['output']>;
  hospitalRoomSeq?: Maybe<Scalars['Int']['output']>;
  hospitalSeq?: Maybe<Scalars['Int']['output']>;
  initialSnapshot?: Maybe<Scalars['JSON']['output']>;
  liveAssessment?: Maybe<Scalars['JSON']['output']>;
  messageSentFlag: Scalars['Boolean']['output'];
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  recordingSeq?: Maybe<Scalars['Int']['output']>;
  responseMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  responseMessageText?: Maybe<Scalars['String']['output']>;
  resultMessage?: Maybe<Scalars['String']['output']>;
  reviewReason?: Maybe<Scalars['String']['output']>;
  rollbackAvailable: Scalars['Boolean']['output'];
  rollbackDisabledReason?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Int']['output'];
  slackChannelId?: Maybe<Scalars['String']['output']>;
  slackMessageTs?: Maybe<Scalars['String']['output']>;
  sourceBarcode?: Maybe<Scalars['String']['output']>;
  status: ChannelTalkRequestStatus;
  submitData: Scalars['JSON']['output'];
  targetBarcode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userChatId?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  workflowCauseOfEnd?: Maybe<Scalars['String']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
  workflowRevisionId?: Maybe<Scalars['String']['output']>;
  workflowSectionPath?: Maybe<Array<Scalars['String']['output']>>;
  workflowTraceId?: Maybe<Scalars['String']['output']>;
  workflowTriggerId?: Maybe<Scalars['String']['output']>;
  workflowType: ChannelTalkWorkflowType;
};

/** 채널톡 요청 처리 결과 */
export type ChannelTalkRequestActionResult = {
  __typename?: 'ChannelTalkRequestActionResult';
  message?: Maybe<Scalars['String']['output']>;
  request?: Maybe<ChannelTalkRequest>;
  success: Scalars['Boolean']['output'];
};

/** 채널톡 요청 현재 상태 갱신 결과 */
export type ChannelTalkRequestCurrentStatusResult = {
  __typename?: 'ChannelTalkRequestCurrentStatusResult';
  completedByClosedConversation: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  request?: Maybe<ChannelTalkRequest>;
  success: Scalars['Boolean']['output'];
};

export type ChannelTalkRequestFilter = {
  /** 생성일 필터 */
  createdAt?: InputMaybe<SearchDateInput>;
  /** 실행 모드 필터 */
  executionModes?: InputMaybe<Array<ChannelTalkExecutionMode>>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 상태 필터 */
  statuses?: InputMaybe<Array<ChannelTalkRequestStatus>>;
  /** 요청 유형 필터 */
  workflowTypes?: InputMaybe<Array<ChannelTalkWorkflowType>>;
};

export enum ChannelTalkRequestStatus {
  EXECUTED = 'EXECUTED',
  EXECUTING = 'EXECUTING',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum ChannelTalkWorkflowType {
  DELETE = 'DELETE',
  EDIT = 'EDIT',
  TRANSFER = 'TRANSFER'
}

/** Crystal Reveal 프롬프트 draft 생성 입력 */
export type CreateCrystalRevealPromptDraftInputDto = {
  memo?: InputMaybe<Scalars['String']['input']>;
  sourcePromptSetSeq?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSpecialBarcodeInput = {
  barcode: Scalars['String']['input'];
  /** True이면 연관된 recording의 deleteFlag를 1로 업데이트 */
  blindRecording?: InputMaybe<Scalars['Boolean']['input']>;
  /** True이면 연관된 class voucher를 만료 처리 */
  expireClassVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** 시스템 설정 생성 입력 */
export type CreateSystemSettingInputDto = {
  /** 선택 가능한 값들 JSON */
  availableValues?: InputMaybe<Scalars['String']['input']>;
  /** 제약조건 JSON */
  constraints?: InputMaybe<Scalars['String']['input']>;
  /** 데이터 타입 */
  dataType: SystemSettingDataType;
  /** 기본값 */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** 설정 설명 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 표시 순서 */
  displayOrder?: Scalars['Int']['input'];
  /** 활성화 여부 */
  isActive?: Scalars['Boolean']['input'];
  /** 필수 여부 */
  isRequired?: Scalars['Boolean']['input'];
  /** 설정 키 */
  settingKey: Scalars['String']['input'];
  /** 생성자 */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** 설정값 */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** USB 디바이스 생성 Input */
export type CreateUsbDeviceInput = {
  /** 별칭 (캡처보드용) */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** 한글 표시명 */
  kor: Scalars['String']['input'];
  /** 기술명 */
  name: Scalars['String']['input'];
  /** Product ID (10진수) */
  pid: Scalars['Int']['input'];
  /** 단일키 장치 여부 */
  singleKeyDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** 디바이스 타입 */
  type: UsbDeviceType;
  /** Vendor ID (10진수) */
  vid: Scalars['Int']['input'];
};

export type CredentialsDto = {
  __typename?: 'CredentialsDto';
  accessKeyId: Scalars['String']['output'];
  expiration: Scalars['DateTime']['output'];
  secretAccessKey: Scalars['String']['output'];
  sessionToken?: Maybe<Scalars['String']['output']>;
};

/** CRM 정보 */
export type CrmDto = {
  __typename?: 'CrmDto';
  /** 구글 계정 ID */
  actorIdentity: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** 처리 상태 */
  crmStatus?: Maybe<Scalars['String']['output']>;
  /** 유형 정보 */
  crmType: CrmTypeDto;
  /** 유형 seq */
  crmTypeSeq: Scalars['Float']['output'];
  /** 기록 내용 */
  description?: Maybe<Scalars['String']['output']>;
  /** 병원 정보 */
  hospital?: Maybe<HospitalDto>;
  /** 진료실 정보 */
  hospitalRoom?: Maybe<HospitalRoomDto>;
  /** 진료실 seq */
  hospitalRoomSeq?: Maybe<Scalars['Float']['output']>;
  /** 병원 seq */
  hospitalSeq?: Maybe<Scalars['Float']['output']>;
  seq: Scalars['Float']['output'];
  /** 슬랙 메시지 아이디 */
  slackMessageId?: Maybe<Scalars['String']['output']>;
  /** 슬랙 링크 */
  slackPermaLink?: Maybe<Scalars['String']['output']>;
  /** 미사용 */
  slackTaNudge?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** 미사용 */
  visitDate?: Maybe<Scalars['DateTime']['output']>;
  /** 미사용 */
  visitMemo?: Maybe<Scalars['String']['output']>;
};

/** CRM 정보 Input */
export type CrmInput = {
  /** 로그인된 구글 계정이나 일반 계정 ID */
  actorIdentity?: InputMaybe<Scalars['String']['input']>;
  /** 처리 상태 */
  crmStatus?: InputMaybe<Scalars['String']['input']>;
  /** CRM 유형 seq */
  crmTypeSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 기록 내용 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 진료실 seq */
  hospitalRoomSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 병원 seq */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** Slack 전송 여부 */
  sendSlack: Scalars['Boolean']['input'];
  seq?: InputMaybe<Scalars['Float']['input']>;
  /** 슬랙 메시지 아이디 */
  slackMessageId?: InputMaybe<Scalars['String']['input']>;
  /** 슬랙 링크 */
  slackPermaLink?: InputMaybe<Scalars['String']['input']>;
  /** 미사용 */
  slackTaNudge?: InputMaybe<Scalars['Boolean']['input']>;
  /** 미사용 */
  visitDate?: InputMaybe<Scalars['String']['input']>;
  /** 미사용 */
  visitMemo?: InputMaybe<Scalars['String']['input']>;
};

export type CrmListOptions = {
  /** 로그인된 구글 계정이나 일반 계정 ID */
  actorIdentity?: InputMaybe<Scalars['String']['input']>;
  /** CRM내역 생성시간 */
  createdAt?: InputMaybe<SearchDateInput>;
  /** 처리 상태 */
  crmStatus?: InputMaybe<Scalars['String']['input']>;
  /** 병원명 */
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 유형 */
  typeName?: InputMaybe<Scalars['String']['input']>;
};

/** CRM 유형 정보 */
export type CrmTypeDto = {
  __typename?: 'CrmTypeDto';
  /** 활성화 여부 */
  activeFlag: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** CRM 정보 */
  crms?: Maybe<Array<CrmDto>>;
  seq: Scalars['Float']['output'];
  /** 유형명 */
  typeName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** CRM 유형 정보 Input */
export type CrmTypeInput = {
  /** 활성화 여부 */
  activeFlag?: InputMaybe<Scalars['Boolean']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
  /** 유형명 */
  typeName?: InputMaybe<Scalars['String']['input']>;
};

/** Crystal Reveal 프롬프트 */
export type CrystalRevealPromptDto = {
  __typename?: 'CrystalRevealPromptDto';
  createdAt: Scalars['DateTime']['output'];
  model: Scalars['String']['output'];
  parametersJson?: Maybe<Scalars['JSON']['output']>;
  promptSetSeq: Scalars['Int']['output'];
  promptText: Scalars['String']['output'];
  promptType: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Crystal Reveal 프롬프트 입력 */
export type CrystalRevealPromptInputDto = {
  model?: InputMaybe<Scalars['String']['input']>;
  parametersJson?: InputMaybe<Scalars['JSON']['input']>;
  promptText: Scalars['String']['input'];
  promptType: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};

/** Crystal Reveal 프롬프트 세트 */
export type CrystalRevealPromptSetDto = {
  __typename?: 'CrystalRevealPromptSetDto';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  prompts: Array<CrystalRevealPromptDto>;
  seq: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type DeviceAlertPolicy = {
  __typename?: 'DeviceAlertPolicy';
  autoCreated: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  groupBy?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  maxThreadCount: Scalars['Int']['output'];
  severity: DeviceNotificationSeverity;
  slackEnabled: Scalars['Boolean']['output'];
  slackThresholdCount: Scalars['Int']['output'];
  threadEnabled: Scalars['Boolean']['output'];
  threadWindowMinutes: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceAlertPolicyFilters = {
  autoCreated?: InputMaybe<Scalars['Boolean']['input']>;
  severities?: InputMaybe<Array<DeviceNotificationSeverity>>;
};

export type DeviceAlertPolicyListOptions = {
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
};

/** 장비 정보 */
export type DeviceDto = {
  __typename?: 'DeviceDto';
  /** 활성화 상태 */
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  /** 작업 로그 정보 */
  activityLogs?: Maybe<Array<ActivityLogDto>>;
  /** 에이전트 연결 상태 정보 */
  agentState?: Maybe<AgentStateDto>;
  /** cfg1 설정 JSON */
  cfg1?: Maybe<Scalars['JSON']['output']>;
  /** 자동 업데이트 여부 */
  cfg1_auto_update: Scalars['Boolean']['output'];
  /** 녹화 중에만 캡쳐 */
  cfg1_capture_on_recording?: Maybe<Scalars['Boolean']['output']>;
  /** 캡처 사운드 소리 크기 (3단계) */
  cfg1_capture_sound_level?: Maybe<Scalars['Float']['output']>;
  /** 캡처 스위치 사용 모드 */
  cfg1_capture_sw_mode?: Maybe<Scalars['String']['output']>;
  /** 1년 이상 지난 바코드 차단 여부 (-1: 기존 설정 따름) */
  cfg1_check_expired_barcode?: Maybe<Scalars['Float']['output']>;
  /** 유효 바코드 체크 */
  cfg1_check_invalid_barcode?: Maybe<Scalars['Boolean']['output']>;
  /** 네트워크 상태 감지 */
  cfg1_check_online: Scalars['Boolean']['output'];
  /** 핑크바코드 차단 여부 (-1: 기존 설정 따름) */
  cfg1_check_pink_barcode?: Maybe<Scalars['Float']['output']>;
  /** 핑크바코드 사용기간 경과 차단 여부 (기본값 꺼짐) */
  cfg1_check_pink_barcode_period?: Maybe<Scalars['Float']['output']>;
  /** 핑크바코드 사용기간 (일, 기본값 60) */
  cfg1_pink_barcode_valid_days?: Maybe<Scalars['Float']['output']>;
  /** 화면보호기 모드 감지 */
  cfg1_check_screensaver: Scalars['Boolean']['output'];
  /** 색상 불균형 임계값 */
  cfg1_color_imbalance_threshold?: Maybe<Scalars['Float']['output']>;
  /** 디버그 모드 활성화 */
  cfg1_debug_mode: Scalars['Boolean']['output'];
  /** 파일 체크 시간 간격 (초) */
  cfg1_file_check_interval?: Maybe<Scalars['Float']['output']>;
  /** 파일 증가율 학습 기능 활성화 */
  cfg1_file_growth_learning_enabled: Scalars['Boolean']['output'];
  /** 파일 체크 최대 실패 횟수 */
  cfg1_file_max_failures?: Maybe<Scalars['Float']['output']>;
  /** 파일 체크 오류 실패 횟수 */
  cfg1_file_max_failures_for_error?: Maybe<Scalars['Float']['output']>;
  /** 파일 최소 증가율 (bytes/sec) */
  cfg1_file_min_growth_rate?: Maybe<Scalars['Float']['output']>;
  /** 녹화 중 이미지 품질 체크 */
  cfg1_image_quality_check_enabled: Scalars['Boolean']['output'];
  /** 문제된 이미지 허용 횟수 */
  cfg1_max_consecutive_image_issues?: Maybe<Scalars['Float']['output']>;
  /** 최대 녹화 시간 */
  cfg1_max_recording_time?: Maybe<Scalars['Float']['output']>;
  /** 모션 감지 임계값 */
  cfg1_motion_threshold?: Maybe<Scalars['Float']['output']>;
  /** 모션감지 타임아웃 */
  cfg1_motion_timeout?: Maybe<Scalars['Float']['output']>;
  /** 현장 알림 피드백 (사운드/LED) 활성화 */
  cfg1_notification_feedback?: Maybe<Scalars['Float']['output']>;
  /** 녹화 중지/재개 소리 출력 여부 */
  cfg1_pause_resume_sound_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** 녹화 영상 밝기 */
  cfg1_recording_brightness?: Maybe<Scalars['Float']['output']>;
  /** 녹음 사운드 카드 우선순위 선택 모드 */
  cfg1_recording_card_select_mode?: Maybe<Scalars['String']['output']>;
  /** 녹화 영상 대비 */
  cfg1_recording_contrast?: Maybe<Scalars['Float']['output']>;
  /** 녹화 종료 후 영상·음성 품질 검사 (2.11.310 이상, 기본값 켜짐) */
  cfg1_recording_media_validation_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** 녹화 파일 정지 화면 감지 기준 (초, 기본값 600) */
  cfg1_recording_video_freeze_threshold_sec?: Maybe<Scalars['Float']['output']>;
  /** S3 직접 업로드 사용 여부 */
  cfg1_s3_direct_upload?: Maybe<Scalars['Boolean']['output']>;
  /** 모션감지 밝기 임계값 */
  cfg1_threshold_luminance?: Maybe<Scalars['Float']['output']>;
  /** 자동 업데이트 대상 버전 */
  cfg1_update_target?: Maybe<Scalars['String']['output']>;
  /** 다이어리 캡처 사용 여부 */
  cfg1_use_diary_capture?: Maybe<Scalars['Boolean']['output']>;
  /** 프린터 사용 여부 */
  cfg1_use_printer_cp1300?: Maybe<Scalars['Boolean']['output']>;
  /** 비디오 길이 체크 비율 */
  cfg1_video_min_duration_ratio?: Maybe<Scalars['Float']['output']>;
  /** 비디오 타임스탬프 동기화 설정 */
  cfg1_vsync?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 설명 */
  description?: Maybe<Scalars['String']['output']>;
  /** 장비명(기번) */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** Redis에 저장된 장비 상태 정보 */
  deviceState?: Maybe<DeviceStateDto>;
  /** 병원 정보 */
  hospital?: Maybe<HospitalDto>;
  /** 병실 정보 */
  hospitalRoom?: Maybe<HospitalRoomDto>;
  hospitalRoomSeq?: Maybe<Scalars['Float']['output']>;
  hospitalSeq?: Maybe<Scalars['Float']['output']>;
  /** 설치 상태 */
  installFlag?: Maybe<Scalars['Boolean']['output']>;
  /** 초음파 영상 정보 */
  recordings?: Maybe<Array<RecordingDto>>;
  seq: Scalars['Float']['output'];
  /** 세션 정보 */
  sessions?: Maybe<Array<SessionDto>>;
  status?: Maybe<Scalars['String']['output']>;
  /** 초음파 캡처 정보 */
  ultrasoundCaptures?: Maybe<Array<UltrasoundCaptureDto>>;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** 장비 정보 Input */
export type DeviceInput = {
  /** 활성화 상태 */
  activeFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 에이전트 v3 버전 */
  agentVersionFix?: InputMaybe<Scalars['Boolean']['input']>;
  /** 자동 업데이트 여부 */
  cfg1_auto_update?: InputMaybe<Scalars['Boolean']['input']>;
  /** 녹화 중에만 캡쳐 */
  cfg1_capture_on_recording?: InputMaybe<Scalars['Boolean']['input']>;
  /** 캡처 사운드 소리 크기 (3단계) */
  cfg1_capture_sound_level?: InputMaybe<Scalars['Float']['input']>;
  /** 캡처 스위치 사용 모드 */
  cfg1_capture_sw_mode?: InputMaybe<Scalars['String']['input']>;
  /** 1년 이상 지난 바코드 차단 여부 (-1: 기존 설정 따름) */
  cfg1_check_expired_barcode?: InputMaybe<Scalars['Float']['input']>;
  /** 유효 바코드 체크 */
  cfg1_check_invalid_barcode?: InputMaybe<Scalars['Boolean']['input']>;
  /** 네트워크 상태 감지 */
  cfg1_check_online?: InputMaybe<Scalars['Boolean']['input']>;
  /** 핑크바코드 차단 여부 (-1: 기존 설정 따름) */
  cfg1_check_pink_barcode?: InputMaybe<Scalars['Float']['input']>;
  /** 핑크바코드 사용기간 경과 차단 여부 (기본값 꺼짐) */
  cfg1_check_pink_barcode_period?: InputMaybe<Scalars['Float']['input']>;
  /** 핑크바코드 사용기간 (일, 기본값 60) */
  cfg1_pink_barcode_valid_days?: InputMaybe<Scalars['Float']['input']>;
  /** 화면보호기 모드 감지 */
  cfg1_check_screensaver?: InputMaybe<Scalars['Boolean']['input']>;
  /** 색상 불균형 임계값 */
  cfg1_color_imbalance_threshold?: InputMaybe<Scalars['Float']['input']>;
  /** 디버그 모드 활성화 */
  cfg1_debug_mode?: InputMaybe<Scalars['Boolean']['input']>;
  /** 파일 체크 시간 간격 (초) */
  cfg1_file_check_interval?: InputMaybe<Scalars['Float']['input']>;
  /** 파일 증가율 학습 기능 활성화 */
  cfg1_file_growth_learning_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 파일 체크 최대 실패 횟수 */
  cfg1_file_max_failures?: InputMaybe<Scalars['Float']['input']>;
  /** 파일 체크 오류 실패 횟수 */
  cfg1_file_max_failures_for_error?: InputMaybe<Scalars['Float']['input']>;
  /** 파일 최소 증가율 (bytes/sec) */
  cfg1_file_min_growth_rate?: InputMaybe<Scalars['Float']['input']>;
  /** 녹화 중 이미지 품질 체크 */
  cfg1_image_quality_check_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 문제된 이미지 허용 횟수 */
  cfg1_max_consecutive_image_issues?: InputMaybe<Scalars['Float']['input']>;
  /** 최대 녹화 시간 */
  cfg1_max_recording_time?: InputMaybe<Scalars['Float']['input']>;
  /** 모션 감지 임계값 */
  cfg1_motion_threshold?: InputMaybe<Scalars['Float']['input']>;
  /** 모션감지 타임아웃 */
  cfg1_motion_timeout?: InputMaybe<Scalars['Float']['input']>;
  /** 현장 알림 피드백 (사운드/LED) 활성화 */
  cfg1_notification_feedback?: InputMaybe<Scalars['Float']['input']>;
  /** 녹화 중지/재개 소리 출력 여부 */
  cfg1_pause_resume_sound_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 녹화 영상 밝기 */
  cfg1_recording_brightness?: InputMaybe<Scalars['Float']['input']>;
  /** 녹음 사운드 카드 우선순위 선택 모드 */
  cfg1_recording_card_select_mode?: InputMaybe<Scalars['String']['input']>;
  /** 녹화 영상 대비 */
  cfg1_recording_contrast?: InputMaybe<Scalars['Float']['input']>;
  /** 녹화 종료 후 영상·음성 품질 검사 (2.11.310 이상) */
  cfg1_recording_media_validation_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 녹화 파일 정지 화면 감지 기준 (초, 최소 1, 기본값 600) */
  cfg1_recording_video_freeze_threshold_sec?: InputMaybe<Scalars['Float']['input']>;
  /** S3 직접 업로드 사용 여부 */
  cfg1_s3_direct_upload?: InputMaybe<Scalars['Boolean']['input']>;
  /** 모션감지 밝기 임계값 */
  cfg1_threshold_luminance?: InputMaybe<Scalars['Float']['input']>;
  /** 자동 업데이트 대상 버전 */
  cfg1_update_target?: InputMaybe<Scalars['String']['input']>;
  /** 다이어리 캡처 사용 여부 */
  cfg1_use_diary_capture?: InputMaybe<Scalars['Boolean']['input']>;
  /** 프린터 사용 여부 */
  cfg1_use_printer_cp1300?: InputMaybe<Scalars['Boolean']['input']>;
  /** 비디오 길이 체크 비율 */
  cfg1_video_min_duration_ratio?: InputMaybe<Scalars['Float']['input']>;
  /** 비디오 타임스탬프 동기화 설정 */
  cfg1_vsync?: InputMaybe<Scalars['String']['input']>;
  /** 설명 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 장비명(기번) */
  deviceName?: InputMaybe<Scalars['String']['input']>;
  /** 진료실 seq */
  hospitalRoomSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 병원 seq */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 미사용 */
  hwid?: InputMaybe<Scalars['String']['input']>;
  /** 설치 상태 */
  installFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 설정값 초기화 여부 */
  resetSettings?: InputMaybe<Scalars['Boolean']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
  /** 최종 보고 상태 */
  status?: InputMaybe<Scalars['String']['input']>;
  /** 마미박스 v3 버전 고정 여부 */
  versionFix?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceListOptions = {
  /** 활성/비활성 필터 */
  activeFlag?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 캡쳐보드 연결 상태 필터 */
  captureDeviceConnected?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 병원 번호 */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 둥둥이/마미톡 산부인과 포함 여부 */
  includePropHospitalFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 테스트, A/S 박스 포함 여부 */
  includeTestHospitalFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 설치/미설치 필터 */
  installFlag?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 배정된 진료실 없는 장비 포함 여부 */
  roomNullFlag?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 장비 버전 필터 */
  version?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeviceNotificationDto = {
  __typename?: 'DeviceNotificationDto';
  /** 바코드 */
  barcode?: Maybe<Scalars['String']['output']>;
  /** 알림 코드 */
  code: Scalars['String']['output'];
  /** 레코드 생성 시간 */
  createdAt: Scalars['DateTime']['output'];
  /** 추가 상세 정보 */
  details?: Maybe<Scalars['JSON']['output']>;
  /** 디바이스 이름 */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** 연결된 디바이스 seq */
  deviceSeq?: Maybe<Scalars['Int']['output']>;
  /** 파일 ID */
  fileId?: Maybe<Scalars['String']['output']>;
  /** 그룹 fingerprint */
  fingerprint: Scalars['String']['output'];
  /** 게이트웨이 역할 */
  gatewayRole: Scalars['String']['output'];
  /** thread grouping context */
  groupContext?: Maybe<Scalars['JSON']['output']>;
  /** 알림 고유번호 */
  id: Scalars['Int']['output'];
  /** 메시지 */
  message: Scalars['String']['output'];
  /** 알림 발생 시간 */
  occurredAt: Scalars['DateTime']['output'];
  /** 원본 payload */
  payload?: Maybe<Scalars['JSON']['output']>;
  /** 원본 타입 */
  rawType?: Maybe<Scalars['String']['output']>;
  /** 알림 심각도 */
  severity: DeviceNotificationSeverity;
  /** Slack error */
  slackError?: Maybe<Scalars['String']['output']>;
  /** Slack message ts */
  slackMessageTs?: Maybe<Scalars['String']['output']>;
  /** Slack permalink */
  slackPermalink?: Maybe<Scalars['String']['output']>;
  /** Slack 전송 상태 */
  slackStatus: DeviceNotificationSlackStatus;
  /** Slack thread ts */
  slackThreadTs?: Maybe<Scalars['String']['output']>;
  /** 이벤트 소스 */
  sourceEvent: Scalars['String']['output'];
  /** 상태 요약 */
  statusSummary: Scalars['String']['output'];
  /** 레코드 수정 시간 */
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceNotificationFilters = {
  /** 코드 필터 */
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Slack 쓰레드 존재 여부 */
  hasThread?: InputMaybe<Scalars['Boolean']['input']>;
  /** 심각도 필터 */
  severities?: InputMaybe<Array<DeviceNotificationSeverity>>;
  /** Slack 상태 필터 */
  slackStatuses?: InputMaybe<Array<DeviceNotificationSlackStatus>>;
};

export type DeviceNotificationListOptions = {
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
};

/** 디바이스 알림의 심각도 */
export enum DeviceNotificationSeverity {
  CRITICAL = 'CRITICAL',
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}

/** 디바이스 알림의 Slack 전송 상태 */
export enum DeviceNotificationSlackStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  ROOT_SENT = 'ROOT_SENT',
  SKIPPED = 'SKIPPED',
  THREAD_SENT = 'THREAD_SENT',
  THRESHOLD_SKIPPED = 'THRESHOLD_SKIPPED'
}

export type DeviceScriptStatusDto = {
  __typename?: 'DeviceScriptStatusDto';
  checksum?: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  scriptName: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type DeviceStateDto = {
  __typename?: 'DeviceStateDto';
  acme?: Maybe<Scalars['JSONObject']['output']>;
  captureBoardStatus?: Maybe<Scalars['String']['output']>;
  captureBoardType?: Maybe<Scalars['String']['output']>;
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  diskUsage?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  isConnected?: Maybe<Scalars['Boolean']['output']>;
  isRecording?: Maybe<Scalars['Boolean']['output']>;
  isUploading?: Maybe<Scalars['Boolean']['output']>;
  scanned?: Maybe<ScannedInfo>;
  screenshot?: Maybe<ScreenshotInfo>;
  socketId?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<DeviceStatsState>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type DeviceStatsState = {
  __typename?: 'DeviceStatsState';
  recording?: Maybe<Scalars['Float']['output']>;
  uploading?: Maybe<Scalars['Float']['output']>;
};

export type DeviceValidationResult = {
  __typename?: 'DeviceValidationResult';
  /** 검증 대상 디바이스명 */
  deviceName: Scalars['String']['output'];
  /** 에러 메시지 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** 중복 여부 */
  isDuplicate: Scalars['Boolean']['output'];
  /** 전체 검증 통과 여부 */
  isValid: Scalars['Boolean']['output'];
};

/** 장비 버전 정보 */
export type DeviceVersionDto = {
  __typename?: 'DeviceVersionDto';
  /** 자동 업데이트 여부 */
  autoUpdate: Scalars['Boolean']['output'];
  /** 빌드 해시 */
  buildHash: Scalars['String']['output'];
  /** 빌드 번호 */
  buildNum: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  seq: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** 버전 릴리즈 일자 */
  versionDate: Scalars['String']['output'];
  /** 버전 요약 */
  versionDescription: Scalars['String']['output'];
  /** 버전 이름 */
  versionName: Scalars['String']['output'];
  /** MDA 에이전트 업데이트 기능 리스트 출력 여부 */
  visibleFlag: Scalars['Boolean']['output'];
};

export type DeviceVersionInfoDto = {
  __typename?: 'DeviceVersionInfoDto';
  checksum: Scalars['String']['output'];
  installedAt: Scalars['String']['output'];
  scriptName: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** 장비 버전 정보 Input */
export type DeviceVersionInput = {
  /** 마미박스 v3 버전 자동 업데이트 여부 */
  autoUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /** 빌드 해시 */
  buildHash?: InputMaybe<Scalars['String']['input']>;
  /** 빌드 번호 */
  buildNum?: InputMaybe<Scalars['Float']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
  /** 버전 릴리즈 일자 */
  versionDate?: InputMaybe<Scalars['String']['input']>;
  /** 버전 요약 */
  versionDescription?: InputMaybe<Scalars['String']['input']>;
  /** 버전 이름 */
  versionName?: InputMaybe<Scalars['String']['input']>;
  /** MDA 에이전트 업데이트 기능 리스트 출력 여부 */
  visibleFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DirectUploadConfigDto = {
  __typename?: 'DirectUploadConfigDto';
  bucket: Scalars['String']['output'];
  credentials: CredentialsDto;
  key: Scalars['String']['output'];
  region: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
};

export type DownloadJobDto = {
  __typename?: 'DownloadJobDto';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedChunks: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deviceName: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  filePath: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  networkQuality?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Int']['output'];
  status: DownloadJobStatus;
  totalChunks?: Maybe<Scalars['Int']['output']>;
  uploadSpeed?: Maybe<Scalars['Int']['output']>;
};

/** 다운로드 작업 상태 */
export enum DownloadJobStatus {
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PREPARING = 'PREPARING',
  UPLOADING = 'UPLOADING'
}

export type ExecResult = {
  __typename?: 'ExecResult';
  affected?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ExecuteScriptInputDto = {
  deviceName: Scalars['String']['input'];
  environmentVars?: InputMaybe<Scalars['String']['input']>;
  scriptName: Scalars['String']['input'];
  timeoutSec?: Scalars['Int']['input'];
};

export type FailedUploadRecoveryDownloadUrlDto = {
  __typename?: 'FailedUploadRecoveryDownloadUrlDto';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export type FailedUploadRecoveryInputDto = {
  barcode: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  recordedAt: Scalars['String']['input'];
};

export type FirstRecordingBarcodeExportInput = {
  /** 조회할 최초 녹화 바코드 */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** 조회 종료일 (YYYY-MM-DD, Asia/Seoul 기준, 해당 일자 포함) */
  endDate: Scalars['String']['input'];
  /** 조회할 병원 seq 목록 */
  hospitalSeqs: Array<Scalars['Int']['input']>;
  /** 조회 시작일 (YYYY-MM-DD, Asia/Seoul 기준) */
  startDate: Scalars['String']['input'];
};

export type FirstRecordingBarcodeExportRow = {
  __typename?: 'FirstRecordingBarcodeExportRow';
  /** 최초 녹화 바코드 */
  barcode: Scalars['String']['output'];
  /** 최초 녹화 병원명 */
  hospitalName: Scalars['String']['output'];
  /** 최초 녹화 병원 seq */
  hospitalSeq: Scalars['Int']['output'];
  /** 최초 녹화 시각 (YYYY-MM-DD HH:mm:ss, Asia/Seoul 기준) */
  recordedAt: Scalars['String']['output'];
  /** 바코드 등록자 이름 */
  userName: Scalars['String']['output'];
  /** 바코드 등록자 전화번호 */
  userPhoneNumber: Scalars['String']['output'];
};

export type FirstRecordingBarcodeMessageSendInput = {
  /** 문자를 보낼 최초 녹화 바코드 목록 */
  barcodes: Array<Scalars['String']['input']>;
  /** 발송할 문자 내용 */
  message: Scalars['String']['input'];
};

export type FirstRecordingBarcodeMessageSendResult = {
  __typename?: 'FirstRecordingBarcodeMessageSendResult';
  /** 발송 실패 건수 */
  failedCount: Scalars['Int']['output'];
  /** 발송 결과 메시지 */
  message?: Maybe<Scalars['String']['output']>;
  /** 요청된 바코드 수 */
  requestedCount: Scalars['Int']['output'];
  /** 발송 성공 건수 */
  sentCount: Scalars['Int']['output'];
  /** 전화번호가 없어 스킵된 건수 */
  skippedCount: Scalars['Int']['output'];
  /** 문자 발송 요청 성공 여부 */
  status: Scalars['Boolean']['output'];
};

export type GetScriptStatusInputDto = {
  deviceName: Scalars['String']['input'];
};

/** Google 시트 캡처 정보 */
export type GoogleSheetCaptureDto = {
  __typename?: 'GoogleSheetCaptureDto';
  /** 바코드 */
  barcode?: Maybe<Scalars['String']['output']>;
  /** 캡쳐 시간 */
  capturedAt?: Maybe<Scalars['String']['output']>;
  /** 업로드 된 시간 */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** 삭제 여부 */
  deleteFlag?: Maybe<Scalars['String']['output']>;
  /** 병원 설명 */
  description?: Maybe<Scalars['String']['output']>;
  /** 장비 이름 */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** 병원명 */
  hospitalName?: Maybe<Scalars['String']['output']>;
  /** 병실명 */
  hospitalRoomName?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
};

export type GoogleSheetDeviceDto = {
  __typename?: 'GoogleSheetDeviceDto';
  /** 장비 활성화 상태 */
  activeFlag?: Maybe<Scalars['String']['output']>;
  /** 캡처 스위치 사용 모드 */
  cfg1_capture_sw_mode?: Maybe<Scalars['String']['output']>;
  /** 최대 녹화 시간 설정 */
  cfg1_max_recording_time?: Maybe<Scalars['String']['output']>;
  /** 모션 임계값 설정 */
  cfg1_motion_threshold?: Maybe<Scalars['String']['output']>;
  /** 녹화 영상 밝기 */
  cfg1_recording_brightness?: Maybe<Scalars['String']['output']>;
  /** 녹음 사운드카드 우선순위 선택 모드 */
  cfg1_recording_card_select_mode?: Maybe<Scalars['String']['output']>;
  /** 녹화 영상 대비 */
  cfg1_recording_contrast?: Maybe<Scalars['String']['output']>;
  /** 초음파 영상 캡처 사용 여부 */
  cfg1_use_diary_capture?: Maybe<Scalars['String']['output']>;
  /** 프린터 사용 여부 */
  cfg1_use_printer_cp1300?: Maybe<Scalars['String']['output']>;
  /** 장비명 */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** 병원명 */
  hospitalName?: Maybe<Scalars['String']['output']>;
  /** 진료실명 */
  hospitalRoomName?: Maybe<Scalars['String']['output']>;
  /** 장비 설치 상태 */
  installFlag?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
  /** 상태 */
  status?: Maybe<Scalars['String']['output']>;
  /** 활동 시간 */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** 버전 */
  version?: Maybe<Scalars['String']['output']>;
};

/** 병원 정보 */
export type GoogleSheetHospitalDto = {
  __typename?: 'GoogleSheetHospitalDto';
  /** 활성화 여부 */
  activeFlag?: Maybe<Scalars['String']['output']>;
  /** 주소 */
  address?: Maybe<Scalars['String']['output']>;
  /** 시 */
  city?: Maybe<Scalars['String']['output']>;
  /** 캡쳐 Viewable 상태 기본값 */
  defaultBlindCapture?: Maybe<Scalars['String']['output']>;
  /** 영상 Viewable 상태 기본값 */
  defaultBlindRecording?: Maybe<Scalars['String']['output']>;
  /** 병원명 */
  hospitalName?: Maybe<Scalars['String']['output']>;
  /** 동영상 이전 서비스 사용 여부 */
  migrationServiceActiveFlag?: Maybe<Scalars['String']['output']>;
  /** 동영상 이전 서비스 제공자 */
  migrationServiceProvider?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
  /** 대표 연락처 */
  telephone?: Maybe<Scalars['String']['output']>;
  /** Libre 사용 여부 */
  useLibreFlag?: Maybe<Scalars['String']['output']>;
  /** NIPT 사용 여부 */
  useNiptFlag?: Maybe<Scalars['String']['output']>;
  /** 원격 진료 사용 여부 */
  useTelemedicineFlag?: Maybe<Scalars['String']['output']>;
};

/** 녹화 정보 */
export type GoogleSheetRecordingDto = {
  __typename?: 'GoogleSheetRecordingDto';
  /** 바코드 */
  barcode?: Maybe<Scalars['String']['output']>;
  /** 업로드 된 시간 */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** 삭제 여부 */
  deleteFlag?: Maybe<Scalars['String']['output']>;
  /** 병원 설명 */
  description?: Maybe<Scalars['String']['output']>;
  /** 장비 이름 */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** 병원명 */
  hospitalName?: Maybe<Scalars['String']['output']>;
  /** 병실명 */
  hospitalRoomName?: Maybe<Scalars['String']['output']>;
  /** net30Flag (30일 이내 업로드 여부) */
  net30Flag?: Maybe<Scalars['String']['output']>;
  /** 녹화 시작 시간 */
  recordedAt?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
  /** 비디오 길이 */
  videoLength?: Maybe<Scalars['String']['output']>;
};

/** 병원 정보 */
export type HospitalDto = {
  __typename?: 'HospitalDto';
  /** 활성화 여부 */
  activeFlag: Scalars['Boolean']['output'];
  /** 전체 주소 */
  address: Scalars['String']['output'];
  /** 시 */
  city: Scalars['String']['output'];
  /** 계약일자 */
  contractDate?: Maybe<Scalars['DateTime']['output']>;
  /** 국가 */
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** CRM 정보 */
  crms?: Maybe<Array<CrmDto>>;
  /** CrystalReveal 사용 모드(운영 US 전용): 0 NONE, 1 BASIC, 2 FULL */
  crystalRevealMode: Scalars['Float']['output'];
  /** 캡쳐 Viewalbe 상태 기본 */
  defaultBlindCapture: Scalars['Boolean']['output'];
  /** 영상 Viewalbe 상태 기본 */
  defaultBlindRecording: Scalars['Boolean']['output'];
  /** 비활성화 일자 */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 병원 주요 지역 */
  description: Scalars['String']['output'];
  /** 마미박스 이상 알림 전용 연락 번호(휴대전화 전용) */
  deviceAlertPhone: Scalars['String']['output'];
  /** 장비 정보 */
  devices?: Maybe<Array<DeviceDto>>;
  /** 병원 홈페이지 주소 */
  homepage?: Maybe<Scalars['String']['output']>;
  /** 병원 로그인 정보 */
  hospitalLogins?: Maybe<Array<HospitalLoginDto>>;
  /** 병원명 */
  hospitalName: Scalars['String']['output'];
  /** 병실 정보 */
  hospitalRooms?: Maybe<Array<HospitalRoomDto>>;
  /** 분만병원 상태 */
  isMaternity: Scalars['Boolean']['output'];
  /** 핑크바코드 적용일 */
  isPinkBarcode?: Maybe<Scalars['DateTime']['output']>;
  /** 위도 */
  lat: Scalars['Float']['output'];
  /** 경도 */
  lng: Scalars['Float']['output'];
  /** 참고사항 */
  memo?: Maybe<Scalars['String']['output']>;
  /** 동영상 이전 서비스 사용 여부 */
  migrationServiceActiveFlag: Scalars['Boolean']['output'];
  /** 동영상 이전 서비스 제공자 */
  migrationServiceProvider: Scalars['String']['output'];
  /** 유료화 시작일 */
  paidBarcodeDate?: Maybe<Scalars['DateTime']['output']>;
  /** 도/주 */
  province: Scalars['String']['output'];
  /** 실제 병원명 */
  realName: Scalars['String']['output'];
  /** 녹음 정보 */
  recordings?: Maybe<Array<RecordingDto>>;
  /** 지역 별칭 */
  regionAlias: Scalars['String']['output'];
  seq: Scalars['Float']['output'];
  /** 영상 송출 정지 여부 */
  streamingStop: Scalars['Boolean']['output'];
  /** 상세 주소 */
  street: Scalars['String']['output'];
  /** 구독 기간 (일수) */
  subscriptionDurationDays?: Maybe<Scalars['Float']['output']>;
  /** 대표 연락처 */
  telephone: Scalars['String']['output'];
  /** 초음파 정보 */
  ultrasoundCaptures?: Maybe<Array<UltrasoundCaptureDto>>;
  updatedAt: Scalars['DateTime']['output'];
  /** 베이비매직 사용 여부 */
  useBabyMagicFlag: Scalars['Boolean']['output'];
  /** QR 결제 사용 여부 */
  useQrPaymentFlag: Scalars['Boolean']['output'];
  /** Libre 사용 여부 */
  useLibreFlag: Scalars['Boolean']['output'];
  /** NIPT 사용 여부 */
  useNiptFlag: Scalars['Boolean']['output'];
  /** 원격 진료 사용 여부 */
  useTelemedicineFlag: Scalars['Boolean']['output'];
  /** 우편번호 */
  zipcode: Scalars['String']['output'];
};

/** 병원 정보 Input */
export type HospitalInput = {
  /** 활성화 여부 */
  activeFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 전체 주소 */
  address?: InputMaybe<Scalars['String']['input']>;
  /** 시 */
  city?: InputMaybe<Scalars['String']['input']>;
  /** 계약일자 */
  contractDate?: InputMaybe<Scalars['String']['input']>;
  /** 국가 */
  country?: InputMaybe<Scalars['String']['input']>;
  /** CrystalReveal 사용 모드(운영 US 전용): 0 NONE, 1 BASIC, 2 FULL */
  crystalRevealMode?: InputMaybe<Scalars['Float']['input']>;
  /** 캡쳐 Viewable 상태 기본 */
  defaultBlindCapture?: InputMaybe<Scalars['Boolean']['input']>;
  /** 영상 Viewable 상태 기본 */
  defaultBlindRecording?: InputMaybe<Scalars['Boolean']['input']>;
  /** 비활성화 일자 */
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  /** 병원 주요 지역 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 마미박스 이상 알림 전용 연락 번호(휴대전화 전용) */
  deviceAlertPhone?: InputMaybe<Scalars['String']['input']>;
  /** 병원 홈페이지 주소 */
  homepage?: InputMaybe<Scalars['String']['input']>;
  /** 병원명 */
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  /** 분만병원 상태 */
  isMaternity?: InputMaybe<Scalars['Boolean']['input']>;
  /** 핑크바코드 적용일 */
  isPinkBarcode?: InputMaybe<Scalars['String']['input']>;
  /** 위도 */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** 경도 */
  lng?: InputMaybe<Scalars['Float']['input']>;
  /** 참고사항 */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** 동영상 이전 서비스 사용 여부 */
  migrationServiceActiveFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 동영상 이전 서비스 제공자 */
  migrationServiceProvider?: InputMaybe<Scalars['String']['input']>;
  /** 유료화 시작일 */
  paidBarcodeDate?: InputMaybe<Scalars['String']['input']>;
  /** 도/주 */
  province?: InputMaybe<Scalars['String']['input']>;
  /** 실제 병원명 */
  realName?: InputMaybe<Scalars['String']['input']>;
  /** 지역 별칭 */
  regionAlias?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
  /** 영상 송출 정지 여부 */
  streamingStop?: InputMaybe<Scalars['Boolean']['input']>;
  /** 상세 주소 */
  street?: InputMaybe<Scalars['String']['input']>;
  /** 구독 기간 (일수) */
  subscriptionDurationDays?: InputMaybe<Scalars['Float']['input']>;
  /** 대표 연락처 */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** 베이비매직 사용 여부 */
  useBabyMagicFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** QR 결제 사용 여부 */
  useQrPaymentFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Libre 사용 여부 */
  useLibreFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** NIPT 사용 여부 */
  useNiptFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 원격 진료 사용 여부 */
  useTelemedicineFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 우편번호 */
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type HospitalListOptions = {
  activeFlag?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  streamingStop?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** 병원 로그인 정보 */
export type HospitalLoginDto = {
  __typename?: 'HospitalLoginDto';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 병원 정보 */
  hospital?: Maybe<HospitalDto>;
  /** 병원 ID */
  hospitalId: Scalars['String']['output'];
  /** 병원 PW */
  hospitalPassword: Scalars['String']['output'];
  /** 병원 seq */
  hospitalSeq: Scalars['Float']['output'];
  /** 병원 로그인 권한 정보 */
  permission: HospitalLoginPermissionDto;
  /** 병원 로그인 권한 seq */
  permissionSeq: Scalars['Float']['output'];
  /** 병원 평문 PW */
  rawPassword: Scalars['String']['output'];
  seq: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** 병원 로그인 정보 Input */
export type HospitalLoginInput = {
  /** 병원 ID */
  hospitalId?: InputMaybe<Scalars['String']['input']>;
  /** 병원 PW */
  hospitalPassword?: InputMaybe<Scalars['String']['input']>;
  /** 병원 seq */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 병원 권한 */
  permission?: InputMaybe<HospitalLoginPermissionInput>;
  /** 병원 평문 PW */
  rawPassword?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
};

/** 병원 로그인 권한 정보 */
export type HospitalLoginPermissionDto = {
  __typename?: 'HospitalLoginPermissionDto';
  createdAt: Scalars['DateTime']['output'];
  /** 장비 열람 권한 */
  device_list: Scalars['Boolean']['output'];
  /** 병원 로그인 seq */
  hospitalLoginSeq: Scalars['Float']['output'];
  /** LIBRE 관리 권한 */
  libre_admin: Scalars['Boolean']['output'];
  /** 진료 기록 관리 권한 */
  medical_record_display: Scalars['Boolean']['output'];
  /** NIPT 관리 권한 */
  nipt_admin: Scalars['Boolean']['output'];
  seq: Scalars['Float']['output'];
  /** 지표 관리 권한 */
  stats_display: Scalars['Boolean']['output'];
  /** 원격 진료 관리 권한 */
  telemedicine_admin: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** 영상 블라인드 권한 */
  video_blind: Scalars['Boolean']['output'];
  /** 영상 상세 검색 권한 */
  video_detail_search: Scalars['Boolean']['output'];
  /** 영상 다운로드 권한 */
  video_download: Scalars['Boolean']['output'];
  /** 영상 재생 권한 */
  video_play: Scalars['Boolean']['output'];
};

/** 병원 로그인 권한 정보 Input */
export type HospitalLoginPermissionInput = {
  /** 장비 열람 권한 */
  device_list?: InputMaybe<Scalars['Boolean']['input']>;
  /** LIBRE 관리 권한 */
  libre_admin?: InputMaybe<Scalars['Boolean']['input']>;
  /** 진료 기록 관리 권한 */
  medical_record_display?: InputMaybe<Scalars['Boolean']['input']>;
  /** NIPT 관리 권한 */
  nipt_admin?: InputMaybe<Scalars['Boolean']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
  /** 지표 관리 권한 */
  stats_display?: InputMaybe<Scalars['Boolean']['input']>;
  /** 원격 진료 관리 권한 */
  telemedicine_admin?: InputMaybe<Scalars['Boolean']['input']>;
  /** 영상 블라인드 권한 */
  video_blind?: InputMaybe<Scalars['Boolean']['input']>;
  /** 영상 상세 검색 권한 */
  video_detail_search?: InputMaybe<Scalars['Boolean']['input']>;
  /** 영상 다운로드 권한 */
  video_download?: InputMaybe<Scalars['Boolean']['input']>;
  /** 영상 재생 권한 */
  video_play?: InputMaybe<Scalars['Boolean']['input']>;
};

/** 진료실 정보 */
export type HospitalRoomDto = {
  __typename?: 'HospitalRoomDto';
  /** 활성화 여부 */
  activeFlag: Scalars['Boolean']['output'];
  /** 장비 목록 */
  devices?: Maybe<Array<DeviceDto>>;
  /** 담당의명 */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** 병원명 */
  hospital?: Maybe<HospitalDto>;
  /** 병원 seq */
  hospitalSeq: Scalars['Float']['output'];
  /** 특이사항 */
  memo?: Maybe<Scalars['String']['output']>;
  /** 진료실명 */
  roomName?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
};

/** 진료실 정보 Input */
export type HospitalRoomInput = {
  /** 사용 여부 */
  activeFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 담당의명 */
  doctorName?: InputMaybe<Scalars['String']['input']>;
  /** 병원 seq */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 특이사항 */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** 진료실명 */
  roomName?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
};

export type HospitalSubscriptionInfoDto = {
  __typename?: 'HospitalSubscriptionInfoDto';
  /** 활성화 상태 */
  activeFlag: Scalars['Boolean']['output'];
  /** 계약일자 */
  contractDate?: Maybe<Scalars['DateTime']['output']>;
  /** 병원명 */
  hospitalName: Scalars['String']['output'];
  /** 병원 시퀀스 */
  hospitalSeq: Scalars['Float']['output'];
  /** 바코드 유료화 시작일 */
  paidBarcodeDate?: Maybe<Scalars['DateTime']['output']>;
  /** 남은 일수 */
  remainingDays: Scalars['Float']['output'];
  /** 구독 기간 (일수) */
  subscriptionDurationDays?: Maybe<Scalars['Float']['output']>;
  /** 구독 만료일 */
  subscriptionEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type HospitalSubscriptionUpdateDto = {
  /** 구독 기간 (일수) */
  subscriptionDurationDays: Scalars['Int']['input'];
};

export type HumangateMemberDto = {
  __typename?: 'HumangateMemberDto';
  /** 바코드 */
  barcode?: Maybe<Scalars['String']['output']>;
  /** 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /** 회원번호 */
  no?: Maybe<Scalars['Int']['output']>;
  /** 전화번호 */
  phone?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Int']['output'];
};

export type HumangateVideolistDto = {
  __typename?: 'HumangateVideolistDto';
  /** 파일 이름 */
  fileName: Scalars['String']['output'];
  /** 파일 크기 */
  fileSize: Scalars['Float']['output'];
  /** 녹화 시간 */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InstallScriptsInputDto = {
  deviceName: Scalars['String']['input'];
  forceUpdate?: Scalars['Boolean']['input'];
};

export type KeycloakCodeInput = {
  /** Keycloak에서 발급한 일회성 Authorization Code */
  code: Scalars['String']['input'];
  /** PKCE code verifier (S256) */
  codeVerifier: Scalars['String']['input'];
  /** Keycloak 로그인 요청 시 사용한 Redirect URI */
  redirectUri: Scalars['String']['input'];
};

export type ListOptions = {
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
};

export type MothersMemberDto = {
  __typename?: 'MothersMemberDto';
  /** 차트번호 */
  mChartNum?: Maybe<Scalars['String']['output']>;
  /** 출산일 */
  mDateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** 이메일 */
  mEmail?: Maybe<Scalars['String']['output']>;
  /** 병원 Idx */
  mHidx?: Maybe<Scalars['Float']['output']>;
  /** 아이디 */
  mId: Scalars['String']['output'];
  mIdx: Scalars['Float']['output'];
  /** 이름 */
  mName?: Maybe<Scalars['String']['output']>;
  /** 닉네임 */
  mNickname?: Maybe<Scalars['String']['output']>;
  /** 전화번호 */
  mPhone?: Maybe<Scalars['String']['output']>;
  /** 가입일 */
  mRegiste?: Maybe<Scalars['DateTime']['output']>;
};

export type MothersVideolistDto = {
  __typename?: 'MothersVideolistDto';
  /** 파일 존재 여부 */
  checked?: Maybe<Scalars['Boolean']['output']>;
  /** 마더스 영상 이전 가능 상태 */
  migrationStatus?: Maybe<Scalars['String']['output']>;
  /** 마더스 영상 이전 가능 상태 메시지 */
  migrationStatusMessage?: Maybe<Scalars['String']['output']>;
  /** 마더스 원본 S3 보관 클래스 */
  s3StorageClass?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
  /** 차트번호 */
  vChartnumber?: Maybe<Scalars['String']['output']>;
  /** 파일 경로 */
  vFilelocation?: Maybe<Scalars['String']['output']>;
  /** 파일 이름 */
  vFilename?: Maybe<Scalars['String']['output']>;
  /** 파일 크기 */
  vFilesize?: Maybe<Scalars['Float']['output']>;
  /** 병원 이름 */
  vHname?: Maybe<Scalars['String']['output']>;
  /** 병원 지역 */
  vLocation?: Maybe<Scalars['String']['output']>;
  /** 원본 차트번호 */
  vOriginChartnumber?: Maybe<Scalars['String']['output']>;
  /** 녹화 시간 */
  vRegiste?: Maybe<Scalars['DateTime']['output']>;
};

/** 모션 정보 */
export type MotionDto = {
  __typename?: 'MotionDto';
  /** 지속 시간 (초) */
  duration?: Maybe<Scalars['Float']['output']>;
  /** 종료 시간 */
  end?: Maybe<Scalars['String']['output']>;
  /** 시작 시간 */
  start?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** DRAFT Crystal Reveal 프롬프트 세트 활성화 */
  activateCrystalRevealPromptSet: CrystalRevealPromptSetDto;
  approveChannelTalkRequest: ChannelTalkRequestActionResult;
  /**
   * 디바이스 일괄 등록
   *
   *     최대 100개까지 일괄 등록 가능
   *
   *     deviceName 중복 체크 및 입력값 검증
   *
   *     부분 실패 시 성공/실패 건수 분리 반환
   */
  batchCreateDevices: BatchCreateResult;
  /** Create multiple special barcode entries and return partial success information. */
  batchCreateSpecialBarcodes: BatchCreateSpecialBarcodesResult;
  /**
   * 시스템 설정 일괄 업데이트
   *
   *     여러 설정을 한 번에 업데이트
   */
  batchUpdateSystemSettings: Array<SystemSettingsDto>;
  /**
   * 초음파 캡쳐 전체 블라인드 설정/해제
   *
   *       @throws RECORDING_NOT_EXISTS -> 해당하는 초음파 영상이 존재하지 않는 경우
   *
   */
  blindUltrasoundCaptures: ExecResult;
  bulkApproveChannelTalkRequests: BulkChannelTalkRequestActionResult;
  /** S3 스토리지 클래스 및 복원 상태 확인 */
  checkS3Class: ExecResult;
  completeChannelTalkRequest: ChannelTalkRequestActionResult;
  /** Create an activity log entry for client-side actions */
  createActivityLog: ExecResult;
  /** 활성 또는 지정 프롬프트 세트를 복사해 DRAFT 생성 */
  createCrystalRevealPromptDraft: CrystalRevealPromptSetDto;
  /** Create a new special barcode entry and optionally blind related recordings. */
  createSpecialBarcode: SpecialBarcodeEntity;
  /**
   * 새 시스템 설정 생성
   *
   *     중복된 settingKey는 불가
   */
  createSystemSetting: SystemSettingsDto;
  /** USB 디바이스 생성 */
  createUsbDevice: UsbDeviceEntity;
  /** 디버깅을 위한 스크립트 직접 실행 (list-directory.py 테스트용) */
  debugListDirectory: ScriptDebugInfoDto;
  /** 스크립트 설치 상태 디버깅 및 강제 설치 */
  debugScriptInstallation: ScriptInstallDebugDto;
  /** CRM 삭제 */
  deleteCrm: ExecResult;
  /** 다운로드 작업 삭제 (소유자만 가능, 완료/실패/만료 상태만 허용) */
  deleteDownload: Scalars['Boolean']['output'];
  /** 병원 로그인 삭제 */
  deleteHospitalLogin: ExecResult;
  /**
   * 시스템 설정 삭제
   *
   *     실제 삭제가 아닌 비활성화 처리
   */
  deleteSystemSetting: Scalars['Boolean']['output'];
  /**
   * 초음파 영상 복제
   *
   *       @throws NOT_EXISTS -> 복제할 초음파 영상 데이터가 존재하지 않을 경우
   *       초음파 영상을 targetBarcode에 복제 (S3, DB)
   *
   */
  duplicateRecording: ExecResult;
  /**
   * 초음파 영상 편집
   *
   *       @throws NOT_EXISTS -> 편집할 초음파 영상 데이터가 존재하지 않을 경우
   *       초음파 영상 길이 편집
   *
   */
  editRecording: ExecResult;
  /** 장비에서 스크립트 실행 */
  executeScript: ScriptExecutionResultDto;
  /** USB 디바이스 목록을 JSON 파일로 Export (장비용) */
  exportUsbListToJson: Scalars['String']['output'];
  googleLogin?: Maybe<TokenResult>;
  /** 장비에 스크립트 설치 또는 업데이트 */
  installScriptsOnDevice: Array<ScriptInstallResultDto>;
  /** 모든 장비의 스크립트 캐시 무효화 */
  invalidateAllScriptCache: Scalars['Boolean']['output'];
  /** 특정 장비의 스크립트 캐시 무효화 (강제 재체크) */
  invalidateScriptCache: Scalars['Boolean']['output'];
  keycloakLoginCallback?: Maybe<TokenResult>;
  keycloakTokenReissue?: Maybe<TokenResult>;
  /** 초음파 영상 다운로드 로그 기록 */
  logRecordingDownload: ExecResult;
  /** 휴먼게이트(휴먼시티)의 영상을 이전 */
  migrateHumangateVideos: ExecResult;
  /** 마더스다이어리의 영상을 이전 */
  migrateMothersVideos: ExecResult;
  /**
   * 초음파 영상 덮어쓰기 등록
   *
   *       @throws NOT_EXISTS -> 덮어쓸 초음파 영상 데이터가 존재하지 않을 경우
   *       덮어쓰기 사유 기록, 영상정보 새로고침
   *
   */
  overwriteRecording: ExecResult;
  refreshChannelTalkRequestCurrentStatus: ChannelTalkRequestCurrentStatusResult;
  /** 초음파 영상 새로고침 */
  refreshRecording: ExecResult;
  rejectChannelTalkRequest: ChannelTalkRequestActionResult;
  /** 원격 조작(쓰기) 실행: delete_paths/clean/restart_process/set_pm2_max_memory/set_volume/patch_* */
  remoteOpsMutate: RemoteOpsResultDto;
  /** 장시간 작업 시작(patch_agent/patch_box/factory_reset 등). 진행상황은 subscription으로 수신 */
  remoteOpsStart: RemoteOpsStartDto;
  /** Delete a special barcode entry and optionally unblind related recordings. */
  removeSpecialBarcode: SpecialBarcodeEntity;
  /** USB 디바이스 삭제 (Soft Delete) */
  removeUsbDevice: Scalars['Boolean']['output'];
  /**
   * 시스템 설정을 기본값으로 복원
   *
   *     defaultValue로 설정 값을 되돌림
   */
  resetSystemSettingToDefault: SystemSettingsDto;
  /** 스크립트 버전 충돌 자동 해결 */
  resolveVersionConflicts: VersionConflictResolutionDto;
  /**
   * S3 아카이브에서 초음파 영상 복원
   *
   *       @throws NOT_EXISTS -> 복원할 초음파 영상 데이터가 존재하지 않을 경우
   *
   *       아카이브된 영상을 복원 요청 (Standard Tier, 3-5시간 소요)
   *
   */
  restoreArchivedRecording: ExecResult;
  /**
   * 편집된 초음파 영상 복원
   *
   *       @throws NOT_EXISTS -> 복원할 초음파 영상 데이터가 존재하지 않을 경우
   *
   */
  restoreRecording: ExecResult;
  /** 스트리밍 종료 영상 복원 실행 */
  restoreStoppedRecordings: StoppedRecordingRestoreResult;
  rollbackChannelTalkRequest: ChannelTalkRequestActionResult;
  sendChannelTalkConversationMessage: ChannelTalkConversationActionResult;
  sendCommand: ExecResult;
  /** 선택한 최초 녹화 바코드 등록자에게 문자 발송 */
  sendFirstRecordingBarcodeMessages: FirstRecordingBarcodeMessageSendResult;
  setCustomCropTemplate: ExecResult;
  sshOrder: ExecResult;
  /** IoT 장비 → S3 직접 업로드 시작 (JWT에서 userSeq 자동 추출) */
  startDirectUpload: StartDirectUploadDto;
  /** 초음파 영상 바코드 이전 */
  transferRecording: ExecResult;
  updateAgent: ExecResult;
  updateBox: ExecResult;
  updateChannelTalkRequestReview: ChannelTalkRequestActionResult;
  /** DRAFT Crystal Reveal 프롬프트 세트 수정 */
  updateCrystalRevealPromptSet: CrystalRevealPromptSetDto;
  /** 디바이스 알림 정책 일괄 수정 */
  updateDeviceAlertPolicies: Array<DeviceAlertPolicy>;
  /** 병원 구독 기간 수정 */
  updateHospitalSubscription: ExecResult;
  /** Update an existing special barcode entry. */
  updateSpecialBarcode: SpecialBarcodeEntity;
  /**
   * 시스템 설정 값 업데이트
   *
   *     데이터 타입과 제약조건에 따른 유효성 검사 수행
   */
  updateSystemSetting: SystemSettingsDto;
  /** 업로드 상태 업데이트 (IoT 장비에서 호출) */
  updateUploadStatus: Scalars['Boolean']['output'];
  /** USB 디바이스 수정 */
  updateUsbDevice: UsbDeviceEntity;
  /**
   * 캡쳐 업로드
   *
   *       바코드와 녹화 영상을 선택하여 캡쳐 이미지를 업로드합니다.
   *
   *       captureFile은 필수 입력이며, base64, data URL, 또는 파일 경로를 지원합니다.
   *
   *       지원 이미지 형식: JPG, JPEG, PNG, GIF, WEBP
   *
   *       fileId는 capturedAt 기준으로 YYYYMMDDHHmmss-${영상fileId}.${확장자} 형식으로 자동 생성됩니다.
   *
   */
  uploadCapture: ExecResult;
  /**
   * CRM 등록/수정 (seq이 없으면 등록, 있으면 수정)
   *
   *       @throws NOT_EXISTS -> 수정할 CRM 데이터가 존재하지 않을 경우
   *
   */
  upsertCrm: ExecResult;
  /**
   * CRM 유형 등록/수정/삭제 (seq이 없으면 등록, 있으면 수정)
   *
   *     @throws NOT_EXISTS -> 수정할 CRM 유형 데이터가 존재하지 않을 경우
   *
   *     activeFlag 이용하여 soft delete
   *
   */
  upsertCrmType: ExecResult;
  /**
   * 장비 등록/수정/삭제 (seq이 없으면 등록, 있으면 수정)
   *
   *     @throws NOT_EXISTS -> 수정할 장비 데이터가 존재하지 않을 경우
   *
   *     activeFlag 이용하여 soft delete
   *
   */
  upsertDevice: ExecResult;
  /**
   * 장비 버전 등록/수정/삭제 (seq이 없으면 등록, 있으면 수정)
   *
   *     @throws NOT_EXISTS -> 수정할 장비 버전 데이터가 존재하지 않을 경우
   *
   *     visibleFlag 이용하여 soft delete
   *
   */
  upsertDeviceVersion: ExecResult;
  /**
   * 병원 등록/수정/삭제 (seq이 없으면 등록, 있으면 수정)
   *
   *     @throws NOT_EXISTS -> 수정할 병원 데이터가 존재하지 않을 경우
   *
   *     activeFlag 이용하여 soft delete
   *
   */
  upsertHospital: ExecResult;
  /**
   * 병원 로그인 등록/수정 (seq이 없으면 등록, 있으면 수정)
   *
   *       @throws NOT_EXISTS -> 수정할 병원 로그인 데이터가 존재하지 않을 경우
   *
   */
  upsertHospitalLogin: ExecResult;
  /**
   * 진료실 등록/수정/삭제 (seq이 없으면 등록, 있으면 수정)
   *
   *     @throws NOT_EXISTS -> 수정할 진료실 데이터가 존재하지 않을 경우
   *
   *     activeFlag 이용하여 soft delete
   *
   */
  upsertHospitalRoom: ExecResult;
  /**
   * 초음파 영상 등록/수정 (seq이 없으면 등록, 있으면 수정)
   *
   *       @throws NOT_EXISTS -> 수정할 초음파 영상 데이터가 존재하지 않을 경우
   *
   *       deleteFlag 이용하여 soft delete
   *
   */
  upsertRecording: ExecResult;
  /**
   * 초음파 캡쳐 메타데이터 등록/수정 (seq이 없으면 등록, 있으면 수정)
   *
   *       신규 등록시 fileId와 s3FileKey가 필수입니다 (S3에 파일이 이미 존재해야 함).
   *
   *       실제 파일 업로드와 함께 생성하려면 uploadCapture 뮤테이션을 사용하세요.
   *
   *       @throws NOT_EXISTS -> 수정할 초음파 캡쳐 데이터가 존재하지 않을 경우
   *
   *       deleteFlag 이용하여 soft delete
   *
   */
  upsertUltrasoundCapture: ExecResult;
  /**
   * 디바이스명 검증
   *
   *     최대 100개까지 일괄 검증 가능
   *
   *     중복 체크, 형식 검증, 길이 검증
   *
   *     각 디바이스명별로 검증 결과 반환
   */
  validateDeviceNames: ValidateDeviceNamesResult;
};


export type MutationActivateCrystalRevealPromptSetArgs = {
  promptSetSeq: Scalars['Int']['input'];
};


export type MutationApproveChannelTalkRequestArgs = {
  sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
  seq: Scalars['Int']['input'];
};


export type MutationBatchCreateDevicesArgs = {
  input: BatchCreateDevicesInput;
};


export type MutationBatchCreateSpecialBarcodesArgs = {
  input: BatchCreateSpecialBarcodesInput;
};


export type MutationBatchUpdateSystemSettingsArgs = {
  input: BatchUpdateSystemSettingsInputDto;
};


export type MutationBlindUltrasoundCapturesArgs = {
  deleteFlag: Scalars['Boolean']['input'];
  recordingSeq: Scalars['Float']['input'];
};


export type MutationBulkApproveChannelTalkRequestsArgs = {
  sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
  seqs: Array<Scalars['Int']['input']>;
};


export type MutationCheckS3ClassArgs = {
  seq: Scalars['Float']['input'];
};


export type MutationCompleteChannelTalkRequestArgs = {
  sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
  seq: Scalars['Int']['input'];
};


export type MutationCreateActivityLogArgs = {
  input: ActivityLogCreateInput;
};


export type MutationCreateCrystalRevealPromptDraftArgs = {
  input: CreateCrystalRevealPromptDraftInputDto;
};


export type MutationCreateSpecialBarcodeArgs = {
  createSpecialBarcodeInput: CreateSpecialBarcodeInput;
};


export type MutationCreateSystemSettingArgs = {
  input: CreateSystemSettingInputDto;
};


export type MutationCreateUsbDeviceArgs = {
  input: CreateUsbDeviceInput;
};


export type MutationDebugListDirectoryArgs = {
  input: GetScriptStatusInputDto;
  path?: Scalars['String']['input'];
};


export type MutationDebugScriptInstallationArgs = {
  input: GetScriptStatusInputDto;
};


export type MutationDeleteCrmArgs = {
  seq: Scalars['Float']['input'];
};


export type MutationDeleteDownloadArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationDeleteHospitalLoginArgs = {
  seq: Scalars['Float']['input'];
};


export type MutationDeleteSystemSettingArgs = {
  settingKey: Scalars['String']['input'];
};


export type MutationDuplicateRecordingArgs = {
  reason: Scalars['String']['input'];
  seq: Scalars['Float']['input'];
  targetBarcode: Scalars['String']['input'];
};


export type MutationEditRecordingArgs = {
  duration: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
  requester?: InputMaybe<Scalars['String']['input']>;
  seq: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
};


export type MutationExecuteScriptArgs = {
  input: ExecuteScriptInputDto;
};


export type MutationExportUsbListToJsonArgs = {
  filePath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGoogleLoginArgs = {
  googleAccessToken: Scalars['String']['input'];
};


export type MutationInstallScriptsOnDeviceArgs = {
  input: InstallScriptsInputDto;
};


export type MutationInvalidateScriptCacheArgs = {
  input: GetScriptStatusInputDto;
};


export type MutationKeycloakLoginCallbackArgs = {
  input: KeycloakCodeInput;
};


export type MutationKeycloakTokenReissueArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationLogRecordingDownloadArgs = {
  reason: Scalars['String']['input'];
  seq: Scalars['Float']['input'];
};


export type MutationMigrateHumangateVideosArgs = {
  barcode: Scalars['String']['input'];
  targetBarcode: Scalars['String']['input'];
  targetHospitalSeq: Scalars['Float']['input'];
};


export type MutationMigrateMothersVideosArgs = {
  targetBarcode: Scalars['String']['input'];
  targetHospitalSeq: Scalars['Float']['input'];
  videoSeqs: Array<Scalars['Float']['input']>;
};


export type MutationOverwriteRecordingArgs = {
  reason: Scalars['String']['input'];
  seq: Scalars['Float']['input'];
};


export type MutationRefreshChannelTalkRequestCurrentStatusArgs = {
  seq: Scalars['Int']['input'];
};


export type MutationRefreshRecordingArgs = {
  seq: Scalars['Float']['input'];
};


export type MutationRejectChannelTalkRequestArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  responseMessage?: InputMaybe<Scalars['String']['input']>;
  sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
  seq: Scalars['Int']['input'];
};


export type MutationRemoteOpsMutateArgs = {
  input: RemoteOpsInputDto;
};


export type MutationRemoteOpsStartArgs = {
  input: RemoteOpsInputDto;
};


export type MutationRemoveSpecialBarcodeArgs = {
  blindRecording?: InputMaybe<Scalars['Boolean']['input']>;
  seq: Scalars['Int']['input'];
};


export type MutationRemoveUsbDeviceArgs = {
  seq: Scalars['Int']['input'];
};


export type MutationResetSystemSettingToDefaultArgs = {
  settingKey: Scalars['String']['input'];
};


export type MutationResolveVersionConflictsArgs = {
  input: GetScriptStatusInputDto;
};


export type MutationRestoreArchivedRecordingArgs = {
  days: Scalars['Int']['input'];
  seq: Scalars['Int']['input'];
};


export type MutationRestoreRecordingArgs = {
  reason: Scalars['String']['input'];
  seq: Scalars['Float']['input'];
};


export type MutationRestoreStoppedRecordingsArgs = {
  input: RestoreStoppedRecordingsInput;
};


export type MutationRollbackChannelTalkRequestArgs = {
  reason: Scalars['String']['input'];
  seq: Scalars['Int']['input'];
};


export type MutationSendChannelTalkConversationMessageArgs = {
  message: Scalars['String']['input'];
  seq: Scalars['Int']['input'];
};


export type MutationSendCommandArgs = {
  acme?: InputMaybe<Scalars['JSON']['input']>;
  command: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
};


export type MutationSendFirstRecordingBarcodeMessagesArgs = {
  input: FirstRecordingBarcodeMessageSendInput;
};


export type MutationSetCustomCropTemplateArgs = {
  h: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};


export type MutationSshOrderArgs = {
  action: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  host: Scalars['String']['input'];
};


export type MutationStartDirectUploadArgs = {
  input: StartDirectUploadInputDto;
};


export type MutationTransferRecordingArgs = {
  reason: Scalars['String']['input'];
  requester?: InputMaybe<Scalars['String']['input']>;
  seq: Scalars['Float']['input'];
  targetBarcode: Scalars['String']['input'];
};


export type MutationUpdateAgentArgs = {
  deviceName: Scalars['String']['input'];
  force: Scalars['Boolean']['input'];
};


export type MutationUpdateBoxArgs = {
  deviceName: Scalars['String']['input'];
  silent?: InputMaybe<Scalars['Boolean']['input']>;
  version: Scalars['String']['input'];
};


export type MutationUpdateChannelTalkRequestReviewArgs = {
  input: UpdateChannelTalkRequestReviewInput;
  seq: Scalars['Int']['input'];
};


export type MutationUpdateCrystalRevealPromptSetArgs = {
  input: UpdateCrystalRevealPromptSetInputDto;
};


export type MutationUpdateDeviceAlertPoliciesArgs = {
  inputs: Array<UpdateDeviceAlertPolicyInput>;
};


export type MutationUpdateHospitalSubscriptionArgs = {
  hospitalSeq: Scalars['Float']['input'];
  updateData: HospitalSubscriptionUpdateDto;
};


export type MutationUpdateSpecialBarcodeArgs = {
  updateSpecialBarcodeInput: UpdateSpecialBarcodeInput;
};


export type MutationUpdateSystemSettingArgs = {
  input: UpdateSystemSettingInputDto;
};


export type MutationUpdateUploadStatusArgs = {
  input: UpdateUploadStatusInputDto;
};


export type MutationUpdateUsbDeviceArgs = {
  input: UpdateUsbDeviceInput;
};


export type MutationUploadCaptureArgs = {
  captureUploadInput: CaptureUploadInput;
  reason: Scalars['String']['input'];
};


export type MutationUpsertCrmArgs = {
  crmUpsert: CrmInput;
};


export type MutationUpsertCrmTypeArgs = {
  crmTypeUpsert: CrmTypeInput;
};


export type MutationUpsertDeviceArgs = {
  deviceUpsert: DeviceInput;
};


export type MutationUpsertDeviceVersionArgs = {
  deviceVersionUpsert: DeviceVersionInput;
};


export type MutationUpsertHospitalArgs = {
  hospitalUpsert: HospitalInput;
};


export type MutationUpsertHospitalLoginArgs = {
  hospitalLoginUpsert: HospitalLoginInput;
};


export type MutationUpsertHospitalRoomArgs = {
  hospitalRoomUpsert: HospitalRoomInput;
};


export type MutationUpsertRecordingArgs = {
  reason: Scalars['String']['input'];
  recordingUpsert: RecordingInput;
};


export type MutationUpsertUltrasoundCaptureArgs = {
  ultrasoundCaptureUpsert: UltrasoundCaptureInput;
};


export type MutationValidateDeviceNamesArgs = {
  deviceNames: Array<Scalars['String']['input']>;
};

/** 페이징 정보가 포함된 접속 로그 리스트 */
export type PaginatedAccessLog = {
  __typename?: 'PaginatedAccessLog';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<AccessLogDto>;
};

/** 페이징 정보가 포함된 작업 로그 리스트 */
export type PaginatedActivityLog = {
  __typename?: 'PaginatedActivityLog';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<ActivityLogDto>;
};

/** 패이징 정보가 포함된 관리자 리스트 */
export type PaginatedAdminUser = {
  __typename?: 'PaginatedAdminUser';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<AdminUserDto>;
};

/** 페이징 정보가 포함된 초음파 영상 리스트 */
export type PaginatedBabyAi = {
  __typename?: 'PaginatedBabyAi';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<BabyAiListDto>;
};

/** 페이징된 채널톡 요청 목록 */
export type PaginatedChannelTalkRequest = {
  __typename?: 'PaginatedChannelTalkRequest';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<ChannelTalkRequest>;
};

/** 페이징 정보가 포함된 CRM 리스트 */
export type PaginatedCrm = {
  __typename?: 'PaginatedCrm';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<CrmDto>;
};

export type PaginatedDevice = {
  __typename?: 'PaginatedDevice';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<DeviceDto>;
};

export type PaginatedDeviceAlertPolicy = {
  __typename?: 'PaginatedDeviceAlertPolicy';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<DeviceAlertPolicy>;
};

export type PaginatedDeviceNotification = {
  __typename?: 'PaginatedDeviceNotification';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<DeviceNotificationDto>;
};

export type PaginatedHospital = {
  __typename?: 'PaginatedHospital';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<HospitalDto>;
};

/** 페이징 정보가 포함된 휴먼게이트(휴먼시티) 회원 리스트 */
export type PaginatedHumangateMember = {
  __typename?: 'PaginatedHumangateMember';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<HumangateMemberDto>;
};

/** 페이징 정보가 포함된 마더스다이어리 회원 리스트 */
export type PaginatedMothersMember = {
  __typename?: 'PaginatedMothersMember';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<MothersMemberDto>;
};

/** 페이징 정보가 포함된 초음파 영상 리스트 */
export type PaginatedRecording = {
  __typename?: 'PaginatedRecording';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<RecordingDto>;
};

export type PaginatedSession = {
  __typename?: 'PaginatedSession';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<SessionDto>;
};

export type PaginatedSpecialBarcodeDto = {
  __typename?: 'PaginatedSpecialBarcodeDto';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<SpecialBarcodeEntity>;
};

/** 스트리밍 종료 영상 복원 이력 페이지네이션 결과 */
export type PaginatedStoppedRecordingRestoreHistory = {
  __typename?: 'PaginatedStoppedRecordingRestoreHistory';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<StoppedRecordingRestoreHistory>;
};

/** 페이징 정보가 포함된 초음파 캡처 리스트 */
export type PaginatedUltrasoundCapture = {
  __typename?: 'PaginatedUltrasoundCapture';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<UltrasoundCaptureDto>;
};

export type PaginatedUpload = {
  __typename?: 'PaginatedUpload';
  /** 페이징 정보 */
  meta: PaginationMeta;
  /** 데이터 리스트 */
  nodes: Array<UploadLogDto>;
};

export type PaginationMeta = {
  __typename?: 'PaginationMeta';
  /** 페이지당 가져올 개수 */
  limit: Scalars['Float']['output'];
  /** 오프셋 값 */
  offset?: Maybe<Scalars['Float']['output']>;
  /** 조회할 페이지 번호 */
  page: Scalars['Float']['output'];
  /** 전체 데이터 수 */
  totalCount: Scalars['Float']['output'];
  /** 전체 페이지 수 */
  totalPage?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** 진행 중인 다운로드만 조회 (브라우저 재시작 시 폴링 복원용) */
  activeDownloads: Array<DownloadJobDto>;
  /**
   * 작업 로그 리스트 조회
   *
   *     createdAt 필터 가능
   */
  activityLogs: Array<ActivityLogDto>;
  /** 관리자 정보 조회 */
  adminUser?: Maybe<TokenResult>;
  /** 서버 인증/로그인 흐름 구성 정보 */
  authFlowInfo: AuthFlowInfo;
  /** 서버에서 사용 가능한 스크립트 목록 조회 */
  availableScripts: Array<ScriptInfoDto>;
  channelTalkConversation: ChannelTalkConversation;
  channelTalkRequests: PaginatedChannelTalkRequest;
  /** 서버와 장비의 스크립트 버전 비교 */
  compareScriptVersions: ScriptVersionComparisonDto;
  /** CRM 유형 리스트 */
  crmTypes: Array<CrmTypeDto>;
  /**
   * CRM 리스트 조회
   *
   *     Crm 생성기간 조회 가능
   */
  crms: Array<CrmDto>;
  /** 활성 Crystal Reveal 프롬프트 세트 조회 */
  crystalRevealActivePromptSet?: Maybe<CrystalRevealPromptSetDto>;
  /** Crystal Reveal 프롬프트 세트 목록 조회 */
  crystalRevealPromptSets: Array<CrystalRevealPromptSetDto>;
  /** 디바이스 알림 정책 목록 조회 */
  deviceAlertPolicies: PaginatedDeviceAlertPolicy;
  /** 디바이스별 알림 리스트 조회 (occurredAt desc 정렬). */
  deviceNotifications: PaginatedDeviceNotification;
  /** 특정 장비에 설치된 스크립트 상태 조회 */
  deviceScriptStatus: Array<DeviceScriptStatusDto>;
  /** 장비에 설치된 스크립트 버전 정보 조회 */
  deviceScriptVersions: Array<DeviceVersionInfoDto>;
  /** 장비 버전 리스트 */
  deviceVersions: Array<DeviceVersionDto>;
  /**
   * 장비 전체 리스트 조회
   *
   *     seq으로 장비 단일 조회 가능
   */
  devices: Array<DeviceDto>;
  /** 특정 다운로드 작업 상태 조회 (폴링용) */
  downloadJob?: Maybe<DownloadJobDto>;
  /**
   * 정상 촬영 실패하여 업로드 되지 못 한 모션 영상 다운로드
   *
   */
  failedUploadRecovery: FailedUploadRecoveryDownloadUrlDto;
  /** 선택한 병원과 KST 기간 내 최초 녹화 바코드 CSV 추출용 데이터 조회 */
  firstRecordingBarcodes: Array<FirstRecordingBarcodeExportRow>;
  /** 모든 베이비매직 이미지 URL 목록 조회 */
  getBabyAiImageUrls: Array<Scalars['String']['output']>;
  getBoxLog: BoxLogDto;
  getCropTemplates: Scalars['JSON']['output'];
  getGoogleSheetCaptures: Array<GoogleSheetCaptureDto>;
  getGoogleSheetDevices: Array<GoogleSheetDeviceDto>;
  getGoogleSheetHospitals: Array<GoogleSheetHospitalDto>;
  getGoogleSheetRecordings: Array<GoogleSheetRecordingDto>;
  /**
   * 휴먼게이트(휴먼시티) 회원 조회
   *
   *     name, phone, barcode 필터 가능
   */
  getHumangateMembers: PaginatedHumangateMember;
  /** 휴먼게이트(휴먼시티) 영상 조회 */
  getHumangateVideos: Array<HumangateVideolistDto>;
  /**
   * 마더스다이어리 회원 조회
   *
   *     hospitalName, actorIdentity, crmStatus, typeName 필터 가능
   */
  getMothersMembers: PaginatedMothersMember;
  /**
   * 마더스다이어리 영상 조회
   *
   *     chartnumber 필터 가능
   */
  getMothersVideos: Array<MothersVideolistDto>;
  /**
   * 초음파 영상 S3 Presigned URL 생성
   *
   *       @throws NOT_EXISTS -> 조회할 초음파 영상 데이터가 존재하지 않을 경우
   *
   */
  getRecordingPresignedUrl: ExecResult;
  /** 테스트 바코드 발급 */
  getTestBarcode: TestBarcodeResult;
  /** 초음파 영상의 캡쳐 조회 */
  getUltrasoundCaptureByRecording: UltrasoundCaptureByRecording;
  /**
   * 병원 로그인 리스트
   *
   *     hospitalSeq으로 병원별 로그인 리스트 조회 가능
   */
  hospitalLogins: Array<HospitalLoginDto>;
  /**
   * 진료실 리스트
   *
   *     hospitalSeq으로 병원별 진료실 리스트 조회 가능
   */
  hospitalRooms: Array<HospitalRoomDto>;
  /** 병원의 구독 정보 조회 */
  hospitalSubscriptionInfo: HospitalSubscriptionInfoDto;
  /**
   * 병원 전체 리스트 조회
   *
   *     seq으로 병원 단일 조회 가능
   */
  hospitals: Array<HospitalDto>;
  /** 사용자별 다운로드 히스토리 조회 (JWT에서 userSeq 자동 추출) */
  myDownloads: Array<DownloadJobDto>;
  /** 페이징 처리된 접속 로그 리스트 조회 */
  paginatedAccessLogs: PaginatedAccessLog;
  /** 페이징 처리된 작업 로그 리스트 조회 */
  paginatedActivityLogs: PaginatedActivityLog;
  /** 관리자 리스트 조회 */
  paginatedAdminUsers: PaginatedAdminUser;
  /**
   * 페이징 처리된 베이비매직 리스트 조회
   *
   *     hospitalSeq, hospitalRoomSeq, visibleFlag 필터 가능
   */
  paginatedBabyAiList: PaginatedBabyAi;
  /**
   * 페이징 처리된 CRM 리스트 조회
   *
   *     hospitalName, actorIdentity, crmStatus, typeName 필터 가능
   */
  paginatedCrms: PaginatedCrm;
  /**
   * 페이징 처리된 장비 리스트 조회
   *
   *     activeFlag, includePropHospitalFlag, roomNullFlag로 장비 조회 시 필터 적용 가능
   */
  paginatedDevices: PaginatedDevice;
  /**
   * 페이징 처리된 병원 리스트 조회
   *
   *     seq, activeFlag, streamingStop으로 병원 조회 시 필터 적용 가능
   */
  paginatedHospitals: PaginatedHospital;
  /**
   * 페이징 처리된 초음파 영상 리스트 조회
   *
   *     fullBarcode, hospitalName, deviceName, recordedAt 필터 가능
   */
  paginatedRecordings: PaginatedRecording;
  /**
   * 페이징 처리된 세션 리스트 조회
   *
   *     status로 세션 조회 시 필터 적용 가능
   */
  paginatedSessions: PaginatedSession;
  /** Get a paginated list of special barcode entries with filtering and sorting. */
  paginatedSpecialBarcodes: PaginatedSpecialBarcodeDto;
  /** 스트리밍 종료 영상 복원 이력 조회 */
  paginatedStoppedRecordingRestoreHistories: PaginatedStoppedRecordingRestoreHistory;
  /**
   * 페이징 처리된 초음파 캡쳐 리스트 조회
   *
   *     barcode, hospitalName, deviceName, capturedAt 필터 가능
   */
  paginatedUltrasoundCaptures: PaginatedUltrasoundCapture;
  /**
   * 페이징 처리된 업로드 리스트 조회
   *
   *     status로 조회 시 필터 적용 가능
   */
  paginatedUploadLogs: PaginatedUpload;
  /**
   * 초음파 영상 리스트 조회
   *
   *     recordedAt 필터 가능
   */
  recordings: Array<RecordingDto>;
  /** 원격 조작(읽기) 실행: list_directory/read_file/download_file/get_disk_usage/get_pm2_list/get_volume/get_usb_status/get_system_info/capabilities/batch_execute */
  remoteOpsQuery: RemoteOpsResultDto;
  /** 장비의 스크립트 캐시 상태 조회 */
  scriptCacheStatus: ScriptCacheStatusDto;
  /** 바코드로 녹화 영상 검색 (캡쳐 업로드용) */
  searchRecordingsByBarcode: Array<RecordingSearchDto>;
  /** Get a single special barcode entry by sequence number. */
  specialBarcode: SpecialBarcodeEntity;
  /** 스트리밍 종료 영상 복원 후보 상세 조회 */
  stoppedRecordingRestoreCandidates: Array<StoppedRecordingRestoreCandidate>;
  /** 스트리밍 종료 영상 병원별 복원 요약 조회 */
  stoppedRecordingRestoreSummary: Array<StoppedRecordingRestoreHospital>;
  /**
   * 특정 시스템 설정 조회
   *
   *     settingKey로 단일 설정 조회
   */
  systemSetting: SystemSettingsDto;
  /**
   * 시스템 설정 값 조회
   *
   *     settingKey로 설정 값만 반환 (value가 없으면 defaultValue 반환)
   */
  systemSettingValue?: Maybe<Scalars['String']['output']>;
  /**
   * 모든 시스템 설정 조회
   *
   *     활성화된 설정들만 반환
   */
  systemSettings: Array<SystemSettingsDto>;
  /** 자동 녹화 테스트 */
  testAutoRecording: ExecResult;
  /**
   * 초음파 캡쳐 리스트 조회
   *
   *     capturedAt 필터 가능(기간이 없으면 금월을 기간으로 조회, 기간은 한달로 제한)
   *
   */
  ultrasoundCaptures: Array<UltrasoundCaptureDto>;
  /** 초음파 캡쳐 리스트 조회 by recording seq */
  ultrasoundCapturesByRecordingSeq: Array<UltrasoundCaptureDto>;
  /** USB 디바이스 단건 조회 (seq) */
  usbDevice: UsbDeviceEntity;
  /** VID/PID로 USB 디바이스 조회 */
  usbDeviceByVidPid?: Maybe<UsbDeviceEntity>;
  /** USB 디바이스 목록 조회 (필터 옵션) */
  usbDevices: Array<UsbDeviceEntity>;
};


export type QueryActivityLogsArgs = {
  searchDateInput?: InputMaybe<SearchDateInput>;
};


export type QueryAdminUserArgs = {
  userPassword: Scalars['String']['input'];
};


export type QueryChannelTalkConversationArgs = {
  seq: Scalars['Int']['input'];
};


export type QueryChannelTalkRequestsArgs = {
  listOptions: ChannelTalkRequestFilter;
};


export type QueryCompareScriptVersionsArgs = {
  input: GetScriptStatusInputDto;
};


export type QueryCrmsArgs = {
  searchOptions?: InputMaybe<SearchDateInput>;
};


export type QueryDeviceAlertPoliciesArgs = {
  filters?: InputMaybe<DeviceAlertPolicyFilters>;
  listOptions: DeviceAlertPolicyListOptions;
};


export type QueryDeviceNotificationsArgs = {
  date: Scalars['DateTime']['input'];
  deviceName: Scalars['String']['input'];
  filters?: InputMaybe<DeviceNotificationFilters>;
  listOptions: DeviceNotificationListOptions;
};


export type QueryDeviceScriptStatusArgs = {
  input: GetScriptStatusInputDto;
};


export type QueryDeviceScriptVersionsArgs = {
  input: GetScriptStatusInputDto;
};


export type QueryDevicesArgs = {
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryDownloadJobArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryFailedUploadRecoveryArgs = {
  failedUploadRecoveryInputDto: FailedUploadRecoveryInputDto;
};


export type QueryFirstRecordingBarcodesArgs = {
  input: FirstRecordingBarcodeExportInput;
};


export type QueryGetBoxLogArgs = {
  date: Scalars['DateTime']['input'];
  deviceName: Scalars['String']['input'];
};


export type QueryGetHumangateMembersArgs = {
  listOptions: ListOptions;
};


export type QueryGetHumangateVideosArgs = {
  barcode: Scalars['String']['input'];
};


export type QueryGetMothersMembersArgs = {
  listOptions: ListOptions;
};


export type QueryGetMothersVideosArgs = {
  chartnumber: Scalars['String']['input'];
};


export type QueryGetRecordingPresignedUrlArgs = {
  seq: Scalars['Float']['input'];
};


export type QueryGetTestBarcodeArgs = {
  countryCode: Scalars['String']['input'];
  hospitalSeq: Scalars['Float']['input'];
  recordedAt: Scalars['String']['input'];
};


export type QueryGetUltrasoundCaptureByRecordingArgs = {
  seq: Scalars['Float']['input'];
};


export type QueryHospitalLoginsArgs = {
  hospitalSeq: Scalars['Float']['input'];
};


export type QueryHospitalRoomsArgs = {
  hospitalSeq: Scalars['Float']['input'];
  withInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHospitalSubscriptionInfoArgs = {
  hospitalSeq: Scalars['Float']['input'];
};


export type QueryHospitalsArgs = {
  seq?: InputMaybe<Scalars['Float']['input']>;
  withInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyDownloadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DownloadJobStatus>;
};


export type QueryPaginatedAccessLogsArgs = {
  listOptions: AccessLogListOptions;
};


export type QueryPaginatedActivityLogsArgs = {
  listOptions: ActivityLogListOptions;
};


export type QueryPaginatedAdminUsersArgs = {
  listOptions: AdminUserListOptions;
};


export type QueryPaginatedBabyAiListArgs = {
  listOptions: BabyAiListOptions;
};


export type QueryPaginatedCrmsArgs = {
  listOptions: CrmListOptions;
};


export type QueryPaginatedDevicesArgs = {
  listOptions: DeviceListOptions;
};


export type QueryPaginatedHospitalsArgs = {
  listOptions: HospitalListOptions;
};


export type QueryPaginatedRecordingsArgs = {
  listOptions: RecordingListOptions;
};


export type QueryPaginatedSessionsArgs = {
  listOptions: SessionListOptions;
};


export type QueryPaginatedSpecialBarcodesArgs = {
  listOptions?: InputMaybe<SpecialBarcodeListOptions>;
};


export type QueryPaginatedStoppedRecordingRestoreHistoriesArgs = {
  listOptions: StoppedRecordingRestoreHistoryListOptions;
};


export type QueryPaginatedUltrasoundCapturesArgs = {
  listOptions: UltrasoundCaptureListOptions;
};


export type QueryPaginatedUploadLogsArgs = {
  listOptions: UploadListOptions;
};


export type QueryRecordingsArgs = {
  searchDateInput: SearchDateInput;
};


export type QueryRemoteOpsQueryArgs = {
  input: RemoteOpsInputDto;
};


export type QueryScriptCacheStatusArgs = {
  input: GetScriptStatusInputDto;
};


export type QuerySearchRecordingsByBarcodeArgs = {
  barcode: Scalars['String']['input'];
};


export type QuerySpecialBarcodeArgs = {
  seq: Scalars['Int']['input'];
};


export type QueryStoppedRecordingRestoreCandidatesArgs = {
  barcode: Scalars['String']['input'];
  hospitalSeq: Scalars['Int']['input'];
};


export type QueryStoppedRecordingRestoreSummaryArgs = {
  barcode: Scalars['String']['input'];
};


export type QuerySystemSettingArgs = {
  settingKey: Scalars['String']['input'];
};


export type QuerySystemSettingValueArgs = {
  settingKey: Scalars['String']['input'];
};


export type QueryTestAutoRecordingArgs = {
  barcode: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
};


export type QueryUltrasoundCapturesArgs = {
  searchDateInput: SearchDateInput;
};


export type QueryUltrasoundCapturesByRecordingSeqArgs = {
  recordingSeq: Scalars['Float']['input'];
};


export type QueryUsbDeviceArgs = {
  seq: Scalars['Int']['input'];
};


export type QueryUsbDeviceByVidPidArgs = {
  pid: Scalars['Int']['input'];
  vid: Scalars['Int']['input'];
};


export type QueryUsbDevicesArgs = {
  filter?: InputMaybe<UsbDeviceFilterInput>;
};

/** 녹화 정보 */
export type RecordDto = {
  __typename?: 'RecordDto';
  /** 지속 시간 (초) */
  duration?: Maybe<Scalars['Float']['output']>;
  /** 종료 시간 */
  end?: Maybe<Scalars['String']['output']>;
  /** 시작 시간 */
  start?: Maybe<Scalars['String']['output']>;
};

/** 초음파 영상 정보 */
export type RecordingDto = {
  __typename?: 'RecordingDto';
  /** 9자리 바코드 번호(체크섬 제외) */
  barcode?: Maybe<Scalars['Float']['output']>;
  /** 캡쳐 수 */
  captureCount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 블라인드 처리 여부 */
  deleteFlag?: Maybe<Scalars['Boolean']['output']>;
  /** 장비 정보 */
  device?: Maybe<DeviceDto>;
  /** 장비 seq */
  deviceSeq?: Maybe<Scalars['Float']['output']>;
  /** 파일명 */
  fileId?: Maybe<Scalars['String']['output']>;
  /** 전체 바코드 번호 */
  fullBarcode?: Maybe<Scalars['String']['output']>;
  /** 병원 정보 */
  hospital?: Maybe<HospitalDto>;
  /** 병실 정보 */
  hospitalRoom?: Maybe<HospitalRoomDto>;
  /** 진료실 seq */
  hospitalRoomSeq?: Maybe<Scalars['Float']['output']>;
  /** 병원 seq */
  hospitalSeq?: Maybe<Scalars['Float']['output']>;
  /** 최근 복원 이력 (1건) */
  latestRestoreHistory?: Maybe<RecordingRestoreHistoryDto>;
  /** 미국 집계 net 30 여부 */
  net30Flag?: Maybe<Scalars['Boolean']['output']>;
  /** 환자 ID */
  patientId?: Maybe<Scalars['String']['output']>;
  /** 녹화 시작 시각 */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 초음파 영상 URL */
  recordingUrl?: Maybe<Scalars['String']['output']>;
  /** 촬영 해상도 */
  resolution?: Maybe<Scalars['String']['output']>;
  /** 전체 복원 이력 (최근 10건) */
  restoreHistories?: Maybe<Array<RecordingRestoreHistoryDto>>;
  /** S3 버킷 이름 */
  s3Bucket?: Maybe<Scalars['String']['output']>;
  /** S3 스토리지 클래스 (STANDARD, GLACIER, DEEP_ARCHIVE 등) */
  s3Class?: Maybe<Scalars['String']['output']>;
  /** S3 파일 키 이름 */
  s3FileKey?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
  /** 해외 초음파 영상 Signed URL */
  signedRecordingUrl?: Maybe<Scalars['String']['output']>;
  /** 해외 초음파 영상 썸네일 Signed URL */
  signedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** 스트리밍 상태 (AVAILABLE, ARCHIVED, RESTORING, RESTORED) */
  streamingStatus?: Maybe<Scalars['String']['output']>;
  /** 초음파 영상 썸네일 URL */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** 총 복원 요청 횟수 */
  totalRestoreCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** 비디오 길이 */
  videoLength?: Maybe<Scalars['Float']['output']>;
};

export type RecordingInput = {
  /** 9자리 바코드 번호(체크섬 제외) */
  barcode?: InputMaybe<Scalars['Float']['input']>;
  /** 블라인드 처리 여부 */
  deleteFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 장비 seq */
  deviceSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 파일명 */
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** 전체 바코드 번호 */
  fullBarcode?: InputMaybe<Scalars['String']['input']>;
  /** 진료실 seq */
  hospitalRoomSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 병원 seq */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 녹화 시작 시각 */
  recordedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** 촬영 해상도 */
  resolution?: InputMaybe<Scalars['String']['input']>;
  /** S3 버킷 이름 */
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  /** s3 파일 키 이름 */
  s3FileKey?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
  /** 비디오 길이 */
  videoLength?: InputMaybe<Scalars['Float']['input']>;
};

export type RecordingListOptions = {
  /** 공개/비공개 여부 */
  deleteFlag?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 병원 번호 */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 둥둥이/마미톡 산부인과 포함 여부 */
  includePropHospitalFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 환자 ID 정확히 검색 */
  patientId?: InputMaybe<Scalars['String']['input']>;
  /** 녹화시각 */
  recordedAt?: InputMaybe<SearchDateInput>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
};

export type RecordingRestoreHistoryDto = {
  __typename?: 'RecordingRestoreHistoryDto';
  /** 국가 코드 */
  countryCode: Scalars['String']['output'];
  /** 녹화물 시퀀스 */
  recordingSeq: Scalars['Int']['output'];
  /** 요청 출처 (API/ADMIN/BATCH) */
  requestSource?: Maybe<Scalars['String']['output']>;
  /** 복원 만료 예정 시간 */
  restoreExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** 복원 요청 시간 */
  restoreRequestedAt: Scalars['DateTime']['output'];
  /** 요청한 복원 유지 일수 */
  restoreRequestedDays: Scalars['Int']['output'];
  /** 복원 속도 티어 */
  restoreTier?: Maybe<RestoreTier>;
  /** 복원 완료가 감지된 시간 */
  restoredDetectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 히스토리 고유 ID */
  seq: Scalars['Int']['output'];
  /** 복원 상태 */
  status: RestoreStatus;
};

/** 바코드 검색용 녹화 정보 */
export type RecordingSearchDto = {
  __typename?: 'RecordingSearchDto';
  /** 장비 seq */
  deviceSeq: Scalars['Float']['output'];
  /** 파일명 */
  fileId?: Maybe<Scalars['String']['output']>;
  /** 병원명 */
  hospitalName: Scalars['String']['output'];
  /** 병실명 */
  hospitalRoomName: Scalars['String']['output'];
  /** 병실 seq */
  hospitalRoomSeq: Scalars['Float']['output'];
  /** 병원 seq */
  hospitalSeq: Scalars['Float']['output'];
  /** 녹화 시간 */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  seq: Scalars['Float']['output'];
  /** 비디오 길이 (초) */
  videoLength?: Maybe<Scalars['Float']['output']>;
};

export type RemoteConfigInputDto = {
  paths?: InputMaybe<RemotePathsConfigInputDto>;
};

export type RemoteLimitsInputDto = {
  maxOutputBytes?: InputMaybe<Scalars['Float']['input']>;
  timeoutSec?: InputMaybe<Scalars['Float']['input']>;
};

export type RemoteLogEntryDto = {
  __typename?: 'RemoteLogEntryDto';
  exitCode?: Maybe<Scalars['Int']['output']>;
  stderr?: Maybe<Scalars['String']['output']>;
  stdout?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export type RemoteOpsInputDto = {
  config?: InputMaybe<RemoteConfigInputDto>;
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  deviceName: Scalars['String']['input'];
  env?: InputMaybe<Scalars['JSONObject']['input']>;
  limits?: InputMaybe<RemoteLimitsInputDto>;
  op: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSONObject']['input']>;
  ssh?: InputMaybe<RemoteSshInputDto>;
  sshCommand?: InputMaybe<Scalars['String']['input']>;
};

export type RemoteOpsProgressEventDto = {
  __typename?: 'RemoteOpsProgressEventDto';
  done?: Maybe<Scalars['Boolean']['output']>;
  exitCode?: Maybe<Scalars['Int']['output']>;
  opId: Scalars['String']['output'];
  result?: Maybe<Scalars['JSONObject']['output']>;
  stderr?: Maybe<Scalars['String']['output']>;
  stdout?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export type RemoteOpsResultDto = {
  __typename?: 'RemoteOpsResultDto';
  data?: Maybe<Scalars['JSONObject']['output']>;
  deviceName: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  error?: Maybe<Scalars['JSONObject']['output']>;
  logs: Array<RemoteLogEntryDto>;
  op: Scalars['String']['output'];
  status: RemoteStatus;
  summary: Scalars['String']['output'];
  truncated?: Maybe<Scalars['JSONObject']['output']>;
};

export type RemoteOpsStartDto = {
  __typename?: 'RemoteOpsStartDto';
  opId: Scalars['String']['output'];
};

export type RemotePathsConfigInputDto = {
  agentDir?: InputMaybe<Scalars['String']['input']>;
  appDir?: InputMaybe<Scalars['String']['input']>;
  logsDirs?: InputMaybe<Array<Scalars['String']['input']>>;
  trashDirs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RemoteSshInputDto = {
  host?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  port?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export enum RemoteStatus {
  ERROR = 'ERROR',
  OK = 'OK'
}

export enum RestoreStatus {
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  REQUESTED = 'REQUESTED',
  RESTORED = 'RESTORED',
  RESTORING = 'RESTORING'
}

export type RestoreStoppedRecordingsInput = {
  /** 11자리 전체 바코드 */
  barcode: Scalars['String']['input'];
  /** 병원 seq */
  hospitalSeq: Scalars['Int']['input'];
  /** 복원 사유 */
  reason: Scalars['String']['input'];
  /** 선택 복원할 recording seq 목록. 비어 있으면 병원 전체 복원 */
  recordingSeqs?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum RestoreTier {
  Bulk = 'Bulk',
  Expedited = 'Expedited',
  Standard = 'Standard'
}

/** 스캔 정보 */
export type ScanDto = {
  __typename?: 'ScanDto';
  /** 스캔 정보 */
  scanned?: Maybe<Scalars['String']['output']>;
  /** 스캔 시간 */
  scannedAt?: Maybe<Scalars['String']['output']>;
};

export type ScannedInfo = {
  __typename?: 'ScannedInfo';
  text?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type ScreenshotInfo = {
  __typename?: 'ScreenshotInfo';
  base64Data?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
};

export type ScriptCacheStatusDto = {
  __typename?: 'ScriptCacheStatusDto';
  allUpToDate: Scalars['Boolean']['output'];
  cacheAgeHours?: Maybe<Scalars['Int']['output']>;
  cached: Scalars['Boolean']['output'];
  deviceName: Scalars['String']['output'];
  lastChecked?: Maybe<Scalars['String']['output']>;
  scriptCount: Scalars['Int']['output'];
};

export type ScriptDebugInfoDto = {
  __typename?: 'ScriptDebugInfoDto';
  environmentVars: Array<Scalars['String']['output']>;
  executionTimeMs: Scalars['Float']['output'];
  exitCode: Scalars['Int']['output'];
  scriptName: Scalars['String']['output'];
  stderr: Scalars['String']['output'];
  stdout: Scalars['String']['output'];
};

export type ScriptExecutionResultDto = {
  __typename?: 'ScriptExecutionResultDto';
  exitCode: Scalars['Int']['output'];
  stderr: Scalars['String']['output'];
  stdout: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ScriptInfoDto = {
  __typename?: 'ScriptInfoDto';
  checksum: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  executable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ScriptInstallDebugDto = {
  __typename?: 'ScriptInstallDebugDto';
  deviceName: Scalars['String']['output'];
  directoryExists: Scalars['Boolean']['output'];
  installCommand: Scalars['String']['output'];
  installError: Scalars['String']['output'];
  installOutput: Scalars['String']['output'];
  installedFiles: Array<Scalars['String']['output']>;
  totalScriptsAvailable: Scalars['Int']['output'];
};

export type ScriptInstallResultDto = {
  __typename?: 'ScriptInstallResultDto';
  error?: Maybe<Scalars['String']['output']>;
  installed: Scalars['Boolean']['output'];
  scriptName: Scalars['String']['output'];
  updated: Scalars['Boolean']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type ScriptVersionComparisonDto = {
  __typename?: 'ScriptVersionComparisonDto';
  deviceOnly: Array<Scalars['String']['output']>;
  needsUpdate: Array<Scalars['String']['output']>;
  serverOnly: Array<Scalars['String']['output']>;
  upToDate: Array<Scalars['String']['output']>;
};

export type SearchDateInput = {
  /** 종료일 */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** 시작일 */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type SessionDto = {
  __typename?: 'SessionDto';
  barcode: Scalars['String']['output'];
  captureCount: Scalars['Float']['output'];
  /** 장비 정보 */
  device?: Maybe<DeviceDto>;
  deviceSeq: Scalars['Float']['output'];
  fileId: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  hospital?: Maybe<HospitalDto>;
  hospitalRoom?: Maybe<HospitalRoomDto>;
  motionPassedAt?: Maybe<Scalars['DateTime']['output']>;
  recordingCount: Scalars['Float']['output'];
  scanned?: Maybe<Array<Scalars['JSONObject']['output']>>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  stoppedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SessionListOptions = {
  /** 병원 번호 */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 작업시각 */
  scannedAt?: InputMaybe<SearchDateInput>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 세션 상태 필터 */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** 마미박스 세션 로그 */
export type SessionLogDto = {
  __typename?: 'SessionLogDto';
  /** 바코드 */
  barcode?: Maybe<Scalars['String']['output']>;
  /** 파일 ID */
  fileId?: Maybe<Scalars['String']['output']>;
  /** 모션 정보 */
  motion?: Maybe<MotionDto>;
  /** 녹화 정보 */
  record?: Maybe<Array<RecordDto>>;
  /** 스캔 정보 */
  scan?: Maybe<Array<ScanDto>>;
  /** 분할 */
  segment?: Maybe<Scalars['Float']['output']>;
  /** 바코드 스캔 시간 */
  startedAt?: Maybe<Scalars['String']['output']>;
  /** 업로드 정보 */
  upload?: Maybe<UploadDto>;
};

/** 공통 목록 조회 정렬 방향 */
export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
  ascend = 'ascend',
  descend = 'descend'
}

export type SpecialBarcodeEntity = {
  __typename?: 'SpecialBarcodeEntity';
  barcode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SpecialBarcodeListOptions = {
  /** Filter by barcode (partial match) */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by reason (partial match) */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** Filter by barcode types */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartDirectUploadDto = {
  __typename?: 'StartDirectUploadDto';
  estimatedDurationMin: Scalars['Int']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  jobId: Scalars['String']['output'];
  recommendedChunkSize: Scalars['Int']['output'];
  s3Config: DirectUploadConfigDto;
};

export type StartDirectUploadInputDto = {
  deviceName: Scalars['String']['input'];
  expectedFileSize?: InputMaybe<Scalars['Int']['input']>;
  filePath: Scalars['String']['input'];
  ttlHours?: InputMaybe<Scalars['Int']['input']>;
};

/** 스트리밍 종료 영상 복원 후보 상세 */
export type StoppedRecordingRestoreCandidate = {
  __typename?: 'StoppedRecordingRestoreCandidate';
  currentS3FileKey?: Maybe<Scalars['String']['output']>;
  expectedS3FileKey?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fullBarcode?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  restorable: Scalars['Boolean']['output'];
  seq: Scalars['Int']['output'];
};

/** 스트리밍 종료 영상 복원 실패 항목 */
export type StoppedRecordingRestoreFailedItem = {
  __typename?: 'StoppedRecordingRestoreFailedItem';
  fileId?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
};

/** 스트리밍 종료 영상 복원 이력 */
export type StoppedRecordingRestoreHistory = {
  __typename?: 'StoppedRecordingRestoreHistory';
  actorIdentity: Scalars['String']['output'];
  barcode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  failedCount: Scalars['Int']['output'];
  hospitalName?: Maybe<Scalars['String']['output']>;
  hospitalSeq: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  recordings: Array<StoppedRecordingRestoreHistoryRecording>;
  requestedCount: Scalars['Int']['output'];
  restoredCount: Scalars['Int']['output'];
  seq: Scalars['Int']['output'];
};

export type StoppedRecordingRestoreHistoryListOptions = {
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
};

/** 스트리밍 종료 영상 복원 이력 내 개별 영상 정보 */
export type StoppedRecordingRestoreHistoryRecording = {
  __typename?: 'StoppedRecordingRestoreHistoryRecording';
  failureReason?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fromS3FileKey?: Maybe<Scalars['String']['output']>;
  fullBarcode?: Maybe<Scalars['String']['output']>;
  recordingSeq: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  toS3FileKey?: Maybe<Scalars['String']['output']>;
};

/** 바코드 기준 스트리밍 종료 영상 병원별 요약 */
export type StoppedRecordingRestoreHospital = {
  __typename?: 'StoppedRecordingRestoreHospital';
  disabledCount: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  hospitalSeq: Scalars['Int']['output'];
  restorableCount: Scalars['Int']['output'];
  unrestorableCount: Scalars['Int']['output'];
};

/** 스트리밍 종료 영상 복원 실행 결과 */
export type StoppedRecordingRestoreResult = {
  __typename?: 'StoppedRecordingRestoreResult';
  failedCount: Scalars['Int']['output'];
  failedItems: Array<StoppedRecordingRestoreFailedItem>;
  message?: Maybe<Scalars['String']['output']>;
  requestedCount: Scalars['Int']['output'];
  restoredCount: Scalars['Int']['output'];
  status: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** 장비 상태 변경 실시간 구독 (Redis pub/sub 기반) */
  deviceUpdate: DeviceDto;
  /** 원격 조작 진행 상황 스트림 */
  remoteOpsProgress: RemoteOpsProgressEventDto;
};


export type SubscriptionDeviceUpdateArgs = {
  hospitalSeq: Scalars['Float']['input'];
};


export type SubscriptionRemoteOpsProgressArgs = {
  opId: Scalars['String']['input'];
};

export enum SystemSettingDataType {
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  JSON = 'JSON',
  NUMBER = 'NUMBER',
  STRING = 'STRING'
}

/** 시스템 설정 */
export type SystemSettingsDto = {
  __typename?: 'SystemSettingsDto';
  /** 선택 가능한 값들(배열/문자열/객체 허용) */
  availableValues?: Maybe<Scalars['JSON']['output']>;
  /** 제약조건 {min, max, regex, options 등} */
  constraints?: Maybe<Scalars['JSON']['output']>;
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output'];
  /** 데이터 타입 */
  dataType: SystemSettingDataType;
  /** 기본값 */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** 설정 설명 */
  description?: Maybe<Scalars['String']['output']>;
  /** 표시 순서 */
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** 활성화 여부 */
  isActive: Scalars['Boolean']['output'];
  /** 필수 여부 */
  isRequired: Scalars['Boolean']['output'];
  /** 설정 키 */
  settingKey: Scalars['String']['output'];
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output'];
  /** 수정자 */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** 현재 설정값 */
  value?: Maybe<Scalars['String']['output']>;
};

export type TestBarcodeResult = {
  __typename?: 'TestBarcodeResult';
  barcode?: Maybe<Scalars['String']['output']>;
};

export type TokenResult = {
  __typename?: 'TokenResult';
  accessToken?: Maybe<Scalars['String']['output']>;
  affected?: Maybe<Scalars['Float']['output']>;
  enabledFlag: Scalars['Boolean']['output'];
  groups?: Maybe<Array<Scalars['String']['output']>>;
  idToken?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  seq: Scalars['ID']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  superFlag: Scalars['Boolean']['output'];
  userDisplayName: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

/** 초음파 영상별 캡쳐 조회 */
export type UltrasoundCaptureByRecording = {
  __typename?: 'UltrasoundCaptureByRecording';
  /** 캡쳐 정보 */
  captures?: Maybe<Array<UltrasoundCaptureDto>>;
  /** 캡쳐 수 */
  count: Scalars['Float']['output'];
};

/** 초음파 캡처 정보 */
export type UltrasoundCaptureDto = {
  __typename?: 'UltrasoundCaptureDto';
  /** 전체 바코드 번호 */
  barcode?: Maybe<Scalars['String']['output']>;
  /** 초음파 캡처 URL */
  captureUrl?: Maybe<Scalars['String']['output']>;
  /** 촬영 시각 */
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 삭제 여부 */
  deleteFlag?: Maybe<Scalars['Boolean']['output']>;
  /** 장비 정보 */
  device?: Maybe<DeviceDto>;
  /** 장비 seq */
  deviceSeq?: Maybe<Scalars['Float']['output']>;
  /** 추적 파일명 */
  fileId?: Maybe<Scalars['String']['output']>;
  /** 병원 정보 */
  hospital?: Maybe<HospitalDto>;
  /** 병실 정보 */
  hospitalRoom?: Maybe<HospitalRoomDto>;
  /** 진료실 seq */
  hospitalRoomSeq?: Maybe<Scalars['Float']['output']>;
  /** 병원 seq */
  hospitalSeq?: Maybe<Scalars['Float']['output']>;
  /** 환자 ID */
  patientId?: Maybe<Scalars['String']['output']>;
  /** S3 버킷 이름 */
  s3Bucket?: Maybe<Scalars['String']['output']>;
  /** S3 파일 키 이름 */
  s3FileKey?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Float']['output'];
  /** 해외 초음파 캡처 Signed URL */
  signedCaptureUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** 초음파 캡처 정보 Input */
export type UltrasoundCaptureInput = {
  /** 전체 바코드 번호 */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** 촬영 시각 */
  capturedAt?: InputMaybe<Scalars['String']['input']>;
  /** 삭제 여부 */
  deleteFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 장비 seq */
  deviceSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 추적 파일명 */
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** 진료실 seq */
  hospitalRoomSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 병원 seq */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** S3 버킷 이름 */
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  /** s3 파일 키 이름 */
  s3FileKey?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Float']['input']>;
};

export type UltrasoundCaptureListOptions = {
  /** 캡쳐 시각 */
  capturedAt?: InputMaybe<SearchDateInput>;
  /** 공개/비공개 여부 */
  deleteFlag?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 병원 번호 */
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
  /** 둥둥이/마미톡 산부인과 포함 여부 */
  includePropHospitalFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 환자 ID 정확히 검색 */
  patientId?: InputMaybe<Scalars['String']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
};

export type UpdateChannelTalkRequestReviewInput = {
  editDuration?: InputMaybe<Scalars['String']['input']>;
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  hospitalRoomName?: InputMaybe<Scalars['String']['input']>;
  hospitalRoomSeq?: InputMaybe<Scalars['Int']['input']>;
  hospitalSeq?: InputMaybe<Scalars['Int']['input']>;
  recordedAt?: InputMaybe<Scalars['String']['input']>;
  recordingSeq?: InputMaybe<Scalars['Int']['input']>;
  sourceBarcode?: InputMaybe<Scalars['String']['input']>;
  targetBarcode?: InputMaybe<Scalars['String']['input']>;
};

/** Crystal Reveal 프롬프트 세트 수정 입력 */
export type UpdateCrystalRevealPromptSetInputDto = {
  memo?: InputMaybe<Scalars['String']['input']>;
  promptSetSeq: Scalars['Int']['input'];
  prompts: Array<CrystalRevealPromptInputDto>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceAlertPolicyInput = {
  code: Scalars['String']['input'];
  maxThreadCount: Scalars['Int']['input'];
  slackEnabled: Scalars['Boolean']['input'];
  slackThresholdCount: Scalars['Int']['input'];
  threadEnabled: Scalars['Boolean']['input'];
  threadWindowMinutes: Scalars['Int']['input'];
};

export type UpdateSpecialBarcodeInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** True이면 연관된 recording의 deleteFlag를 1로 업데이트 */
  blindRecording?: InputMaybe<Scalars['Boolean']['input']>;
  /** True이면 연관된 class voucher를 만료 처리 */
  expireClassVoucher?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  seq: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

/** 시스템 설정 업데이트 입력 */
export type UpdateSystemSettingInputDto = {
  /** 설정 키 */
  settingKey: Scalars['String']['input'];
  /** 수정자 */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** 새로운 설정값 */
  value: Scalars['String']['input'];
};

export type UpdateUploadStatusInputDto = {
  completedChunks?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  progress: Scalars['Int']['input'];
  status: DownloadJobStatus;
  totalChunks?: InputMaybe<Scalars['Int']['input']>;
};

/** USB 디바이스 수정 Input */
export type UpdateUsbDeviceInput = {
  /** 별칭 (캡처보드용) */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** 한글 표시명 */
  kor?: InputMaybe<Scalars['String']['input']>;
  /** 기술명 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Product ID (10진수) */
  pid?: InputMaybe<Scalars['Int']['input']>;
  /** USB 디바이스 seq (PK) */
  seq: Scalars['Int']['input'];
  /** 단일키 장치 여부 */
  singleKeyDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** 디바이스 타입 */
  type?: InputMaybe<UsbDeviceType>;
  /** Vendor ID (10진수) */
  vid?: InputMaybe<Scalars['Int']['input']>;
};

/** 업로드 정보 */
export type UploadDto = {
  __typename?: 'UploadDto';
  /** 상태 */
  status?: Maybe<Scalars['Boolean']['output']>;
  /** 업로드 시간 */
  uploadedAt?: Maybe<Scalars['String']['output']>;
};

export type UploadListOptions = {
  /** 페이지당 가져올 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 조회할 페이지 번호 */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** 검색어 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 필드 */
  sortField?: InputMaybe<Scalars['String']['input']>;
  /** 정렬 순서 */
  sortOrder?: InputMaybe<SortOrder>;
  /** 상태 필터 */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** 업로드 로그 */
export type UploadLogDto = {
  __typename?: 'UploadLogDto';
  /** 장비명 */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** 파일 ID */
  fileId: Scalars['String']['output'];
  /** 전체 바코드 번호 */
  fullBarcode?: Maybe<Scalars['String']['output']>;
  /** 병원명 */
  hospitalName?: Maybe<Scalars['String']['output']>;
  /** 진료실명 */
  roomName?: Maybe<Scalars['String']['output']>;
  /** 바코드 스캔 시간 */
  scannedAt?: Maybe<Scalars['String']['output']>;
  /** 업로드 상태 */
  status: Scalars['Boolean']['output'];
};

/** USB 디바이스 */
export type UsbDeviceEntity = {
  __typename?: 'UsbDeviceEntity';
  /** 별칭 (캡처보드용, 예: LS_EASYCAP) */
  alias?: Maybe<Scalars['String']['output']>;
  /** 생성일시 */
  createdAt: Scalars['DateTime']['output'];
  /** 삭제일시 */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 한글 표시명 (예: 마미톡 LED) */
  kor: Scalars['String']['output'];
  /** 기술명 (예: MmtLEDv3) */
  name: Scalars['String']['output'];
  /** Product ID (10진수) */
  pid: Scalars['Int']['output'];
  /** Primary Key */
  seq: Scalars['Int']['output'];
  /** 단일키 장치 여부 (풋/리모트 스위치용) */
  singleKeyDevice?: Maybe<Scalars['Boolean']['output']>;
  /** 디바이스 타입 */
  type: UsbDeviceType;
  /** 수정일시 */
  updatedAt: Scalars['DateTime']['output'];
  /** Vendor ID (10진수) */
  vid: Scalars['Int']['output'];
};

/** USB 디바이스 조회 필터 */
export type UsbDeviceFilterInput = {
  /** Product ID */
  pid?: InputMaybe<Scalars['Int']['input']>;
  /** 디바이스 타입 */
  type?: InputMaybe<UsbDeviceType>;
  /** Vendor ID */
  vid?: InputMaybe<Scalars['Int']['input']>;
};

/** USB 디바이스 타입 */
export enum UsbDeviceType {
  CAPTUREBOARD = 'CAPTUREBOARD',
  FOOTSWITCH = 'FOOTSWITCH',
  LED = 'LED',
  PRINTER = 'PRINTER',
  REMOTESWITCH = 'REMOTESWITCH',
  SCANNER = 'SCANNER'
}

export type ValidateDeviceNamesResult = {
  __typename?: 'ValidateDeviceNamesResult';
  /** 검증 결과 목록 */
  results: Array<DeviceValidationResult>;
};

export type VersionConflictResolutionDto = {
  __typename?: 'VersionConflictResolutionDto';
  conflictsDetected: Scalars['Boolean']['output'];
  failedConflicts: Array<Scalars['String']['output']>;
  resolvedConflicts: Array<Scalars['String']['output']>;
  totalConflicts: Scalars['Int']['output'];
};

export type GoogleLoginMutationVariables = Exact<{
  googleAccessToken: Scalars['String']['input'];
}>;


export type GoogleLoginMutation = { __typename?: 'Mutation', googleLogin?: { __typename?: 'TokenResult', status?: boolean | null, affected?: number | null, message?: string | null, seq: string, userDisplayName: string, userEmail: string, enabledFlag: boolean, superFlag: boolean, accessToken?: string | null } | null };

export type UpsertUltrasoundCaptureMutationVariables = Exact<{
  ultrasoundCaptureUpsert: UltrasoundCaptureInput;
}>;


export type UpsertUltrasoundCaptureMutation = { __typename?: 'Mutation', upsertUltrasoundCapture: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type BlindUltrasoundCapturesMutationVariables = Exact<{
  recordingSeq: Scalars['Float']['input'];
  deleteFlag: Scalars['Boolean']['input'];
}>;


export type BlindUltrasoundCapturesMutation = { __typename?: 'Mutation', blindUltrasoundCaptures: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UploadCaptureMutationVariables = Exact<{
  captureUploadInput: CaptureUploadInput;
  reason: Scalars['String']['input'];
}>;


export type UploadCaptureMutation = { __typename?: 'Mutation', uploadCapture: { __typename?: 'ExecResult', status?: boolean | null, message?: string | null } };

export type UpsertCrmMutationVariables = Exact<{
  crmUpsert: CrmInput;
}>;


export type UpsertCrmMutation = { __typename?: 'Mutation', upsertCrm: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type DeleteCrmMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
}>;


export type DeleteCrmMutation = { __typename?: 'Mutation', deleteCrm: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpsertCrmTypeMutationVariables = Exact<{
  crmTypeUpsert: CrmTypeInput;
}>;


export type UpsertCrmTypeMutation = { __typename?: 'Mutation', upsertCrmType: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type ApproveChannelTalkRequestMutationVariables = Exact<{
  seq: Scalars['Int']['input'];
  sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ApproveChannelTalkRequestMutation = { __typename?: 'Mutation', approveChannelTalkRequest: { __typename?: 'ChannelTalkRequestActionResult', success: boolean, message?: string | null, request?: { __typename?: 'ChannelTalkRequest', seq: number, workflowType: ChannelTalkWorkflowType, executionMode: ChannelTalkExecutionMode, status: ChannelTalkRequestStatus, channelId: string, channelTalkUserId: string, userChatId?: string | null, userName: string, submitData: any, recordingSeq?: number | null, sourceBarcode?: string | null, targetBarcode?: string | null, recordedAt?: any | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, hospitalName?: string | null, hospitalRoomName?: string | null, reviewReason?: string | null, slackMessageTs?: string | null, slackChannelId?: string | null, messageSentFlag: boolean, responseMessageText?: string | null, responseMessageSentAt?: any | null, resultMessage?: string | null, decisionBy?: string | null, decisionAt?: any | null, decisionSource?: ChannelTalkDecisionSource | null, executedBy?: string | null, executedAt?: any | null, createdAt: any, updatedAt: any } | null } };

export type BulkApproveChannelTalkRequestsMutationVariables = Exact<{
  seqs: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type BulkApproveChannelTalkRequestsMutation = { __typename?: 'Mutation', bulkApproveChannelTalkRequests: { __typename?: 'BulkChannelTalkRequestActionResult', successCount: number, failureCount: number, results: Array<{ __typename?: 'ChannelTalkRequestActionResult', success: boolean, message?: string | null, request?: { __typename?: 'ChannelTalkRequest', seq: number, workflowType: ChannelTalkWorkflowType, executionMode: ChannelTalkExecutionMode, status: ChannelTalkRequestStatus, channelId: string, channelTalkUserId: string, userChatId?: string | null, userName: string, submitData: any, recordingSeq?: number | null, sourceBarcode?: string | null, targetBarcode?: string | null, recordedAt?: any | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, hospitalName?: string | null, hospitalRoomName?: string | null, reviewReason?: string | null, slackMessageTs?: string | null, slackChannelId?: string | null, messageSentFlag: boolean, responseMessageText?: string | null, responseMessageSentAt?: any | null, resultMessage?: string | null, decisionBy?: string | null, decisionAt?: any | null, decisionSource?: ChannelTalkDecisionSource | null, executedBy?: string | null, executedAt?: any | null, createdAt: any, updatedAt: any } | null }> } };

export type RejectChannelTalkRequestMutationVariables = Exact<{
  seq: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  responseMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectChannelTalkRequestMutation = { __typename?: 'Mutation', rejectChannelTalkRequest: { __typename?: 'ChannelTalkRequestActionResult', success: boolean, message?: string | null, request?: { __typename?: 'ChannelTalkRequest', seq: number, workflowType: ChannelTalkWorkflowType, executionMode: ChannelTalkExecutionMode, status: ChannelTalkRequestStatus, channelId: string, channelTalkUserId: string, userChatId?: string | null, userName: string, submitData: any, recordingSeq?: number | null, sourceBarcode?: string | null, targetBarcode?: string | null, recordedAt?: any | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, hospitalName?: string | null, hospitalRoomName?: string | null, reviewReason?: string | null, slackMessageTs?: string | null, slackChannelId?: string | null, messageSentFlag: boolean, responseMessageText?: string | null, responseMessageSentAt?: any | null, resultMessage?: string | null, decisionBy?: string | null, decisionAt?: any | null, decisionSource?: ChannelTalkDecisionSource | null, executedBy?: string | null, executedAt?: any | null, createdAt: any, updatedAt: any } | null } };

export type DuplicateRecordingMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
  targetBarcode: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type DuplicateRecordingMutation = { __typename?: 'Mutation', duplicateRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpsertRecordingMutationVariables = Exact<{
  recordingUpsert: RecordingInput;
  reason: Scalars['String']['input'];
}>;


export type UpsertRecordingMutation = { __typename?: 'Mutation', upsertRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type EditRecordingMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
  startTime: Scalars['String']['input'];
  duration: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
}>;


export type EditRecordingMutation = { __typename?: 'Mutation', editRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type OverwriteRecordingMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
}>;


export type OverwriteRecordingMutation = { __typename?: 'Mutation', overwriteRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type TransferRecordingMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
  targetBarcode: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type TransferRecordingMutation = { __typename?: 'Mutation', transferRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpsertDeviceMutationVariables = Exact<{
  DeviceUpsert: DeviceInput;
}>;


export type UpsertDeviceMutation = { __typename?: 'Mutation', upsertDevice: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpsertDeviceVersionMutationVariables = Exact<{
  deviceVersionUpsert: DeviceVersionInput;
}>;


export type UpsertDeviceVersionMutation = { __typename?: 'Mutation', upsertDeviceVersion: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type SendCommandMutationVariables = Exact<{
  deviceName: Scalars['String']['input'];
  command: Scalars['String']['input'];
  acme?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SendCommandMutation = { __typename?: 'Mutation', sendCommand: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type SshOrderMutationVariables = Exact<{
  deviceName: Scalars['String']['input'];
  action: Scalars['String']['input'];
  host: Scalars['String']['input'];
}>;


export type SshOrderMutation = { __typename?: 'Mutation', sshOrder: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpdateAgentMutationVariables = Exact<{
  deviceName: Scalars['String']['input'];
  force: Scalars['Boolean']['input'];
}>;


export type UpdateAgentMutation = { __typename?: 'Mutation', updateAgent: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpdateBoxMutationVariables = Exact<{
  deviceName: Scalars['String']['input'];
  version: Scalars['String']['input'];
  silent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBoxMutation = { __typename?: 'Mutation', updateBox: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type BatchCreateDevicesMutationVariables = Exact<{
  input: BatchCreateDevicesInput;
}>;


export type BatchCreateDevicesMutation = { __typename?: 'Mutation', batchCreateDevices: { __typename?: 'BatchCreateResult', success: boolean, message?: string | null, successCount: number, failureCount: number, failures: Array<{ __typename?: 'BatchCreateFailure', deviceName: string, description: string, errorMessage: string }> } };

export type ValidateDeviceNamesMutationVariables = Exact<{
  deviceNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ValidateDeviceNamesMutation = { __typename?: 'Mutation', validateDeviceNames: { __typename?: 'ValidateDeviceNamesResult', results: Array<{ __typename?: 'DeviceValidationResult', deviceName: string, isValid: boolean, isDuplicate: boolean, errorMessage?: string | null }> } };

export type SetCustomCropTemplateMutationVariables = Exact<{
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  h: Scalars['Float']['input'];
}>;


export type SetCustomCropTemplateMutation = { __typename?: 'Mutation', setCustomCropTemplate: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type StartDirectUploadMutationVariables = Exact<{
  input: StartDirectUploadInputDto;
}>;


export type StartDirectUploadMutation = { __typename?: 'Mutation', startDirectUpload: { __typename?: 'StartDirectUploadDto', jobId: string, estimatedDurationMin: number, s3Config: { __typename?: 'DirectUploadConfigDto', bucket: string, key: string, uploadId: string, region: string, credentials: { __typename?: 'CredentialsDto', accessKeyId: string, secretAccessKey: string, sessionToken?: string | null, expiration: any } } } };

export type DeleteDownloadMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DeleteDownloadMutation = { __typename?: 'Mutation', deleteDownload: boolean };

export type UpsertHospitalMutationVariables = Exact<{
  HospitalUpsert: HospitalInput;
}>;


export type UpsertHospitalMutation = { __typename?: 'Mutation', upsertHospital: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpsertHospitalLoginMutationVariables = Exact<{
  hospitalLoginUpsert: HospitalLoginInput;
}>;


export type UpsertHospitalLoginMutation = { __typename?: 'Mutation', upsertHospitalLogin: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type DeleteHospitalLoginMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
}>;


export type DeleteHospitalLoginMutation = { __typename?: 'Mutation', deleteHospitalLogin: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpsertHospitalRoomMutationVariables = Exact<{
  HospitalRoomUpsert: HospitalRoomInput;
}>;


export type UpsertHospitalRoomMutation = { __typename?: 'Mutation', upsertHospitalRoom: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type UpdateHospitalSubscriptionMutationVariables = Exact<{
  hospitalSeq: Scalars['Float']['input'];
  updateData: HospitalSubscriptionUpdateDto;
}>;


export type UpdateHospitalSubscriptionMutation = { __typename?: 'Mutation', updateHospitalSubscription: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type KeycloakLoginCallbackMutationVariables = Exact<{
  input: KeycloakCodeInput;
}>;


export type KeycloakLoginCallbackMutation = { __typename?: 'Mutation', keycloakLoginCallback?: { __typename?: 'TokenResult', accessToken?: string | null, refreshToken?: string | null, idToken?: string | null, roles?: Array<string> | null, groups?: Array<string> | null, seq: string, userDisplayName: string, userEmail: string, enabledFlag: boolean, superFlag: boolean } | null };

export type KeycloakTokenReissueMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type KeycloakTokenReissueMutation = { __typename?: 'Mutation', keycloakTokenReissue?: { __typename?: 'TokenResult', accessToken?: string | null, refreshToken?: string | null, idToken?: string | null, roles?: Array<string> | null, groups?: Array<string> | null, seq: string, userDisplayName: string, userEmail: string, enabledFlag: boolean, superFlag: boolean } | null };

export type MigrateMothersVideosMutationVariables = Exact<{
  videoSeqs: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  targetHospitalSeq: Scalars['Float']['input'];
  targetBarcode: Scalars['String']['input'];
}>;


export type MigrateMothersVideosMutation = { __typename?: 'Mutation', migrateMothersVideos: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type MigrateHumangateVideosMutationVariables = Exact<{
  barcode: Scalars['String']['input'];
  targetHospitalSeq: Scalars['Float']['input'];
  targetBarcode: Scalars['String']['input'];
}>;


export type MigrateHumangateVideosMutation = { __typename?: 'Mutation', migrateHumangateVideos: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type RefreshRecordingMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
}>;


export type RefreshRecordingMutation = { __typename?: 'Mutation', refreshRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type RestoreRecordingMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
}>;


export type RestoreRecordingMutation = { __typename?: 'Mutation', restoreRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type RestoreArchivedRecordingMutationVariables = Exact<{
  seq: Scalars['Int']['input'];
  days: Scalars['Int']['input'];
}>;


export type RestoreArchivedRecordingMutation = { __typename?: 'Mutation', restoreArchivedRecording: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type CheckS3ClassMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
}>;


export type CheckS3ClassMutation = { __typename?: 'Mutation', checkS3Class: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type LogRecordingDownloadMutationVariables = Exact<{
  seq: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
}>;


export type LogRecordingDownloadMutation = { __typename?: 'Mutation', logRecordingDownload: { __typename?: 'ExecResult', status?: boolean | null, message?: string | null } };

export type RestoreStoppedRecordingsMutationVariables = Exact<{
  input: RestoreStoppedRecordingsInput;
}>;


export type RestoreStoppedRecordingsMutation = { __typename?: 'Mutation', restoreStoppedRecordings: { __typename?: 'StoppedRecordingRestoreResult', status: boolean, message?: string | null, requestedCount: number, restoredCount: number, failedCount: number, failedItems: Array<{ __typename?: 'StoppedRecordingRestoreFailedItem', seq: number, fileId?: string | null, reason: string }> } };

export type CreateSpecialBarcodeMutationVariables = Exact<{
  createSpecialBarcodeInput: CreateSpecialBarcodeInput;
}>;


export type CreateSpecialBarcodeMutation = { __typename?: 'Mutation', createSpecialBarcode: { __typename?: 'SpecialBarcodeEntity', seq: number, barcode: string, type: string, reason?: string | null, createdAt: any, updatedAt: any } };

export type BatchCreateSpecialBarcodesMutationVariables = Exact<{
  input: BatchCreateSpecialBarcodesInput;
}>;


export type BatchCreateSpecialBarcodesMutation = { __typename?: 'Mutation', batchCreateSpecialBarcodes: { __typename?: 'BatchCreateSpecialBarcodesResult', success: boolean, message?: string | null, successCount: number, failureCount: number, failures: Array<{ __typename?: 'BatchCreateSpecialBarcodeFailure', barcode: string, errorMessage: string }> } };

export type UpdateSpecialBarcodeMutationVariables = Exact<{
  updateSpecialBarcodeInput: UpdateSpecialBarcodeInput;
}>;


export type UpdateSpecialBarcodeMutation = { __typename?: 'Mutation', updateSpecialBarcode: { __typename?: 'SpecialBarcodeEntity', seq: number, barcode: string, type: string, reason?: string | null, createdAt: any, updatedAt: any } };

export type RemoveSpecialBarcodeMutationVariables = Exact<{
  seq: Scalars['Int']['input'];
  blindRecording?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveSpecialBarcodeMutation = { __typename?: 'Mutation', removeSpecialBarcode: { __typename?: 'SpecialBarcodeEntity', seq: number, barcode: string, type: string, reason?: string | null, createdAt: any, updatedAt: any } };

export type CreateSystemSettingMutationVariables = Exact<{
  input: CreateSystemSettingInputDto;
}>;


export type CreateSystemSettingMutation = { __typename?: 'Mutation', createSystemSetting: { __typename?: 'SystemSettingsDto', settingKey: string, value?: string | null, dataType: SystemSettingDataType } };

export type UpdateSystemSettingMutationVariables = Exact<{
  input: UpdateSystemSettingInputDto;
}>;


export type UpdateSystemSettingMutation = { __typename?: 'Mutation', updateSystemSetting: { __typename?: 'SystemSettingsDto', settingKey: string, value?: string | null } };

export type BatchUpdateSystemSettingsMutationVariables = Exact<{
  input: BatchUpdateSystemSettingsInputDto;
}>;


export type BatchUpdateSystemSettingsMutation = { __typename?: 'Mutation', batchUpdateSystemSettings: Array<{ __typename?: 'SystemSettingsDto', settingKey: string, value?: string | null }> };

export type ResetSystemSettingToDefaultMutationVariables = Exact<{
  settingKey: Scalars['String']['input'];
}>;


export type ResetSystemSettingToDefaultMutation = { __typename?: 'Mutation', resetSystemSettingToDefault: { __typename?: 'SystemSettingsDto', settingKey: string, value?: string | null, defaultValue?: string | null } };

export type DeleteSystemSettingMutationVariables = Exact<{
  settingKey: Scalars['String']['input'];
}>;


export type DeleteSystemSettingMutation = { __typename?: 'Mutation', deleteSystemSetting: boolean };

export type PaginatedBabyAiListQueryVariables = Exact<{
  listOptions: BabyAiListOptions;
}>;


export type PaginatedBabyAiListQuery = { __typename?: 'Query', paginatedBabyAiList: { __typename?: 'PaginatedBabyAi', nodes: Array<{ __typename?: 'BabyAiListDto', seq: number, barcode: string, babySeq?: number | null, userSeq?: number | null, hospitalSeq: number, hospitalRoomSeq: number, deviceSeq: number, fileId: string, captureImageS3FileKey: string, hiddenBabyImageS3FileKey?: string | null, babyMagicImageS3FileKey?: string | null, visibleFlag: boolean, billableVisibleFlag: boolean, capturedAt: any, createdAt: any, updatedAt: any, captureUrl: string, hiddenBabyUrl?: string | null, babyMagicUrl?: string | null, signedCaptureUrl?: string | null, signedHiddenBabyUrl?: string | null, signedBabyMagicUrl?: string | null, webhookSentAt?: any | null, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type UltrasoundCaptureFragment = { __typename?: 'UltrasoundCaptureDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, s3Bucket?: string | null, s3FileKey?: string | null, captureUrl?: string | null, signedCaptureUrl?: string | null, capturedAt?: any | null, createdAt: any, updatedAt: any };

export type UltrasoundCapturesQueryVariables = Exact<{
  searchDateInput: SearchDateInput;
}>;


export type UltrasoundCapturesQuery = { __typename?: 'Query', ultrasoundCaptures: Array<{ __typename?: 'UltrasoundCaptureDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, s3Bucket?: string | null, s3FileKey?: string | null, captureUrl?: string | null, signedCaptureUrl?: string | null, capturedAt?: any | null, createdAt: any, updatedAt: any, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null, device?: { __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any } | null }> };

export type PaginatedUltrasoundCapturesQueryVariables = Exact<{
  listOptions: UltrasoundCaptureListOptions;
}>;


export type PaginatedUltrasoundCapturesQuery = { __typename?: 'Query', paginatedUltrasoundCaptures: { __typename?: 'PaginatedUltrasoundCapture', nodes: Array<{ __typename?: 'UltrasoundCaptureDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, s3Bucket?: string | null, s3FileKey?: string | null, captureUrl?: string | null, signedCaptureUrl?: string | null, capturedAt?: any | null, createdAt: any, updatedAt: any, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null, device?: { __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any } | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type UltrasoundCapturesByRecordingSeqQueryVariables = Exact<{
  recordingSeq: Scalars['Float']['input'];
}>;


export type UltrasoundCapturesByRecordingSeqQuery = { __typename?: 'Query', ultrasoundCapturesByRecordingSeq: Array<{ __typename?: 'UltrasoundCaptureDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, s3Bucket?: string | null, s3FileKey?: string | null, captureUrl?: string | null, signedCaptureUrl?: string | null, capturedAt?: any | null, createdAt: any, updatedAt: any, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null, device?: { __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any } | null }> };

export type CrmFragment = { __typename?: 'CrmDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, crmTypeSeq: number, actorIdentity: string, crmStatus?: string | null, visitDate?: any | null, visitMemo?: string | null, description?: string | null, slackMessageId?: string | null, slackPermaLink?: string | null, slackTaNudge?: boolean | null, createdAt: any, updatedAt: any };

export type CrmTypeFragment = { __typename?: 'CrmTypeDto', seq: number, typeName: string, activeFlag: boolean, createdAt: any, updatedAt: any };

export type ChannelTalkRequestFragment = { __typename?: 'ChannelTalkRequest', seq: number, workflowType: ChannelTalkWorkflowType, executionMode: ChannelTalkExecutionMode, status: ChannelTalkRequestStatus, channelId: string, channelTalkUserId: string, userChatId?: string | null, userName: string, submitData: any, recordingSeq?: number | null, sourceBarcode?: string | null, targetBarcode?: string | null, recordedAt?: any | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, hospitalName?: string | null, hospitalRoomName?: string | null, reviewReason?: string | null, slackMessageTs?: string | null, slackChannelId?: string | null, messageSentFlag: boolean, responseMessageText?: string | null, responseMessageSentAt?: any | null, resultMessage?: string | null, decisionBy?: string | null, decisionAt?: any | null, decisionSource?: ChannelTalkDecisionSource | null, executedBy?: string | null, executedAt?: any | null, createdAt: any, updatedAt: any };

export type CrmsQueryVariables = Exact<{
  searchOptions?: InputMaybe<SearchDateInput>;
}>;


export type CrmsQuery = { __typename?: 'Query', crms: Array<{ __typename?: 'CrmDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, crmTypeSeq: number, actorIdentity: string, crmStatus?: string | null, visitDate?: any | null, visitMemo?: string | null, description?: string | null, slackMessageId?: string | null, slackPermaLink?: string | null, slackTaNudge?: boolean | null, createdAt: any, updatedAt: any, crmType: { __typename?: 'CrmTypeDto', seq: number, typeName: string, activeFlag: boolean, createdAt: any, updatedAt: any }, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null }> };

export type PaginatedCrmsQueryVariables = Exact<{
  listOptions: CrmListOptions;
}>;


export type PaginatedCrmsQuery = { __typename?: 'Query', paginatedCrms: { __typename?: 'PaginatedCrm', nodes: Array<{ __typename?: 'CrmDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, crmTypeSeq: number, actorIdentity: string, crmStatus?: string | null, visitDate?: any | null, visitMemo?: string | null, description?: string | null, slackMessageId?: string | null, slackPermaLink?: string | null, slackTaNudge?: boolean | null, createdAt: any, updatedAt: any, crmType: { __typename?: 'CrmTypeDto', seq: number, typeName: string, activeFlag: boolean, createdAt: any, updatedAt: any }, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type CrmsByCrmTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CrmsByCrmTypesQuery = { __typename?: 'Query', crmTypes: Array<{ __typename?: 'CrmTypeDto', seq: number, typeName: string, activeFlag: boolean, createdAt: any, updatedAt: any, crms?: Array<{ __typename?: 'CrmDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, crmTypeSeq: number, actorIdentity: string, crmStatus?: string | null, visitDate?: any | null, visitMemo?: string | null, description?: string | null, slackMessageId?: string | null, slackPermaLink?: string | null, slackTaNudge?: boolean | null, createdAt: any, updatedAt: any }> | null }> };

export type CrmTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CrmTypesQuery = { __typename?: 'Query', crmTypes: Array<{ __typename?: 'CrmTypeDto', seq: number, typeName: string, activeFlag: boolean, createdAt: any, updatedAt: any }> };

export type ChannelTalkRequestsQueryVariables = Exact<{
  listOptions: ChannelTalkRequestFilter;
}>;


export type ChannelTalkRequestsQuery = { __typename?: 'Query', channelTalkRequests: { __typename?: 'PaginatedChannelTalkRequest', nodes: Array<{ __typename?: 'ChannelTalkRequest', seq: number, workflowType: ChannelTalkWorkflowType, executionMode: ChannelTalkExecutionMode, status: ChannelTalkRequestStatus, channelId: string, channelTalkUserId: string, userChatId?: string | null, userName: string, submitData: any, recordingSeq?: number | null, sourceBarcode?: string | null, targetBarcode?: string | null, recordedAt?: any | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, hospitalName?: string | null, hospitalRoomName?: string | null, reviewReason?: string | null, slackMessageTs?: string | null, slackChannelId?: string | null, messageSentFlag: boolean, responseMessageText?: string | null, responseMessageSentAt?: any | null, resultMessage?: string | null, decisionBy?: string | null, decisionAt?: any | null, decisionSource?: ChannelTalkDecisionSource | null, executedBy?: string | null, executedAt?: any | null, createdAt: any, updatedAt: any }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type ActivityLogFragment = { __typename?: 'ActivityLogDto', seq?: number | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, activityType?: string | null, actorIdentity?: string | null, reason?: string | null, description?: string | null, detailLog?: string | null, createdAt: any, updatedAt: any };

export type GetRecordingPresignedUrlQueryVariables = Exact<{
  seq: Scalars['Float']['input'];
}>;


export type GetRecordingPresignedUrlQuery = { __typename?: 'Query', getRecordingPresignedUrl: { __typename?: 'ExecResult', affected?: number | null, status?: boolean | null, message?: string | null } };

export type ActivityLogsQueryVariables = Exact<{
  searchDateInput?: InputMaybe<SearchDateInput>;
}>;


export type ActivityLogsQuery = { __typename?: 'Query', activityLogs: Array<{ __typename?: 'ActivityLogDto', seq?: number | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, activityType?: string | null, actorIdentity?: string | null, reason?: string | null, description?: string | null, detailLog?: string | null, createdAt: any, updatedAt: any }> };

export type PaginatedActivityLogsQueryVariables = Exact<{
  listOptions: ActivityLogListOptions;
}>;


export type PaginatedActivityLogsQuery = { __typename?: 'Query', paginatedActivityLogs: { __typename?: 'PaginatedActivityLog', nodes: Array<{ __typename?: 'ActivityLogDto', seq?: number | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, activityType?: string | null, actorIdentity?: string | null, reason?: string | null, description?: string | null, detailLog?: string | null, createdAt: any, updatedAt: any }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type FailedUploadRecoveryQueryVariables = Exact<{
  failedUploadRecoveryInputDto: FailedUploadRecoveryInputDto;
}>;


export type FailedUploadRecoveryQuery = { __typename?: 'Query', failedUploadRecovery: { __typename?: 'FailedUploadRecoveryDownloadUrlDto', urls?: Array<string> | null, status: boolean, message?: string | null } };

export type SessionFragment = { __typename?: 'SessionDto', deviceSeq: number, barcode: string, fileId: string, status: string, scanned?: Array<any> | null, recordingCount: number, captureCount: number, startedAt?: any | null, motionPassedAt?: any | null, stoppedAt?: any | null, finishedAt?: any | null, uploadedAt?: any | null };

export type PaginatedUploadLogsQueryVariables = Exact<{
  listOptions: UploadListOptions;
}>;


export type PaginatedUploadLogsQuery = { __typename?: 'Query', paginatedUploadLogs: { __typename?: 'PaginatedUpload', nodes: Array<{ __typename?: 'UploadLogDto', deviceName?: string | null, hospitalName?: string | null, roomName?: string | null, fullBarcode?: string | null, fileId: string, status: boolean, scannedAt?: string | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type PaginatedSessionsQueryVariables = Exact<{
  listOptions: SessionListOptions;
}>;


export type PaginatedSessionsQuery = { __typename?: 'Query', paginatedSessions: { __typename?: 'PaginatedSession', nodes: Array<{ __typename?: 'SessionDto', deviceSeq: number, barcode: string, fileId: string, status: string, scanned?: Array<any> | null, recordingCount: number, captureCount: number, startedAt?: any | null, motionPassedAt?: any | null, stoppedAt?: any | null, finishedAt?: any | null, uploadedAt?: any | null, device?: { __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any } | null, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type DeviceFragment = { __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any };

export type DeviceStateFragment = { __typename?: 'DeviceStateDto', version?: string | null, captureBoardType?: string | null, captureBoardStatus?: string | null, isConnected?: boolean | null, isRecording?: boolean | null, isUploading?: boolean | null, status?: string | null, acme?: any | null, diskUsage?: string | null, ip?: string | null, connectedAt?: any | null, updatedAt?: any | null, scanned?: { __typename?: 'ScannedInfo', text?: string | null, timestamp?: any | null } | null, screenshot?: { __typename?: 'ScreenshotInfo', timestamp?: any | null, base64Data?: string | null } | null, stats?: { __typename?: 'DeviceStatsState', recording?: number | null, uploading?: number | null } | null };

export type AgentStateFragment = { __typename?: 'AgentStateDto', isConnected?: boolean | null, agentVersion?: string | null, connectedAt?: any | null, updatedAt?: any | null, agentSsh?: { __typename?: 'AgentSshInfo', action?: string | null, host?: string | null, port?: number | null, status?: string | null, error?: string | null } | null };

export type DevicesQueryVariables = Exact<{
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
}>;


export type DevicesQuery = { __typename?: 'Query', devices: Array<{ __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any, hospitalRoom?: { __typename?: 'HospitalRoomDto', roomName?: string | null } | null }> };

export type DevicesWithStateQueryVariables = Exact<{
  hospitalSeq?: InputMaybe<Scalars['Float']['input']>;
}>;


export type DevicesWithStateQuery = { __typename?: 'Query', devices: Array<{ __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any, deviceState?: { __typename?: 'DeviceStateDto', version?: string | null, captureBoardType?: string | null, captureBoardStatus?: string | null, isConnected?: boolean | null, isRecording?: boolean | null, isUploading?: boolean | null, status?: string | null, acme?: any | null, diskUsage?: string | null, ip?: string | null, connectedAt?: any | null, updatedAt?: any | null, scanned?: { __typename?: 'ScannedInfo', text?: string | null, timestamp?: any | null } | null, screenshot?: { __typename?: 'ScreenshotInfo', timestamp?: any | null, base64Data?: string | null } | null, stats?: { __typename?: 'DeviceStatsState', recording?: number | null, uploading?: number | null } | null } | null, agentState?: { __typename?: 'AgentStateDto', isConnected?: boolean | null, agentVersion?: string | null, connectedAt?: any | null, updatedAt?: any | null, agentSsh?: { __typename?: 'AgentSshInfo', action?: string | null, host?: string | null, port?: number | null, status?: string | null, error?: string | null } | null } | null }> };

export type PaginatedDevicesQueryVariables = Exact<{
  listOptions: DeviceListOptions;
}>;


export type PaginatedDevicesQuery = { __typename?: 'Query', paginatedDevices: { __typename?: 'PaginatedDevice', nodes: Array<{ __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any, deviceState?: { __typename?: 'DeviceStateDto', version?: string | null, status?: string | null, updatedAt?: any | null } | null, agentState?: { __typename?: 'AgentStateDto', agentVersion?: string | null } | null, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type DeviceVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceVersionsQuery = { __typename?: 'Query', deviceVersions: Array<{ __typename?: 'DeviceVersionDto', seq: number, versionName: string, buildNum: number, buildHash: string, versionDescription: string, versionDate: string, visibleFlag: boolean, autoUpdate: boolean, createdAt: any, updatedAt: any }> };

export type GetBoxLogQueryVariables = Exact<{
  deviceName: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type GetBoxLogQuery = { __typename?: 'Query', getBoxLog: { __typename?: 'BoxLogDto', rawLog?: string | null, sessionLogs?: Array<{ __typename?: 'SessionLogDto', barcode?: string | null, startedAt?: string | null, fileId?: string | null, segment?: number | null, motion?: { __typename?: 'MotionDto', start?: string | null, end?: string | null, duration?: number | null } | null, scan?: Array<{ __typename?: 'ScanDto', scanned?: string | null, scannedAt?: string | null }> | null, record?: Array<{ __typename?: 'RecordDto', start?: string | null, end?: string | null, duration?: number | null }> | null, upload?: { __typename?: 'UploadDto', status?: boolean | null, uploadedAt?: string | null } | null }> | null } };

export type DeviceNotificationsQueryVariables = Exact<{
  deviceName: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  listOptions: DeviceNotificationListOptions;
}>;


export type DeviceNotificationsQuery = { __typename?: 'Query', deviceNotifications: { __typename?: 'PaginatedDeviceNotification', nodes: Array<{ __typename?: 'DeviceNotificationDto', id: number, occurredAt: any, severity: DeviceNotificationSeverity, code: string, message: string, barcode?: string | null, fileId?: string | null, statusSummary: string, slackStatus: DeviceNotificationSlackStatus, slackPermalink?: string | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type GetCropTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCropTemplatesQuery = { __typename?: 'Query', getCropTemplates: any };

export type TestAutoRecordingQueryVariables = Exact<{
  deviceName: Scalars['String']['input'];
  barcode: Scalars['String']['input'];
}>;


export type TestAutoRecordingQuery = { __typename?: 'Query', testAutoRecording: { __typename?: 'ExecResult', status?: boolean | null, message?: string | null } };

export type MyDownloadsQueryVariables = Exact<{
  status?: InputMaybe<DownloadJobStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyDownloadsQuery = { __typename?: 'Query', myDownloads: Array<{ __typename?: 'DownloadJobDto', jobId: string, deviceName: string, filePath: string, fileSize?: number | null, status: DownloadJobStatus, progress: number, totalChunks?: number | null, completedChunks: number, downloadUrl?: string | null, createdAt: any, completedAt?: any | null, expiresAt?: any | null, networkQuality?: string | null, uploadSpeed?: number | null, errorMessage?: string | null }> };

export type ActiveDownloadsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveDownloadsQuery = { __typename?: 'Query', activeDownloads: Array<{ __typename?: 'DownloadJobDto', jobId: string, deviceName: string, filePath: string, status: DownloadJobStatus, progress: number, downloadUrl?: string | null, networkQuality?: string | null, uploadSpeed?: number | null }> };

export type DownloadJobQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DownloadJobQuery = { __typename?: 'Query', downloadJob?: { __typename?: 'DownloadJobDto', jobId: string, status: DownloadJobStatus, progress: number, downloadUrl?: string | null, errorMessage?: string | null } | null };

export type GetGoogleSheetDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleSheetDevicesQuery = { __typename?: 'Query', getGoogleSheetDevices: Array<{ __typename?: 'GoogleSheetDeviceDto', seq: number, deviceName?: string | null, activeFlag?: string | null, installFlag?: string | null, hospitalName?: string | null, hospitalRoomName?: string | null, version?: string | null, status?: string | null, updatedAt?: string | null, cfg1_max_recording_time?: string | null, cfg1_motion_threshold?: string | null, cfg1_use_printer_cp1300?: string | null, cfg1_use_diary_capture?: string | null, cfg1_capture_sw_mode?: string | null, cfg1_recording_brightness?: string | null, cfg1_recording_contrast?: string | null, cfg1_recording_card_select_mode?: string | null }> };

export type GetGoogleSheetHospitalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleSheetHospitalsQuery = { __typename?: 'Query', getGoogleSheetHospitals: Array<{ __typename?: 'GoogleSheetHospitalDto', seq: number, hospitalName?: string | null, city?: string | null, address?: string | null, telephone?: string | null, useTelemedicineFlag?: string | null, useNiptFlag?: string | null, useLibreFlag?: string | null, migrationServiceProvider?: string | null, migrationServiceActiveFlag?: string | null, defaultBlindRecording?: string | null, defaultBlindCapture?: string | null, activeFlag?: string | null }> };

export type GetGoogleSheetRecordingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleSheetRecordingsQuery = { __typename?: 'Query', getGoogleSheetRecordings: Array<{ __typename?: 'GoogleSheetRecordingDto', seq: number, barcode?: string | null, deviceName?: string | null, hospitalName?: string | null, description?: string | null, hospitalRoomName?: string | null, deleteFlag?: string | null, videoLength?: string | null, recordedAt?: string | null, createdAt?: string | null }> };

export type GetGoogleSheetCapturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleSheetCapturesQuery = { __typename?: 'Query', getGoogleSheetCaptures: Array<{ __typename?: 'GoogleSheetCaptureDto', seq: number, hospitalName?: string | null, hospitalRoomName?: string | null, deviceName?: string | null, barcode?: string | null, deleteFlag?: string | null, capturedAt?: string | null }> };

export type HospitalFragment = { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any };

export type HospitalRoomFragment = { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null };

export type HospitalRoomWithHospitalFragment = { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null };

export type HospitalLoginPermissionFragment = { __typename?: 'HospitalLoginPermissionDto', seq: number, hospitalLoginSeq: number, video_play: boolean, video_detail_search: boolean, video_download: boolean, device_list: boolean, nipt_admin: boolean, libre_admin: boolean, telemedicine_admin: boolean, stats_display: boolean, medical_record_display: boolean, video_blind: boolean, createdAt: any, updatedAt: any };

export type HospitalLoginFragment = { __typename?: 'HospitalLoginDto', seq: number, hospitalSeq: number, permissionSeq: number, hospitalId: string, hospitalPassword: string, rawPassword: string, createdAt: any, updatedAt: any, deletedAt?: any | null };

export type HospitalsQueryVariables = Exact<{ [key: string]: never; }>;


export type HospitalsQuery = { __typename?: 'Query', hospitals: Array<{ __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any }> };

export type PaginatedHospitalsQueryVariables = Exact<{
  listOptions: HospitalListOptions;
}>;


export type PaginatedHospitalsQuery = { __typename?: 'Query', paginatedHospitals: { __typename?: 'PaginatedHospital', nodes: Array<{ __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type HospitalRoomsQueryVariables = Exact<{
  hospitalSeq: Scalars['Float']['input'];
}>;


export type HospitalRoomsQuery = { __typename?: 'Query', hospitalRooms: Array<{ __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null }> };

export type HospitalRoomsWithDevicesQueryVariables = Exact<{
  hospitalSeq: Scalars['Float']['input'];
}>;


export type HospitalRoomsWithDevicesQuery = { __typename?: 'Query', hospitalRooms: Array<{ __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null, devices?: Array<{ __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any, deviceState?: { __typename?: 'DeviceStateDto', version?: string | null, captureBoardType?: string | null, captureBoardStatus?: string | null, isConnected?: boolean | null, isRecording?: boolean | null, isUploading?: boolean | null, status?: string | null, acme?: any | null, diskUsage?: string | null, ip?: string | null, connectedAt?: any | null, updatedAt?: any | null, scanned?: { __typename?: 'ScannedInfo', text?: string | null, timestamp?: any | null } | null, screenshot?: { __typename?: 'ScreenshotInfo', timestamp?: any | null, base64Data?: string | null } | null, stats?: { __typename?: 'DeviceStatsState', recording?: number | null, uploading?: number | null } | null } | null, agentState?: { __typename?: 'AgentStateDto', isConnected?: boolean | null, agentVersion?: string | null, connectedAt?: any | null, updatedAt?: any | null, agentSsh?: { __typename?: 'AgentSshInfo', action?: string | null, host?: string | null, port?: number | null, status?: string | null, error?: string | null } | null } | null }> | null }> };

export type HospitalLoginsQueryVariables = Exact<{
  hospitalSeq: Scalars['Float']['input'];
}>;


export type HospitalLoginsQuery = { __typename?: 'Query', hospitalLogins: Array<{ __typename?: 'HospitalLoginDto', seq: number, hospitalSeq: number, permissionSeq: number, hospitalId: string, hospitalPassword: string, rawPassword: string, createdAt: any, updatedAt: any, deletedAt?: any | null, permission: { __typename?: 'HospitalLoginPermissionDto', seq: number, hospitalLoginSeq: number, video_play: boolean, video_detail_search: boolean, video_download: boolean, device_list: boolean, nipt_admin: boolean, libre_admin: boolean, telemedicine_admin: boolean, stats_display: boolean, medical_record_display: boolean, video_blind: boolean, createdAt: any, updatedAt: any } }> };

export type SubscriptionInfoFragment = { __typename?: 'HospitalSubscriptionInfoDto', hospitalSeq: number, hospitalName: string, subscriptionDurationDays?: number | null, contractDate?: any | null, paidBarcodeDate?: any | null, activeFlag: boolean, subscriptionEndDate?: any | null, remainingDays: number };

export type HospitalSubscriptionInfoQueryVariables = Exact<{
  hospitalSeq: Scalars['Float']['input'];
}>;


export type HospitalSubscriptionInfoQuery = { __typename?: 'Query', hospitalSubscriptionInfo: { __typename?: 'HospitalSubscriptionInfoDto', hospitalSeq: number, hospitalName: string, subscriptionDurationDays?: number | null, contractDate?: any | null, paidBarcodeDate?: any | null, activeFlag: boolean, subscriptionEndDate?: any | null, remainingDays: number } };

export type PaginationMetaFragment = { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null };

export type RestoreHistoryFragment = { __typename?: 'RecordingRestoreHistoryDto', seq: number, countryCode: string, recordingSeq: number, restoreRequestedAt: any, restoreRequestedDays: number, restoredDetectedAt?: any | null, restoreExpiresAt?: any | null, status: RestoreStatus, restoreTier?: RestoreTier | null, requestSource?: string | null };

export type RecordingFragment = { __typename?: 'RecordingDto', seq: number, deviceSeq?: number | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, barcode?: number | null, fullBarcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, resolution?: string | null, videoLength?: number | null, captureCount?: number | null, s3Bucket?: string | null, s3FileKey?: string | null, s3Class?: string | null, streamingStatus?: string | null, recordingUrl?: string | null, thumbnailUrl?: string | null, signedRecordingUrl?: string | null, signedThumbnailUrl?: string | null, recordedAt?: any | null, createdAt: any, updatedAt: any, net30Flag?: boolean | null, totalRestoreCount?: number | null, latestRestoreHistory?: { __typename?: 'RecordingRestoreHistoryDto', seq: number, countryCode: string, recordingSeq: number, restoreRequestedAt: any, restoreRequestedDays: number, restoredDetectedAt?: any | null, restoreExpiresAt?: any | null, status: RestoreStatus, restoreTier?: RestoreTier | null, requestSource?: string | null } | null, restoreHistories?: Array<{ __typename?: 'RecordingRestoreHistoryDto', seq: number, countryCode: string, recordingSeq: number, restoreRequestedAt: any, restoreRequestedDays: number, restoredDetectedAt?: any | null, restoreExpiresAt?: any | null, status: RestoreStatus, restoreTier?: RestoreTier | null, requestSource?: string | null }> | null };

export type RecordingsQueryVariables = Exact<{
  searchDateInput: SearchDateInput;
}>;


export type RecordingsQuery = { __typename?: 'Query', recordings: Array<{ __typename?: 'RecordingDto', seq: number, deviceSeq?: number | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, barcode?: number | null, fullBarcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, resolution?: string | null, videoLength?: number | null, captureCount?: number | null, s3Bucket?: string | null, s3FileKey?: string | null, s3Class?: string | null, streamingStatus?: string | null, recordingUrl?: string | null, thumbnailUrl?: string | null, signedRecordingUrl?: string | null, signedThumbnailUrl?: string | null, recordedAt?: any | null, createdAt: any, updatedAt: any, net30Flag?: boolean | null, totalRestoreCount?: number | null, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null, device?: { __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any } | null, latestRestoreHistory?: { __typename?: 'RecordingRestoreHistoryDto', seq: number, countryCode: string, recordingSeq: number, restoreRequestedAt: any, restoreRequestedDays: number, restoredDetectedAt?: any | null, restoreExpiresAt?: any | null, status: RestoreStatus, restoreTier?: RestoreTier | null, requestSource?: string | null } | null, restoreHistories?: Array<{ __typename?: 'RecordingRestoreHistoryDto', seq: number, countryCode: string, recordingSeq: number, restoreRequestedAt: any, restoreRequestedDays: number, restoredDetectedAt?: any | null, restoreExpiresAt?: any | null, status: RestoreStatus, restoreTier?: RestoreTier | null, requestSource?: string | null }> | null }> };

export type PaginatedRecordingsQueryVariables = Exact<{
  listOptions: RecordingListOptions;
}>;


export type PaginatedRecordingsQuery = { __typename?: 'Query', paginatedRecordings: { __typename?: 'PaginatedRecording', nodes: Array<{ __typename?: 'RecordingDto', seq: number, deviceSeq?: number | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, barcode?: number | null, fullBarcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, resolution?: string | null, videoLength?: number | null, captureCount?: number | null, s3Bucket?: string | null, s3FileKey?: string | null, s3Class?: string | null, streamingStatus?: string | null, recordingUrl?: string | null, thumbnailUrl?: string | null, signedRecordingUrl?: string | null, signedThumbnailUrl?: string | null, recordedAt?: any | null, createdAt: any, updatedAt: any, net30Flag?: boolean | null, totalRestoreCount?: number | null, hospital?: { __typename?: 'HospitalDto', seq: number, hospitalName: string, realName: string, description: string, regionAlias: string, country: string, province: string, city: string, address: string, street: string, zipcode: string, telephone: string, deviceAlertPhone: string, homepage?: string | null, memo?: string | null, activeFlag: boolean, isMaternity: boolean, isPinkBarcode?: any | null, useTelemedicineFlag: boolean, useNiptFlag: boolean, useLibreFlag: boolean, useBabyMagicFlag: boolean, useQrPaymentFlag: boolean, crystalRevealMode: number, migrationServiceProvider: string, migrationServiceActiveFlag: boolean, defaultBlindRecording: boolean, defaultBlindCapture: boolean, streamingStop: boolean, lat: number, lng: number, contractDate?: any | null, paidBarcodeDate?: any | null, subscriptionDurationDays?: number | null, createdAt: any, updatedAt: any } | null, hospitalRoom?: { __typename?: 'HospitalRoomDto', seq: number, activeFlag: boolean, hospitalSeq: number, roomName?: string | null, doctorName?: string | null, memo?: string | null } | null, device?: { __typename?: 'DeviceDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceName?: string | null, description?: string | null, activeFlag?: boolean | null, installFlag?: boolean | null, cfg1_max_recording_time?: number | null, cfg1_motion_threshold?: number | null, cfg1_use_printer_cp1300?: boolean | null, cfg1_use_diary_capture?: boolean | null, cfg1_capture_sw_mode?: string | null, cfg1_capture_sound_level?: number | null, cfg1_pause_resume_sound_enabled?: boolean | null, cfg1_recording_brightness?: number | null, cfg1_recording_contrast?: number | null, cfg1_recording_card_select_mode?: string | null, cfg1_capture_on_recording?: boolean | null, cfg1_check_invalid_barcode?: boolean | null, cfg1_check_expired_barcode?: number | null, cfg1_check_pink_barcode?: number | null, cfg1_check_pink_barcode_period?: number | null, cfg1_pink_barcode_valid_days?: number | null, cfg1_motion_timeout?: number | null, cfg1_check_screensaver: boolean, cfg1_image_quality_check_enabled: boolean, cfg1_recording_media_validation_enabled?: boolean | null, cfg1_recording_video_freeze_threshold_sec?: number | null, cfg1_check_online: boolean, cfg1_auto_update: boolean, cfg1_update_target?: string | null, cfg1_debug_mode: boolean, cfg1_vsync?: string | null, cfg1_threshold_luminance?: number | null, cfg1_max_consecutive_image_issues?: number | null, cfg1_color_imbalance_threshold?: number | null, cfg1_file_min_growth_rate?: number | null, cfg1_file_growth_learning_enabled: boolean, cfg1_file_check_interval?: number | null, cfg1_file_max_failures?: number | null, cfg1_file_max_failures_for_error?: number | null, cfg1_video_min_duration_ratio?: number | null, cfg1_notification_feedback?: number | null, createdAt: any, updatedAt: any } | null, latestRestoreHistory?: { __typename?: 'RecordingRestoreHistoryDto', seq: number, countryCode: string, recordingSeq: number, restoreRequestedAt: any, restoreRequestedDays: number, restoredDetectedAt?: any | null, restoreExpiresAt?: any | null, status: RestoreStatus, restoreTier?: RestoreTier | null, requestSource?: string | null } | null, restoreHistories?: Array<{ __typename?: 'RecordingRestoreHistoryDto', seq: number, countryCode: string, recordingSeq: number, restoreRequestedAt: any, restoreRequestedDays: number, restoredDetectedAt?: any | null, restoreExpiresAt?: any | null, status: RestoreStatus, restoreTier?: RestoreTier | null, requestSource?: string | null }> | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type FirstRecordingBarcodesQueryVariables = Exact<{
  input: FirstRecordingBarcodeExportInput;
}>;


export type FirstRecordingBarcodesQuery = { __typename?: 'Query', firstRecordingBarcodes: Array<{ __typename?: 'FirstRecordingBarcodeExportRow', barcode: string, recordedAt: string, hospitalSeq: number, hospitalName: string, userName: string, userPhoneNumber: string }> };

export type SendFirstRecordingBarcodeMessagesMutationVariables = Exact<{
  input: FirstRecordingBarcodeMessageSendInput;
}>;


export type SendFirstRecordingBarcodeMessagesMutation = { __typename?: 'Mutation', sendFirstRecordingBarcodeMessages: { __typename?: 'FirstRecordingBarcodeMessageSendResult', status: boolean, requestedCount: number, sentCount: number, skippedCount: number, failedCount: number, message?: string | null } };

export type GetUltrasoundCapturesByRecordingQueryVariables = Exact<{
  seq: Scalars['Float']['input'];
}>;


export type GetUltrasoundCapturesByRecordingQuery = { __typename?: 'Query', getUltrasoundCaptureByRecording: { __typename?: 'UltrasoundCaptureByRecording', count: number, captures?: Array<{ __typename?: 'UltrasoundCaptureDto', seq: number, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceSeq?: number | null, barcode?: string | null, patientId?: string | null, deleteFlag?: boolean | null, fileId?: string | null, s3Bucket?: string | null, s3FileKey?: string | null, captureUrl?: string | null, signedCaptureUrl?: string | null, capturedAt?: any | null, createdAt: any, updatedAt: any }> | null } };

export type GetMothersMembersQueryVariables = Exact<{
  listOptions: ListOptions;
}>;


export type GetMothersMembersQuery = { __typename?: 'Query', getMothersMembers: { __typename?: 'PaginatedMothersMember', nodes: Array<{ __typename?: 'MothersMemberDto', mIdx: number, mId: string, mPhone?: string | null, mName?: string | null, mNickname?: string | null, mEmail?: string | null, mRegiste?: any | null, mHidx?: number | null, mChartNum?: string | null, mDateOfBirth?: any | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type GetMothersVideosQueryVariables = Exact<{
  chartnumber: Scalars['String']['input'];
}>;


export type GetMothersVideosQuery = { __typename?: 'Query', getMothersVideos: Array<{ __typename?: 'MothersVideolistDto', seq: number, checked?: boolean | null, s3StorageClass?: string | null, migrationStatus?: string | null, migrationStatusMessage?: string | null, vHname?: string | null, vLocation?: string | null, vChartnumber?: string | null, vOriginChartnumber?: string | null, vRegiste?: any | null, vFilelocation?: string | null, vFilename?: string | null, vFilesize?: number | null }> };

export type GetHumangateMembersQueryVariables = Exact<{
  listOptions: ListOptions;
}>;


export type GetHumangateMembersQuery = { __typename?: 'Query', getHumangateMembers: { __typename?: 'PaginatedHumangateMember', nodes: Array<{ __typename?: 'HumangateMemberDto', seq: number, no?: number | null, name?: string | null, phone?: string | null, barcode?: string | null }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type GetHumangateVideosQueryVariables = Exact<{
  barcode: Scalars['String']['input'];
}>;


export type GetHumangateVideosQuery = { __typename?: 'Query', getHumangateVideos: Array<{ __typename?: 'HumangateVideolistDto', fileName: string, fileSize: number, recordedAt?: any | null }> };

export type SearchRecordingsByBarcodeQueryVariables = Exact<{
  barcode: Scalars['String']['input'];
}>;


export type SearchRecordingsByBarcodeQuery = { __typename?: 'Query', searchRecordingsByBarcode: Array<{ __typename?: 'RecordingSearchDto', seq: number, fileId?: string | null, hospitalName: string, hospitalRoomName: string, recordedAt?: any | null, videoLength?: number | null }> };

export type StoppedRecordingRestoreSummaryQueryVariables = Exact<{
  barcode: Scalars['String']['input'];
}>;


export type StoppedRecordingRestoreSummaryQuery = { __typename?: 'Query', stoppedRecordingRestoreSummary: Array<{ __typename?: 'StoppedRecordingRestoreHospital', hospitalSeq: number, hospitalName: string, disabledCount: number, restorableCount: number, unrestorableCount: number }> };

export type StoppedRecordingRestoreCandidatesQueryVariables = Exact<{
  barcode: Scalars['String']['input'];
  hospitalSeq: Scalars['Int']['input'];
}>;


export type StoppedRecordingRestoreCandidatesQuery = { __typename?: 'Query', stoppedRecordingRestoreCandidates: Array<{ __typename?: 'StoppedRecordingRestoreCandidate', seq: number, fullBarcode?: string | null, fileId?: string | null, recordedAt?: any | null, currentS3FileKey?: string | null, expectedS3FileKey?: string | null, restorable: boolean, failureReason?: string | null }> };

export type PaginatedStoppedRecordingRestoreHistoriesQueryVariables = Exact<{
  listOptions: StoppedRecordingRestoreHistoryListOptions;
}>;


export type PaginatedStoppedRecordingRestoreHistoriesQuery = { __typename?: 'Query', paginatedStoppedRecordingRestoreHistories: { __typename?: 'PaginatedStoppedRecordingRestoreHistory', nodes: Array<{ __typename?: 'StoppedRecordingRestoreHistory', seq: number, hospitalSeq: number, hospitalName?: string | null, barcode: string, actorIdentity: string, reason: string, requestedCount: number, restoredCount: number, failedCount: number, createdAt: any, recordings: Array<{ __typename?: 'StoppedRecordingRestoreHistoryRecording', recordingSeq: number, fullBarcode?: string | null, fileId?: string | null, fromS3FileKey?: string | null, toS3FileKey?: string | null, status: string, failureReason?: string | null }> }>, meta: { __typename?: 'PaginationMeta', page: number, limit: number, totalCount: number, totalPage?: number | null, offset?: number | null } } };

export type PaginatedSpecialBarcodesQueryVariables = Exact<{
  listOptions?: InputMaybe<SpecialBarcodeListOptions>;
}>;


export type PaginatedSpecialBarcodesQuery = { __typename?: 'Query', paginatedSpecialBarcodes: { __typename?: 'PaginatedSpecialBarcodeDto', nodes: Array<{ __typename?: 'SpecialBarcodeEntity', seq: number, barcode: string, type: string, reason?: string | null, createdBy?: string | null, createdAt: any, updatedAt: any }>, meta: { __typename?: 'PaginationMeta', totalCount: number, page: number, limit: number } } };

export type SpecialBarcodeQueryVariables = Exact<{
  seq: Scalars['Int']['input'];
}>;


export type SpecialBarcodeQuery = { __typename?: 'Query', specialBarcode: { __typename?: 'SpecialBarcodeEntity', seq: number, barcode: string, type: string, reason?: string | null, createdBy?: string | null, createdAt: any, updatedAt: any } };

export type GetSystemSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemSettingsQuery = { __typename?: 'Query', systemSettings: Array<{ __typename?: 'SystemSettingsDto', id: number, settingKey: string, description?: string | null, value?: string | null, defaultValue?: string | null, dataType: SystemSettingDataType, constraints?: any | null, availableValues?: any | null, isRequired: boolean, isActive: boolean, displayOrder: number, createdAt: any, updatedAt: any, updatedBy?: string | null }> };

export type GetSystemSettingQueryVariables = Exact<{
  settingKey: Scalars['String']['input'];
}>;


export type GetSystemSettingQuery = { __typename?: 'Query', systemSetting: { __typename?: 'SystemSettingsDto', settingKey: string, description?: string | null, value?: string | null, defaultValue?: string | null, dataType: SystemSettingDataType, constraints?: any | null, availableValues?: any | null } };

export type GetSystemSettingValueQueryVariables = Exact<{
  settingKey: Scalars['String']['input'];
}>;


export type GetSystemSettingValueQuery = { __typename?: 'Query', systemSettingValue?: string | null };

export type GetTestBarcodeQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  hospitalSeq: Scalars['Float']['input'];
  recordedAt: Scalars['String']['input'];
}>;


export type GetTestBarcodeQuery = { __typename?: 'Query', getTestBarcode: { __typename?: 'TestBarcodeResult', barcode?: string | null } };

export type AdminUserQueryVariables = Exact<{
  userPassword: Scalars['String']['input'];
}>;


export type AdminUserQuery = { __typename?: 'Query', adminUser?: { __typename?: 'TokenResult', status?: boolean | null, affected?: number | null, message?: string | null, seq: string, userDisplayName: string, userEmail: string, enabledFlag: boolean, superFlag: boolean, accessToken?: string | null } | null };

export type DeviceUpdateSubscriptionVariables = Exact<{
  hospitalSeq: Scalars['Float']['input'];
}>;


export type DeviceUpdateSubscription = { __typename?: 'Subscription', deviceUpdate: { __typename?: 'DeviceDto', seq: number, deviceName?: string | null, hospitalSeq?: number | null, hospitalRoomSeq?: number | null, deviceState?: { __typename?: 'DeviceStateDto', version?: string | null, captureBoardType?: string | null, captureBoardStatus?: string | null, isConnected?: boolean | null, isRecording?: boolean | null, isUploading?: boolean | null, status?: string | null, acme?: any | null, diskUsage?: string | null, ip?: string | null, connectedAt?: any | null, updatedAt?: any | null, scanned?: { __typename?: 'ScannedInfo', text?: string | null, timestamp?: any | null } | null, screenshot?: { __typename?: 'ScreenshotInfo', timestamp?: any | null, base64Data?: string | null } | null, stats?: { __typename?: 'DeviceStatsState', recording?: number | null, uploading?: number | null } | null } | null, agentState?: { __typename?: 'AgentStateDto', isConnected?: boolean | null, agentVersion?: string | null, connectedAt?: any | null, updatedAt?: any | null, agentSsh?: { __typename?: 'AgentSshInfo', action?: string | null, host?: string | null, port?: number | null, status?: string | null, error?: string | null } | null } | null } };

export const UltrasoundCaptureFragmentDoc = gql`
    fragment UltrasoundCaptureFragment on UltrasoundCaptureDto {
  seq
  hospitalSeq
  hospitalRoomSeq
  deviceSeq
  barcode
  patientId
  deleteFlag
  fileId
  s3Bucket
  s3FileKey
  captureUrl
  signedCaptureUrl
  capturedAt
  createdAt
  updatedAt
}
    `;
export const CrmFragmentDoc = gql`
    fragment CrmFragment on CrmDto {
  seq
  hospitalSeq
  hospitalRoomSeq
  crmTypeSeq
  actorIdentity
  crmStatus
  visitDate
  visitMemo
  description
  slackMessageId
  slackPermaLink
  slackTaNudge
  createdAt
  updatedAt
}
    `;
export const CrmTypeFragmentDoc = gql`
    fragment CrmTypeFragment on CrmTypeDto {
  seq
  typeName
  activeFlag
  createdAt
  updatedAt
}
    `;
export const ChannelTalkRequestFragmentDoc = gql`
    fragment ChannelTalkRequestFragment on ChannelTalkRequest {
  seq
  workflowType
  executionMode
  status
  channelId
  channelTalkUserId
  userChatId
  userName
  submitData
  recordingSeq
  sourceBarcode
  targetBarcode
  recordedAt
  hospitalSeq
  hospitalRoomSeq
  hospitalName
  hospitalRoomName
  reviewReason
  slackMessageTs
  slackChannelId
  messageSentFlag
  responseMessageText
  responseMessageSentAt
  resultMessage
  decisionBy
  decisionAt
  decisionSource
  executedBy
  executedAt
  createdAt
  updatedAt
}
    `;
export const ActivityLogFragmentDoc = gql`
    fragment ActivityLogFragment on ActivityLogDto {
  seq
  hospitalSeq
  hospitalRoomSeq
  deviceSeq
  barcode
  activityType
  actorIdentity
  reason
  description
  detailLog
  createdAt
  updatedAt
}
    `;
export const SessionFragmentDoc = gql`
    fragment SessionFragment on SessionDto {
  deviceSeq
  barcode
  fileId
  status
  scanned
  recordingCount
  captureCount
  startedAt
  motionPassedAt
  stoppedAt
  finishedAt
  uploadedAt
}
    `;
export const DeviceFragmentDoc = gql`
    fragment DeviceFragment on DeviceDto {
  seq
  hospitalSeq
  hospitalRoomSeq
  deviceName
  description
  activeFlag
  installFlag
  cfg1_max_recording_time
  cfg1_motion_threshold
  cfg1_use_printer_cp1300
  cfg1_use_diary_capture
  cfg1_capture_sw_mode
  cfg1_capture_sound_level
  cfg1_pause_resume_sound_enabled
  cfg1_recording_brightness
  cfg1_recording_contrast
  cfg1_recording_card_select_mode
  cfg1_capture_on_recording
  cfg1_check_invalid_barcode
  cfg1_check_expired_barcode
  cfg1_check_pink_barcode
  cfg1_check_pink_barcode_period
  cfg1_pink_barcode_valid_days
  cfg1_motion_timeout
  cfg1_check_screensaver
  cfg1_image_quality_check_enabled
  cfg1_recording_media_validation_enabled
  cfg1_recording_video_freeze_threshold_sec
  cfg1_check_online
  cfg1_auto_update
  cfg1_update_target
  cfg1_debug_mode
  cfg1_vsync
  cfg1_threshold_luminance
  cfg1_max_consecutive_image_issues
  cfg1_color_imbalance_threshold
  cfg1_file_min_growth_rate
  cfg1_file_growth_learning_enabled
  cfg1_file_check_interval
  cfg1_file_max_failures
  cfg1_file_max_failures_for_error
  cfg1_video_min_duration_ratio
  cfg1_notification_feedback
  createdAt
  updatedAt
}
    `;
export const DeviceStateFragmentDoc = gql`
    fragment DeviceStateFragment on DeviceStateDto {
  version
  captureBoardType
  captureBoardStatus
  isConnected
  isRecording
  isUploading
  status
  scanned {
    text
    timestamp
  }
  screenshot {
    timestamp
    base64Data
  }
  stats {
    recording
    uploading
  }
  acme
  diskUsage
  ip
  connectedAt
  updatedAt
}
    `;
export const AgentStateFragmentDoc = gql`
    fragment AgentStateFragment on AgentStateDto {
  isConnected
  agentVersion
  agentSsh {
    action
    host
    port
    status
    error
  }
  connectedAt
  updatedAt
}
    `;
export const HospitalRoomFragmentDoc = gql`
    fragment HospitalRoomFragment on HospitalRoomDto {
  seq
  activeFlag
  hospitalSeq
  roomName
  doctorName
  memo
}
    `;
export const HospitalFragmentDoc = gql`
    fragment HospitalFragment on HospitalDto {
  seq
  hospitalName
  realName
  description
  regionAlias
  country
  province
  city
  address
  street
  zipcode
  telephone
  deviceAlertPhone
  homepage
  memo
  activeFlag
  isMaternity
  isPinkBarcode
  useTelemedicineFlag
  useNiptFlag
  useLibreFlag
  useBabyMagicFlag
  useQrPaymentFlag
  crystalRevealMode
  migrationServiceProvider
  migrationServiceActiveFlag
  defaultBlindRecording
  defaultBlindCapture
  streamingStop
  lat
  lng
  contractDate
  paidBarcodeDate
  isPinkBarcode
  subscriptionDurationDays
  createdAt
  updatedAt
}
    `;
export const HospitalRoomWithHospitalFragmentDoc = gql`
    fragment HospitalRoomWithHospitalFragment on HospitalRoomDto {
  seq
  activeFlag
  hospitalSeq
  roomName
  doctorName
  memo
  hospital {
    ...HospitalFragment
  }
}
    ${HospitalFragmentDoc}`;
export const HospitalLoginPermissionFragmentDoc = gql`
    fragment HospitalLoginPermissionFragment on HospitalLoginPermissionDto {
  seq
  hospitalLoginSeq
  video_play
  video_detail_search
  video_download
  device_list
  nipt_admin
  libre_admin
  telemedicine_admin
  stats_display
  medical_record_display
  video_blind
  createdAt
  updatedAt
}
    `;
export const HospitalLoginFragmentDoc = gql`
    fragment HospitalLoginFragment on HospitalLoginDto {
  seq
  hospitalSeq
  permissionSeq
  hospitalId
  hospitalPassword
  rawPassword
  createdAt
  updatedAt
  deletedAt
}
    `;
export const SubscriptionInfoFragmentDoc = gql`
    fragment SubscriptionInfoFragment on HospitalSubscriptionInfoDto {
  hospitalSeq
  hospitalName
  subscriptionDurationDays
  contractDate
  paidBarcodeDate
  activeFlag
  subscriptionEndDate
  remainingDays
}
    `;
export const PaginationMetaFragmentDoc = gql`
    fragment PaginationMetaFragment on PaginationMeta {
  page
  limit
  totalCount
  totalPage
  offset
}
    `;
export const RestoreHistoryFragmentDoc = gql`
    fragment RestoreHistoryFragment on RecordingRestoreHistoryDto {
  seq
  countryCode
  recordingSeq
  restoreRequestedAt
  restoreRequestedDays
  restoredDetectedAt
  restoreExpiresAt
  status
  restoreTier
  requestSource
}
    `;
export const RecordingFragmentDoc = gql`
    fragment RecordingFragment on RecordingDto {
  seq
  deviceSeq
  hospitalSeq
  hospitalRoomSeq
  barcode
  fullBarcode
  patientId
  deleteFlag
  fileId
  resolution
  videoLength
  captureCount
  s3Bucket
  s3FileKey
  s3Class
  streamingStatus
  recordingUrl
  thumbnailUrl
  signedRecordingUrl
  signedThumbnailUrl
  recordedAt
  createdAt
  updatedAt
  net30Flag
  latestRestoreHistory {
    ...RestoreHistoryFragment
  }
  restoreHistories {
    ...RestoreHistoryFragment
  }
  totalRestoreCount
}
    ${RestoreHistoryFragmentDoc}`;
export const GoogleLoginDocument = gql`
    mutation GoogleLogin($googleAccessToken: String!) {
  googleLogin(googleAccessToken: $googleAccessToken) {
    status
    affected
    message
    seq
    userDisplayName
    userEmail
    enabledFlag
    superFlag
    accessToken
  }
}
    `;

/**
 * __useGoogleLoginMutation__
 *
 * To run a mutation, you first call `useGoogleLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleLoginMutation, { data, loading, error }] = useGoogleLoginMutation({
 *   variables: {
 *      googleAccessToken: // value for 'googleAccessToken'
 *   },
 * });
 */
export function useGoogleLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GoogleLoginMutation, GoogleLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GoogleLoginMutation, GoogleLoginMutationVariables>(GoogleLoginDocument, options);
      }
export type GoogleLoginMutationHookResult = ReturnType<typeof useGoogleLoginMutation>;
export type GoogleLoginMutationResult = ReturnType<typeof useGoogleLoginMutation>;
export type GoogleLoginMutationOptions = Apollo.MutationOptions<GoogleLoginMutation, GoogleLoginMutationVariables>;
export const UpsertUltrasoundCaptureDocument = gql`
    mutation UpsertUltrasoundCapture($ultrasoundCaptureUpsert: UltrasoundCaptureInput!) {
  upsertUltrasoundCapture(ultrasoundCaptureUpsert: $ultrasoundCaptureUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertUltrasoundCaptureMutation__
 *
 * To run a mutation, you first call `useUpsertUltrasoundCaptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUltrasoundCaptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUltrasoundCaptureMutation, { data, loading, error }] = useUpsertUltrasoundCaptureMutation({
 *   variables: {
 *      ultrasoundCaptureUpsert: // value for 'ultrasoundCaptureUpsert'
 *   },
 * });
 */
export function useUpsertUltrasoundCaptureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertUltrasoundCaptureMutation, UpsertUltrasoundCaptureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertUltrasoundCaptureMutation, UpsertUltrasoundCaptureMutationVariables>(UpsertUltrasoundCaptureDocument, options);
      }
export type UpsertUltrasoundCaptureMutationHookResult = ReturnType<typeof useUpsertUltrasoundCaptureMutation>;
export type UpsertUltrasoundCaptureMutationResult = ReturnType<typeof useUpsertUltrasoundCaptureMutation>;
export type UpsertUltrasoundCaptureMutationOptions = Apollo.MutationOptions<UpsertUltrasoundCaptureMutation, UpsertUltrasoundCaptureMutationVariables>;
export const BlindUltrasoundCapturesDocument = gql`
    mutation BlindUltrasoundCaptures($recordingSeq: Float!, $deleteFlag: Boolean!) {
  blindUltrasoundCaptures(recordingSeq: $recordingSeq, deleteFlag: $deleteFlag) {
    affected
    status
    message
  }
}
    `;

/**
 * __useBlindUltrasoundCapturesMutation__
 *
 * To run a mutation, you first call `useBlindUltrasoundCapturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlindUltrasoundCapturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blindUltrasoundCapturesMutation, { data, loading, error }] = useBlindUltrasoundCapturesMutation({
 *   variables: {
 *      recordingSeq: // value for 'recordingSeq'
 *      deleteFlag: // value for 'deleteFlag'
 *   },
 * });
 */
export function useBlindUltrasoundCapturesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlindUltrasoundCapturesMutation, BlindUltrasoundCapturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlindUltrasoundCapturesMutation, BlindUltrasoundCapturesMutationVariables>(BlindUltrasoundCapturesDocument, options);
      }
export type BlindUltrasoundCapturesMutationHookResult = ReturnType<typeof useBlindUltrasoundCapturesMutation>;
export type BlindUltrasoundCapturesMutationResult = ReturnType<typeof useBlindUltrasoundCapturesMutation>;
export type BlindUltrasoundCapturesMutationOptions = Apollo.MutationOptions<BlindUltrasoundCapturesMutation, BlindUltrasoundCapturesMutationVariables>;
export const UploadCaptureDocument = gql`
    mutation UploadCapture($captureUploadInput: CaptureUploadInput!, $reason: String!) {
  uploadCapture(captureUploadInput: $captureUploadInput, reason: $reason) {
    status
    message
  }
}
    `;

/**
 * __useUploadCaptureMutation__
 *
 * To run a mutation, you first call `useUploadCaptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCaptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCaptureMutation, { data, loading, error }] = useUploadCaptureMutation({
 *   variables: {
 *      captureUploadInput: // value for 'captureUploadInput'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUploadCaptureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadCaptureMutation, UploadCaptureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadCaptureMutation, UploadCaptureMutationVariables>(UploadCaptureDocument, options);
      }
export type UploadCaptureMutationHookResult = ReturnType<typeof useUploadCaptureMutation>;
export type UploadCaptureMutationResult = ReturnType<typeof useUploadCaptureMutation>;
export type UploadCaptureMutationOptions = Apollo.MutationOptions<UploadCaptureMutation, UploadCaptureMutationVariables>;
export const UpsertCrmDocument = gql`
    mutation UpsertCrm($crmUpsert: CrmInput!) {
  upsertCrm(crmUpsert: $crmUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertCrmMutation__
 *
 * To run a mutation, you first call `useUpsertCrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCrmMutation, { data, loading, error }] = useUpsertCrmMutation({
 *   variables: {
 *      crmUpsert: // value for 'crmUpsert'
 *   },
 * });
 */
export function useUpsertCrmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertCrmMutation, UpsertCrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertCrmMutation, UpsertCrmMutationVariables>(UpsertCrmDocument, options);
      }
export type UpsertCrmMutationHookResult = ReturnType<typeof useUpsertCrmMutation>;
export type UpsertCrmMutationResult = ReturnType<typeof useUpsertCrmMutation>;
export type UpsertCrmMutationOptions = Apollo.MutationOptions<UpsertCrmMutation, UpsertCrmMutationVariables>;
export const DeleteCrmDocument = gql`
    mutation DeleteCrm($seq: Float!) {
  deleteCrm(seq: $seq) {
    affected
    status
    message
  }
}
    `;

/**
 * __useDeleteCrmMutation__
 *
 * To run a mutation, you first call `useDeleteCrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCrmMutation, { data, loading, error }] = useDeleteCrmMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useDeleteCrmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCrmMutation, DeleteCrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCrmMutation, DeleteCrmMutationVariables>(DeleteCrmDocument, options);
      }
export type DeleteCrmMutationHookResult = ReturnType<typeof useDeleteCrmMutation>;
export type DeleteCrmMutationResult = ReturnType<typeof useDeleteCrmMutation>;
export type DeleteCrmMutationOptions = Apollo.MutationOptions<DeleteCrmMutation, DeleteCrmMutationVariables>;
export const UpsertCrmTypeDocument = gql`
    mutation UpsertCrmType($crmTypeUpsert: CrmTypeInput!) {
  upsertCrmType(crmTypeUpsert: $crmTypeUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertCrmTypeMutation__
 *
 * To run a mutation, you first call `useUpsertCrmTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCrmTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCrmTypeMutation, { data, loading, error }] = useUpsertCrmTypeMutation({
 *   variables: {
 *      crmTypeUpsert: // value for 'crmTypeUpsert'
 *   },
 * });
 */
export function useUpsertCrmTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertCrmTypeMutation, UpsertCrmTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertCrmTypeMutation, UpsertCrmTypeMutationVariables>(UpsertCrmTypeDocument, options);
      }
export type UpsertCrmTypeMutationHookResult = ReturnType<typeof useUpsertCrmTypeMutation>;
export type UpsertCrmTypeMutationResult = ReturnType<typeof useUpsertCrmTypeMutation>;
export type UpsertCrmTypeMutationOptions = Apollo.MutationOptions<UpsertCrmTypeMutation, UpsertCrmTypeMutationVariables>;
export const ApproveChannelTalkRequestDocument = gql`
    mutation ApproveChannelTalkRequest($seq: Int!, $sendMessage: Boolean) {
  approveChannelTalkRequest(seq: $seq, sendMessage: $sendMessage) {
    success
    message
    request {
      ...ChannelTalkRequestFragment
    }
  }
}
    ${ChannelTalkRequestFragmentDoc}`;

/**
 * __useApproveChannelTalkRequestMutation__
 *
 * To run a mutation, you first call `useApproveChannelTalkRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveChannelTalkRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveChannelTalkRequestMutation, { data, loading, error }] = useApproveChannelTalkRequestMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      sendMessage: // value for 'sendMessage'
 *   },
 * });
 */
export function useApproveChannelTalkRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveChannelTalkRequestMutation, ApproveChannelTalkRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApproveChannelTalkRequestMutation, ApproveChannelTalkRequestMutationVariables>(ApproveChannelTalkRequestDocument, options);
      }
export type ApproveChannelTalkRequestMutationHookResult = ReturnType<typeof useApproveChannelTalkRequestMutation>;
export type ApproveChannelTalkRequestMutationResult = ReturnType<typeof useApproveChannelTalkRequestMutation>;
export type ApproveChannelTalkRequestMutationOptions = Apollo.MutationOptions<ApproveChannelTalkRequestMutation, ApproveChannelTalkRequestMutationVariables>;
export const BulkApproveChannelTalkRequestsDocument = gql`
    mutation BulkApproveChannelTalkRequests($seqs: [Int!]!) {
  bulkApproveChannelTalkRequests(seqs: $seqs) {
    successCount
    failureCount
    results {
      success
      message
      request {
        ...ChannelTalkRequestFragment
      }
    }
  }
}
    ${ChannelTalkRequestFragmentDoc}`;

/**
 * __useBulkApproveChannelTalkRequestsMutation__
 *
 * To run a mutation, you first call `useBulkApproveChannelTalkRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkApproveChannelTalkRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkApproveChannelTalkRequestsMutation, { data, loading, error }] = useBulkApproveChannelTalkRequestsMutation({
 *   variables: {
 *      seqs: // value for 'seqs'
 *   },
 * });
 */
export function useBulkApproveChannelTalkRequestsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkApproveChannelTalkRequestsMutation, BulkApproveChannelTalkRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkApproveChannelTalkRequestsMutation, BulkApproveChannelTalkRequestsMutationVariables>(BulkApproveChannelTalkRequestsDocument, options);
      }
export type BulkApproveChannelTalkRequestsMutationHookResult = ReturnType<typeof useBulkApproveChannelTalkRequestsMutation>;
export type BulkApproveChannelTalkRequestsMutationResult = ReturnType<typeof useBulkApproveChannelTalkRequestsMutation>;
export type BulkApproveChannelTalkRequestsMutationOptions = Apollo.MutationOptions<BulkApproveChannelTalkRequestsMutation, BulkApproveChannelTalkRequestsMutationVariables>;
export const RejectChannelTalkRequestDocument = gql`
    mutation RejectChannelTalkRequest($seq: Int!, $reason: String, $responseMessage: String) {
  rejectChannelTalkRequest(
    seq: $seq
    reason: $reason
    responseMessage: $responseMessage
  ) {
    success
    message
    request {
      ...ChannelTalkRequestFragment
    }
  }
}
    ${ChannelTalkRequestFragmentDoc}`;

/**
 * __useRejectChannelTalkRequestMutation__
 *
 * To run a mutation, you first call `useRejectChannelTalkRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectChannelTalkRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectChannelTalkRequestMutation, { data, loading, error }] = useRejectChannelTalkRequestMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      reason: // value for 'reason'
 *      responseMessage: // value for 'responseMessage'
 *   },
 * });
 */
export function useRejectChannelTalkRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectChannelTalkRequestMutation, RejectChannelTalkRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectChannelTalkRequestMutation, RejectChannelTalkRequestMutationVariables>(RejectChannelTalkRequestDocument, options);
      }
export type RejectChannelTalkRequestMutationHookResult = ReturnType<typeof useRejectChannelTalkRequestMutation>;
export type RejectChannelTalkRequestMutationResult = ReturnType<typeof useRejectChannelTalkRequestMutation>;
export type RejectChannelTalkRequestMutationOptions = Apollo.MutationOptions<RejectChannelTalkRequestMutation, RejectChannelTalkRequestMutationVariables>;
export const DuplicateRecordingDocument = gql`
    mutation DuplicateRecording($seq: Float!, $targetBarcode: String!, $reason: String!) {
  duplicateRecording(seq: $seq, targetBarcode: $targetBarcode, reason: $reason) {
    affected
    status
    message
  }
}
    `;

/**
 * __useDuplicateRecordingMutation__
 *
 * To run a mutation, you first call `useDuplicateRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateRecordingMutation, { data, loading, error }] = useDuplicateRecordingMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      targetBarcode: // value for 'targetBarcode'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDuplicateRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateRecordingMutation, DuplicateRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateRecordingMutation, DuplicateRecordingMutationVariables>(DuplicateRecordingDocument, options);
      }
export type DuplicateRecordingMutationHookResult = ReturnType<typeof useDuplicateRecordingMutation>;
export type DuplicateRecordingMutationResult = ReturnType<typeof useDuplicateRecordingMutation>;
export type DuplicateRecordingMutationOptions = Apollo.MutationOptions<DuplicateRecordingMutation, DuplicateRecordingMutationVariables>;
export const UpsertRecordingDocument = gql`
    mutation UpsertRecording($recordingUpsert: RecordingInput!, $reason: String!) {
  upsertRecording(recordingUpsert: $recordingUpsert, reason: $reason) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertRecordingMutation__
 *
 * To run a mutation, you first call `useUpsertRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRecordingMutation, { data, loading, error }] = useUpsertRecordingMutation({
 *   variables: {
 *      recordingUpsert: // value for 'recordingUpsert'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpsertRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRecordingMutation, UpsertRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertRecordingMutation, UpsertRecordingMutationVariables>(UpsertRecordingDocument, options);
      }
export type UpsertRecordingMutationHookResult = ReturnType<typeof useUpsertRecordingMutation>;
export type UpsertRecordingMutationResult = ReturnType<typeof useUpsertRecordingMutation>;
export type UpsertRecordingMutationOptions = Apollo.MutationOptions<UpsertRecordingMutation, UpsertRecordingMutationVariables>;
export const EditRecordingDocument = gql`
    mutation EditRecording($seq: Float!, $startTime: String!, $duration: Float!, $reason: String!) {
  editRecording(
    seq: $seq
    startTime: $startTime
    duration: $duration
    reason: $reason
  ) {
    affected
    status
    message
  }
}
    `;

/**
 * __useEditRecordingMutation__
 *
 * To run a mutation, you first call `useEditRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRecordingMutation, { data, loading, error }] = useEditRecordingMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      startTime: // value for 'startTime'
 *      duration: // value for 'duration'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useEditRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditRecordingMutation, EditRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditRecordingMutation, EditRecordingMutationVariables>(EditRecordingDocument, options);
      }
export type EditRecordingMutationHookResult = ReturnType<typeof useEditRecordingMutation>;
export type EditRecordingMutationResult = ReturnType<typeof useEditRecordingMutation>;
export type EditRecordingMutationOptions = Apollo.MutationOptions<EditRecordingMutation, EditRecordingMutationVariables>;
export const OverwriteRecordingDocument = gql`
    mutation OverwriteRecording($seq: Float!, $reason: String!) {
  overwriteRecording(seq: $seq, reason: $reason) {
    affected
    status
    message
  }
}
    `;

/**
 * __useOverwriteRecordingMutation__
 *
 * To run a mutation, you first call `useOverwriteRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverwriteRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overwriteRecordingMutation, { data, loading, error }] = useOverwriteRecordingMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useOverwriteRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OverwriteRecordingMutation, OverwriteRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OverwriteRecordingMutation, OverwriteRecordingMutationVariables>(OverwriteRecordingDocument, options);
      }
export type OverwriteRecordingMutationHookResult = ReturnType<typeof useOverwriteRecordingMutation>;
export type OverwriteRecordingMutationResult = ReturnType<typeof useOverwriteRecordingMutation>;
export type OverwriteRecordingMutationOptions = Apollo.MutationOptions<OverwriteRecordingMutation, OverwriteRecordingMutationVariables>;
export const TransferRecordingDocument = gql`
    mutation TransferRecording($seq: Float!, $targetBarcode: String!, $reason: String!) {
  transferRecording(seq: $seq, targetBarcode: $targetBarcode, reason: $reason) {
    affected
    status
    message
  }
}
    `;

/**
 * __useTransferRecordingMutation__
 *
 * To run a mutation, you first call `useTransferRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferRecordingMutation, { data, loading, error }] = useTransferRecordingMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      targetBarcode: // value for 'targetBarcode'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useTransferRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TransferRecordingMutation, TransferRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TransferRecordingMutation, TransferRecordingMutationVariables>(TransferRecordingDocument, options);
      }
export type TransferRecordingMutationHookResult = ReturnType<typeof useTransferRecordingMutation>;
export type TransferRecordingMutationResult = ReturnType<typeof useTransferRecordingMutation>;
export type TransferRecordingMutationOptions = Apollo.MutationOptions<TransferRecordingMutation, TransferRecordingMutationVariables>;
export const UpsertDeviceDocument = gql`
    mutation UpsertDevice($DeviceUpsert: DeviceInput!) {
  upsertDevice(deviceUpsert: $DeviceUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertDeviceMutation__
 *
 * To run a mutation, you first call `useUpsertDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDeviceMutation, { data, loading, error }] = useUpsertDeviceMutation({
 *   variables: {
 *      DeviceUpsert: // value for 'DeviceUpsert'
 *   },
 * });
 */
export function useUpsertDeviceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertDeviceMutation, UpsertDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertDeviceMutation, UpsertDeviceMutationVariables>(UpsertDeviceDocument, options);
      }
export type UpsertDeviceMutationHookResult = ReturnType<typeof useUpsertDeviceMutation>;
export type UpsertDeviceMutationResult = ReturnType<typeof useUpsertDeviceMutation>;
export type UpsertDeviceMutationOptions = Apollo.MutationOptions<UpsertDeviceMutation, UpsertDeviceMutationVariables>;
export const UpsertDeviceVersionDocument = gql`
    mutation UpsertDeviceVersion($deviceVersionUpsert: DeviceVersionInput!) {
  upsertDeviceVersion(deviceVersionUpsert: $deviceVersionUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertDeviceVersionMutation__
 *
 * To run a mutation, you first call `useUpsertDeviceVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDeviceVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDeviceVersionMutation, { data, loading, error }] = useUpsertDeviceVersionMutation({
 *   variables: {
 *      deviceVersionUpsert: // value for 'deviceVersionUpsert'
 *   },
 * });
 */
export function useUpsertDeviceVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertDeviceVersionMutation, UpsertDeviceVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertDeviceVersionMutation, UpsertDeviceVersionMutationVariables>(UpsertDeviceVersionDocument, options);
      }
export type UpsertDeviceVersionMutationHookResult = ReturnType<typeof useUpsertDeviceVersionMutation>;
export type UpsertDeviceVersionMutationResult = ReturnType<typeof useUpsertDeviceVersionMutation>;
export type UpsertDeviceVersionMutationOptions = Apollo.MutationOptions<UpsertDeviceVersionMutation, UpsertDeviceVersionMutationVariables>;
export const SendCommandDocument = gql`
    mutation SendCommand($deviceName: String!, $command: String!, $acme: JSON) {
  sendCommand(deviceName: $deviceName, command: $command, acme: $acme) {
    affected
    status
    message
  }
}
    `;

/**
 * __useSendCommandMutation__
 *
 * To run a mutation, you first call `useSendCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCommandMutation, { data, loading, error }] = useSendCommandMutation({
 *   variables: {
 *      deviceName: // value for 'deviceName'
 *      command: // value for 'command'
 *      acme: // value for 'acme'
 *   },
 * });
 */
export function useSendCommandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCommandMutation, SendCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendCommandMutation, SendCommandMutationVariables>(SendCommandDocument, options);
      }
export type SendCommandMutationHookResult = ReturnType<typeof useSendCommandMutation>;
export type SendCommandMutationResult = ReturnType<typeof useSendCommandMutation>;
export type SendCommandMutationOptions = Apollo.MutationOptions<SendCommandMutation, SendCommandMutationVariables>;
export const SshOrderDocument = gql`
    mutation SshOrder($deviceName: String!, $action: String!, $host: String!) {
  sshOrder(deviceName: $deviceName, action: $action, host: $host) {
    affected
    status
    message
  }
}
    `;

/**
 * __useSshOrderMutation__
 *
 * To run a mutation, you first call `useSshOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSshOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sshOrderMutation, { data, loading, error }] = useSshOrderMutation({
 *   variables: {
 *      deviceName: // value for 'deviceName'
 *      action: // value for 'action'
 *      host: // value for 'host'
 *   },
 * });
 */
export function useSshOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SshOrderMutation, SshOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SshOrderMutation, SshOrderMutationVariables>(SshOrderDocument, options);
      }
export type SshOrderMutationHookResult = ReturnType<typeof useSshOrderMutation>;
export type SshOrderMutationResult = ReturnType<typeof useSshOrderMutation>;
export type SshOrderMutationOptions = Apollo.MutationOptions<SshOrderMutation, SshOrderMutationVariables>;
export const UpdateAgentDocument = gql`
    mutation UpdateAgent($deviceName: String!, $force: Boolean!) {
  updateAgent(deviceName: $deviceName, force: $force) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpdateAgentMutation__
 *
 * To run a mutation, you first call `useUpdateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentMutation, { data, loading, error }] = useUpdateAgentMutation({
 *   variables: {
 *      deviceName: // value for 'deviceName'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdateAgentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAgentMutation, UpdateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAgentMutation, UpdateAgentMutationVariables>(UpdateAgentDocument, options);
      }
export type UpdateAgentMutationHookResult = ReturnType<typeof useUpdateAgentMutation>;
export type UpdateAgentMutationResult = ReturnType<typeof useUpdateAgentMutation>;
export type UpdateAgentMutationOptions = Apollo.MutationOptions<UpdateAgentMutation, UpdateAgentMutationVariables>;
export const UpdateBoxDocument = gql`
    mutation UpdateBox($deviceName: String!, $version: String!, $silent: Boolean) {
  updateBox(deviceName: $deviceName, version: $version, silent: $silent) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpdateBoxMutation__
 *
 * To run a mutation, you first call `useUpdateBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoxMutation, { data, loading, error }] = useUpdateBoxMutation({
 *   variables: {
 *      deviceName: // value for 'deviceName'
 *      version: // value for 'version'
 *      silent: // value for 'silent'
 *   },
 * });
 */
export function useUpdateBoxMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBoxMutation, UpdateBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBoxMutation, UpdateBoxMutationVariables>(UpdateBoxDocument, options);
      }
export type UpdateBoxMutationHookResult = ReturnType<typeof useUpdateBoxMutation>;
export type UpdateBoxMutationResult = ReturnType<typeof useUpdateBoxMutation>;
export type UpdateBoxMutationOptions = Apollo.MutationOptions<UpdateBoxMutation, UpdateBoxMutationVariables>;
export const BatchCreateDevicesDocument = gql`
    mutation BatchCreateDevices($input: BatchCreateDevicesInput!) {
  batchCreateDevices(input: $input) {
    success
    message
    successCount
    failureCount
    failures {
      deviceName
      description
      errorMessage
    }
  }
}
    `;

/**
 * __useBatchCreateDevicesMutation__
 *
 * To run a mutation, you first call `useBatchCreateDevicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateDevicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateDevicesMutation, { data, loading, error }] = useBatchCreateDevicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateDevicesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchCreateDevicesMutation, BatchCreateDevicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchCreateDevicesMutation, BatchCreateDevicesMutationVariables>(BatchCreateDevicesDocument, options);
      }
export type BatchCreateDevicesMutationHookResult = ReturnType<typeof useBatchCreateDevicesMutation>;
export type BatchCreateDevicesMutationResult = ReturnType<typeof useBatchCreateDevicesMutation>;
export type BatchCreateDevicesMutationOptions = Apollo.MutationOptions<BatchCreateDevicesMutation, BatchCreateDevicesMutationVariables>;
export const ValidateDeviceNamesDocument = gql`
    mutation ValidateDeviceNames($deviceNames: [String!]!) {
  validateDeviceNames(deviceNames: $deviceNames) {
    results {
      deviceName
      isValid
      isDuplicate
      errorMessage
    }
  }
}
    `;

/**
 * __useValidateDeviceNamesMutation__
 *
 * To run a mutation, you first call `useValidateDeviceNamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDeviceNamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDeviceNamesMutation, { data, loading, error }] = useValidateDeviceNamesMutation({
 *   variables: {
 *      deviceNames: // value for 'deviceNames'
 *   },
 * });
 */
export function useValidateDeviceNamesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ValidateDeviceNamesMutation, ValidateDeviceNamesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ValidateDeviceNamesMutation, ValidateDeviceNamesMutationVariables>(ValidateDeviceNamesDocument, options);
      }
export type ValidateDeviceNamesMutationHookResult = ReturnType<typeof useValidateDeviceNamesMutation>;
export type ValidateDeviceNamesMutationResult = ReturnType<typeof useValidateDeviceNamesMutation>;
export type ValidateDeviceNamesMutationOptions = Apollo.MutationOptions<ValidateDeviceNamesMutation, ValidateDeviceNamesMutationVariables>;
export const SetCustomCropTemplateDocument = gql`
    mutation SetCustomCropTemplate($x: Float!, $y: Float!, $w: Float!, $h: Float!) {
  setCustomCropTemplate(x: $x, y: $y, w: $w, h: $h) {
    affected
    status
    message
  }
}
    `;

/**
 * __useSetCustomCropTemplateMutation__
 *
 * To run a mutation, you first call `useSetCustomCropTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomCropTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomCropTemplateMutation, { data, loading, error }] = useSetCustomCropTemplateMutation({
 *   variables: {
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      w: // value for 'w'
 *      h: // value for 'h'
 *   },
 * });
 */
export function useSetCustomCropTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCustomCropTemplateMutation, SetCustomCropTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCustomCropTemplateMutation, SetCustomCropTemplateMutationVariables>(SetCustomCropTemplateDocument, options);
      }
export type SetCustomCropTemplateMutationHookResult = ReturnType<typeof useSetCustomCropTemplateMutation>;
export type SetCustomCropTemplateMutationResult = ReturnType<typeof useSetCustomCropTemplateMutation>;
export type SetCustomCropTemplateMutationOptions = Apollo.MutationOptions<SetCustomCropTemplateMutation, SetCustomCropTemplateMutationVariables>;
export const StartDirectUploadDocument = gql`
    mutation StartDirectUpload($input: StartDirectUploadInputDto!) {
  startDirectUpload(input: $input) {
    jobId
    estimatedDurationMin
    s3Config {
      bucket
      key
      uploadId
      region
      credentials {
        accessKeyId
        secretAccessKey
        sessionToken
        expiration
      }
    }
  }
}
    `;

/**
 * __useStartDirectUploadMutation__
 *
 * To run a mutation, you first call `useStartDirectUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDirectUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDirectUploadMutation, { data, loading, error }] = useStartDirectUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartDirectUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartDirectUploadMutation, StartDirectUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartDirectUploadMutation, StartDirectUploadMutationVariables>(StartDirectUploadDocument, options);
      }
export type StartDirectUploadMutationHookResult = ReturnType<typeof useStartDirectUploadMutation>;
export type StartDirectUploadMutationResult = ReturnType<typeof useStartDirectUploadMutation>;
export type StartDirectUploadMutationOptions = Apollo.MutationOptions<StartDirectUploadMutation, StartDirectUploadMutationVariables>;
export const DeleteDownloadDocument = gql`
    mutation DeleteDownload($jobId: String!) {
  deleteDownload(jobId: $jobId)
}
    `;

/**
 * __useDeleteDownloadMutation__
 *
 * To run a mutation, you first call `useDeleteDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDownloadMutation, { data, loading, error }] = useDeleteDownloadMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteDownloadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDownloadMutation, DeleteDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDownloadMutation, DeleteDownloadMutationVariables>(DeleteDownloadDocument, options);
      }
export type DeleteDownloadMutationHookResult = ReturnType<typeof useDeleteDownloadMutation>;
export type DeleteDownloadMutationResult = ReturnType<typeof useDeleteDownloadMutation>;
export type DeleteDownloadMutationOptions = Apollo.MutationOptions<DeleteDownloadMutation, DeleteDownloadMutationVariables>;
export const UpsertHospitalDocument = gql`
    mutation UpsertHospital($HospitalUpsert: HospitalInput!) {
  upsertHospital(hospitalUpsert: $HospitalUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertHospitalMutation__
 *
 * To run a mutation, you first call `useUpsertHospitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHospitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHospitalMutation, { data, loading, error }] = useUpsertHospitalMutation({
 *   variables: {
 *      HospitalUpsert: // value for 'HospitalUpsert'
 *   },
 * });
 */
export function useUpsertHospitalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertHospitalMutation, UpsertHospitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertHospitalMutation, UpsertHospitalMutationVariables>(UpsertHospitalDocument, options);
      }
export type UpsertHospitalMutationHookResult = ReturnType<typeof useUpsertHospitalMutation>;
export type UpsertHospitalMutationResult = ReturnType<typeof useUpsertHospitalMutation>;
export type UpsertHospitalMutationOptions = Apollo.MutationOptions<UpsertHospitalMutation, UpsertHospitalMutationVariables>;
export const UpsertHospitalLoginDocument = gql`
    mutation UpsertHospitalLogin($hospitalLoginUpsert: HospitalLoginInput!) {
  upsertHospitalLogin(hospitalLoginUpsert: $hospitalLoginUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertHospitalLoginMutation__
 *
 * To run a mutation, you first call `useUpsertHospitalLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHospitalLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHospitalLoginMutation, { data, loading, error }] = useUpsertHospitalLoginMutation({
 *   variables: {
 *      hospitalLoginUpsert: // value for 'hospitalLoginUpsert'
 *   },
 * });
 */
export function useUpsertHospitalLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertHospitalLoginMutation, UpsertHospitalLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertHospitalLoginMutation, UpsertHospitalLoginMutationVariables>(UpsertHospitalLoginDocument, options);
      }
export type UpsertHospitalLoginMutationHookResult = ReturnType<typeof useUpsertHospitalLoginMutation>;
export type UpsertHospitalLoginMutationResult = ReturnType<typeof useUpsertHospitalLoginMutation>;
export type UpsertHospitalLoginMutationOptions = Apollo.MutationOptions<UpsertHospitalLoginMutation, UpsertHospitalLoginMutationVariables>;
export const DeleteHospitalLoginDocument = gql`
    mutation DeleteHospitalLogin($seq: Float!) {
  deleteHospitalLogin(seq: $seq) {
    affected
    status
    message
  }
}
    `;

/**
 * __useDeleteHospitalLoginMutation__
 *
 * To run a mutation, you first call `useDeleteHospitalLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHospitalLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHospitalLoginMutation, { data, loading, error }] = useDeleteHospitalLoginMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useDeleteHospitalLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteHospitalLoginMutation, DeleteHospitalLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteHospitalLoginMutation, DeleteHospitalLoginMutationVariables>(DeleteHospitalLoginDocument, options);
      }
export type DeleteHospitalLoginMutationHookResult = ReturnType<typeof useDeleteHospitalLoginMutation>;
export type DeleteHospitalLoginMutationResult = ReturnType<typeof useDeleteHospitalLoginMutation>;
export type DeleteHospitalLoginMutationOptions = Apollo.MutationOptions<DeleteHospitalLoginMutation, DeleteHospitalLoginMutationVariables>;
export const UpsertHospitalRoomDocument = gql`
    mutation UpsertHospitalRoom($HospitalRoomUpsert: HospitalRoomInput!) {
  upsertHospitalRoom(hospitalRoomUpsert: $HospitalRoomUpsert) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpsertHospitalRoomMutation__
 *
 * To run a mutation, you first call `useUpsertHospitalRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHospitalRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHospitalRoomMutation, { data, loading, error }] = useUpsertHospitalRoomMutation({
 *   variables: {
 *      HospitalRoomUpsert: // value for 'HospitalRoomUpsert'
 *   },
 * });
 */
export function useUpsertHospitalRoomMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertHospitalRoomMutation, UpsertHospitalRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertHospitalRoomMutation, UpsertHospitalRoomMutationVariables>(UpsertHospitalRoomDocument, options);
      }
export type UpsertHospitalRoomMutationHookResult = ReturnType<typeof useUpsertHospitalRoomMutation>;
export type UpsertHospitalRoomMutationResult = ReturnType<typeof useUpsertHospitalRoomMutation>;
export type UpsertHospitalRoomMutationOptions = Apollo.MutationOptions<UpsertHospitalRoomMutation, UpsertHospitalRoomMutationVariables>;
export const UpdateHospitalSubscriptionDocument = gql`
    mutation UpdateHospitalSubscription($hospitalSeq: Float!, $updateData: HospitalSubscriptionUpdateDto!) {
  updateHospitalSubscription(hospitalSeq: $hospitalSeq, updateData: $updateData) {
    affected
    status
    message
  }
}
    `;

/**
 * __useUpdateHospitalSubscription__
 *
 * To run a mutation, you first call `useUpdateHospitalSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHospitalSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHospitalSubscription, { data, loading, error }] = useUpdateHospitalSubscription({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *      updateData: // value for 'updateData'
 *   },
 * });
 */
export function useUpdateHospitalSubscription(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHospitalSubscriptionMutation, UpdateHospitalSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHospitalSubscriptionMutation, UpdateHospitalSubscriptionMutationVariables>(UpdateHospitalSubscriptionDocument, options);
      }
export type UpdateHospitalSubscriptionHookResult = ReturnType<typeof useUpdateHospitalSubscription>;
export type UpdateHospitalSubscriptionMutationResult = ReturnType<typeof useUpdateHospitalSubscription>;
export type UpdateHospitalSubscriptionMutationOptions = Apollo.MutationOptions<UpdateHospitalSubscriptionMutation, UpdateHospitalSubscriptionMutationVariables>;
export const KeycloakLoginCallbackDocument = gql`
    mutation KeycloakLoginCallback($input: KeycloakCodeInput!) {
  keycloakLoginCallback(input: $input) {
    accessToken
    refreshToken
    idToken
    roles
    groups
    seq
    userDisplayName
    userEmail
    enabledFlag
    superFlag
  }
}
    `;

/**
 * __useKeycloakLoginCallbackMutation__
 *
 * To run a mutation, you first call `useKeycloakLoginCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeycloakLoginCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keycloakLoginCallbackMutation, { data, loading, error }] = useKeycloakLoginCallbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKeycloakLoginCallbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<KeycloakLoginCallbackMutation, KeycloakLoginCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<KeycloakLoginCallbackMutation, KeycloakLoginCallbackMutationVariables>(KeycloakLoginCallbackDocument, options);
      }
export type KeycloakLoginCallbackMutationHookResult = ReturnType<typeof useKeycloakLoginCallbackMutation>;
export type KeycloakLoginCallbackMutationResult = ReturnType<typeof useKeycloakLoginCallbackMutation>;
export type KeycloakLoginCallbackMutationOptions = Apollo.MutationOptions<KeycloakLoginCallbackMutation, KeycloakLoginCallbackMutationVariables>;
export const KeycloakTokenReissueDocument = gql`
    mutation KeycloakTokenReissue($refreshToken: String!) {
  keycloakTokenReissue(refreshToken: $refreshToken) {
    accessToken
    refreshToken
    idToken
    roles
    groups
    seq
    userDisplayName
    userEmail
    enabledFlag
    superFlag
  }
}
    `;

/**
 * __useKeycloakTokenReissueMutation__
 *
 * To run a mutation, you first call `useKeycloakTokenReissueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeycloakTokenReissueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keycloakTokenReissueMutation, { data, loading, error }] = useKeycloakTokenReissueMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useKeycloakTokenReissueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<KeycloakTokenReissueMutation, KeycloakTokenReissueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<KeycloakTokenReissueMutation, KeycloakTokenReissueMutationVariables>(KeycloakTokenReissueDocument, options);
      }
export type KeycloakTokenReissueMutationHookResult = ReturnType<typeof useKeycloakTokenReissueMutation>;
export type KeycloakTokenReissueMutationResult = ReturnType<typeof useKeycloakTokenReissueMutation>;
export type KeycloakTokenReissueMutationOptions = Apollo.MutationOptions<KeycloakTokenReissueMutation, KeycloakTokenReissueMutationVariables>;
export const MigrateMothersVideosDocument = gql`
    mutation MigrateMothersVideos($videoSeqs: [Float!]!, $targetHospitalSeq: Float!, $targetBarcode: String!) {
  migrateMothersVideos(
    videoSeqs: $videoSeqs
    targetHospitalSeq: $targetHospitalSeq
    targetBarcode: $targetBarcode
  ) {
    affected
    status
    message
  }
}
    `;

/**
 * __useMigrateMothersVideosMutation__
 *
 * To run a mutation, you first call `useMigrateMothersVideosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateMothersVideosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateMothersVideosMutation, { data, loading, error }] = useMigrateMothersVideosMutation({
 *   variables: {
 *      videoSeqs: // value for 'videoSeqs'
 *      targetHospitalSeq: // value for 'targetHospitalSeq'
 *      targetBarcode: // value for 'targetBarcode'
 *   },
 * });
 */
export function useMigrateMothersVideosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MigrateMothersVideosMutation, MigrateMothersVideosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MigrateMothersVideosMutation, MigrateMothersVideosMutationVariables>(MigrateMothersVideosDocument, options);
      }
export type MigrateMothersVideosMutationHookResult = ReturnType<typeof useMigrateMothersVideosMutation>;
export type MigrateMothersVideosMutationResult = ReturnType<typeof useMigrateMothersVideosMutation>;
export type MigrateMothersVideosMutationOptions = Apollo.MutationOptions<MigrateMothersVideosMutation, MigrateMothersVideosMutationVariables>;
export const MigrateHumangateVideosDocument = gql`
    mutation MigrateHumangateVideos($barcode: String!, $targetHospitalSeq: Float!, $targetBarcode: String!) {
  migrateHumangateVideos(
    barcode: $barcode
    targetHospitalSeq: $targetHospitalSeq
    targetBarcode: $targetBarcode
  ) {
    affected
    status
    message
  }
}
    `;

/**
 * __useMigrateHumangateVideosMutation__
 *
 * To run a mutation, you first call `useMigrateHumangateVideosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateHumangateVideosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateHumangateVideosMutation, { data, loading, error }] = useMigrateHumangateVideosMutation({
 *   variables: {
 *      barcode: // value for 'barcode'
 *      targetHospitalSeq: // value for 'targetHospitalSeq'
 *      targetBarcode: // value for 'targetBarcode'
 *   },
 * });
 */
export function useMigrateHumangateVideosMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MigrateHumangateVideosMutation, MigrateHumangateVideosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MigrateHumangateVideosMutation, MigrateHumangateVideosMutationVariables>(MigrateHumangateVideosDocument, options);
      }
export type MigrateHumangateVideosMutationHookResult = ReturnType<typeof useMigrateHumangateVideosMutation>;
export type MigrateHumangateVideosMutationResult = ReturnType<typeof useMigrateHumangateVideosMutation>;
export type MigrateHumangateVideosMutationOptions = Apollo.MutationOptions<MigrateHumangateVideosMutation, MigrateHumangateVideosMutationVariables>;
export const RefreshRecordingDocument = gql`
    mutation RefreshRecording($seq: Float!) {
  refreshRecording(seq: $seq) {
    affected
    status
    message
  }
}
    `;

/**
 * __useRefreshRecordingMutation__
 *
 * To run a mutation, you first call `useRefreshRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshRecordingMutation, { data, loading, error }] = useRefreshRecordingMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useRefreshRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshRecordingMutation, RefreshRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefreshRecordingMutation, RefreshRecordingMutationVariables>(RefreshRecordingDocument, options);
      }
export type RefreshRecordingMutationHookResult = ReturnType<typeof useRefreshRecordingMutation>;
export type RefreshRecordingMutationResult = ReturnType<typeof useRefreshRecordingMutation>;
export type RefreshRecordingMutationOptions = Apollo.MutationOptions<RefreshRecordingMutation, RefreshRecordingMutationVariables>;
export const RestoreRecordingDocument = gql`
    mutation RestoreRecording($seq: Float!, $reason: String!) {
  restoreRecording(seq: $seq, reason: $reason) {
    affected
    status
    message
  }
}
    `;

/**
 * __useRestoreRecordingMutation__
 *
 * To run a mutation, you first call `useRestoreRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreRecordingMutation, { data, loading, error }] = useRestoreRecordingMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRestoreRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreRecordingMutation, RestoreRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreRecordingMutation, RestoreRecordingMutationVariables>(RestoreRecordingDocument, options);
      }
export type RestoreRecordingMutationHookResult = ReturnType<typeof useRestoreRecordingMutation>;
export type RestoreRecordingMutationResult = ReturnType<typeof useRestoreRecordingMutation>;
export type RestoreRecordingMutationOptions = Apollo.MutationOptions<RestoreRecordingMutation, RestoreRecordingMutationVariables>;
export const RestoreArchivedRecordingDocument = gql`
    mutation RestoreArchivedRecording($seq: Int!, $days: Int!) {
  restoreArchivedRecording(seq: $seq, days: $days) {
    affected
    status
    message
  }
}
    `;

/**
 * __useRestoreArchivedRecordingMutation__
 *
 * To run a mutation, you first call `useRestoreArchivedRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreArchivedRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreArchivedRecordingMutation, { data, loading, error }] = useRestoreArchivedRecordingMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useRestoreArchivedRecordingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreArchivedRecordingMutation, RestoreArchivedRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreArchivedRecordingMutation, RestoreArchivedRecordingMutationVariables>(RestoreArchivedRecordingDocument, options);
      }
export type RestoreArchivedRecordingMutationHookResult = ReturnType<typeof useRestoreArchivedRecordingMutation>;
export type RestoreArchivedRecordingMutationResult = ReturnType<typeof useRestoreArchivedRecordingMutation>;
export type RestoreArchivedRecordingMutationOptions = Apollo.MutationOptions<RestoreArchivedRecordingMutation, RestoreArchivedRecordingMutationVariables>;
export const CheckS3ClassDocument = gql`
    mutation CheckS3Class($seq: Float!) {
  checkS3Class(seq: $seq) {
    affected
    status
    message
  }
}
    `;

/**
 * __useCheckS3ClassMutation__
 *
 * To run a mutation, you first call `useCheckS3ClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckS3ClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkS3ClassMutation, { data, loading, error }] = useCheckS3ClassMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useCheckS3ClassMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CheckS3ClassMutation, CheckS3ClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CheckS3ClassMutation, CheckS3ClassMutationVariables>(CheckS3ClassDocument, options);
      }
export type CheckS3ClassMutationHookResult = ReturnType<typeof useCheckS3ClassMutation>;
export type CheckS3ClassMutationResult = ReturnType<typeof useCheckS3ClassMutation>;
export type CheckS3ClassMutationOptions = Apollo.MutationOptions<CheckS3ClassMutation, CheckS3ClassMutationVariables>;
export const LogRecordingDownloadDocument = gql`
    mutation LogRecordingDownload($seq: Float!, $reason: String!) {
  logRecordingDownload(seq: $seq, reason: $reason) {
    status
    message
  }
}
    `;

/**
 * __useLogRecordingDownloadMutation__
 *
 * To run a mutation, you first call `useLogRecordingDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogRecordingDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logRecordingDownloadMutation, { data, loading, error }] = useLogRecordingDownloadMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useLogRecordingDownloadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogRecordingDownloadMutation, LogRecordingDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogRecordingDownloadMutation, LogRecordingDownloadMutationVariables>(LogRecordingDownloadDocument, options);
      }
export type LogRecordingDownloadMutationHookResult = ReturnType<typeof useLogRecordingDownloadMutation>;
export type LogRecordingDownloadMutationResult = ReturnType<typeof useLogRecordingDownloadMutation>;
export type LogRecordingDownloadMutationOptions = Apollo.MutationOptions<LogRecordingDownloadMutation, LogRecordingDownloadMutationVariables>;
export const RestoreStoppedRecordingsDocument = gql`
    mutation RestoreStoppedRecordings($input: RestoreStoppedRecordingsInput!) {
  restoreStoppedRecordings(input: $input) {
    status
    message
    requestedCount
    restoredCount
    failedCount
    failedItems {
      seq
      fileId
      reason
    }
  }
}
    `;

/**
 * __useRestoreStoppedRecordingsMutation__
 *
 * To run a mutation, you first call `useRestoreStoppedRecordingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreStoppedRecordingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreStoppedRecordingsMutation, { data, loading, error }] = useRestoreStoppedRecordingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreStoppedRecordingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreStoppedRecordingsMutation, RestoreStoppedRecordingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreStoppedRecordingsMutation, RestoreStoppedRecordingsMutationVariables>(RestoreStoppedRecordingsDocument, options);
      }
export type RestoreStoppedRecordingsMutationHookResult = ReturnType<typeof useRestoreStoppedRecordingsMutation>;
export type RestoreStoppedRecordingsMutationResult = ReturnType<typeof useRestoreStoppedRecordingsMutation>;
export type RestoreStoppedRecordingsMutationOptions = Apollo.MutationOptions<RestoreStoppedRecordingsMutation, RestoreStoppedRecordingsMutationVariables>;
export const CreateSpecialBarcodeDocument = gql`
    mutation CreateSpecialBarcode($createSpecialBarcodeInput: CreateSpecialBarcodeInput!) {
  createSpecialBarcode(createSpecialBarcodeInput: $createSpecialBarcodeInput) {
    seq
    barcode
    type
    reason
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateSpecialBarcodeMutation__
 *
 * To run a mutation, you first call `useCreateSpecialBarcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialBarcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialBarcodeMutation, { data, loading, error }] = useCreateSpecialBarcodeMutation({
 *   variables: {
 *      createSpecialBarcodeInput: // value for 'createSpecialBarcodeInput'
 *   },
 * });
 */
export function useCreateSpecialBarcodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSpecialBarcodeMutation, CreateSpecialBarcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSpecialBarcodeMutation, CreateSpecialBarcodeMutationVariables>(CreateSpecialBarcodeDocument, options);
      }
export type CreateSpecialBarcodeMutationHookResult = ReturnType<typeof useCreateSpecialBarcodeMutation>;
export type CreateSpecialBarcodeMutationResult = ReturnType<typeof useCreateSpecialBarcodeMutation>;
export type CreateSpecialBarcodeMutationOptions = Apollo.MutationOptions<CreateSpecialBarcodeMutation, CreateSpecialBarcodeMutationVariables>;
export const BatchCreateSpecialBarcodesDocument = gql`
    mutation BatchCreateSpecialBarcodes($input: BatchCreateSpecialBarcodesInput!) {
  batchCreateSpecialBarcodes(input: $input) {
    success
    message
    successCount
    failureCount
    failures {
      barcode
      errorMessage
    }
  }
}
    `;

/**
 * __useBatchCreateSpecialBarcodesMutation__
 *
 * To run a mutation, you first call `useBatchCreateSpecialBarcodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateSpecialBarcodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateSpecialBarcodesMutation, { data, loading, error }] = useBatchCreateSpecialBarcodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateSpecialBarcodesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchCreateSpecialBarcodesMutation, BatchCreateSpecialBarcodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchCreateSpecialBarcodesMutation, BatchCreateSpecialBarcodesMutationVariables>(BatchCreateSpecialBarcodesDocument, options);
      }
export type BatchCreateSpecialBarcodesMutationHookResult = ReturnType<typeof useBatchCreateSpecialBarcodesMutation>;
export type BatchCreateSpecialBarcodesMutationResult = ReturnType<typeof useBatchCreateSpecialBarcodesMutation>;
export type BatchCreateSpecialBarcodesMutationOptions = Apollo.MutationOptions<BatchCreateSpecialBarcodesMutation, BatchCreateSpecialBarcodesMutationVariables>;
export const UpdateSpecialBarcodeDocument = gql`
    mutation UpdateSpecialBarcode($updateSpecialBarcodeInput: UpdateSpecialBarcodeInput!) {
  updateSpecialBarcode(updateSpecialBarcodeInput: $updateSpecialBarcodeInput) {
    seq
    barcode
    type
    reason
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useUpdateSpecialBarcodeMutation__
 *
 * To run a mutation, you first call `useUpdateSpecialBarcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpecialBarcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpecialBarcodeMutation, { data, loading, error }] = useUpdateSpecialBarcodeMutation({
 *   variables: {
 *      updateSpecialBarcodeInput: // value for 'updateSpecialBarcodeInput'
 *   },
 * });
 */
export function useUpdateSpecialBarcodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSpecialBarcodeMutation, UpdateSpecialBarcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSpecialBarcodeMutation, UpdateSpecialBarcodeMutationVariables>(UpdateSpecialBarcodeDocument, options);
      }
export type UpdateSpecialBarcodeMutationHookResult = ReturnType<typeof useUpdateSpecialBarcodeMutation>;
export type UpdateSpecialBarcodeMutationResult = ReturnType<typeof useUpdateSpecialBarcodeMutation>;
export type UpdateSpecialBarcodeMutationOptions = Apollo.MutationOptions<UpdateSpecialBarcodeMutation, UpdateSpecialBarcodeMutationVariables>;
export const RemoveSpecialBarcodeDocument = gql`
    mutation RemoveSpecialBarcode($seq: Int!, $blindRecording: Boolean) {
  removeSpecialBarcode(seq: $seq, blindRecording: $blindRecording) {
    seq
    barcode
    type
    reason
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useRemoveSpecialBarcodeMutation__
 *
 * To run a mutation, you first call `useRemoveSpecialBarcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSpecialBarcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSpecialBarcodeMutation, { data, loading, error }] = useRemoveSpecialBarcodeMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      blindRecording: // value for 'blindRecording'
 *   },
 * });
 */
export function useRemoveSpecialBarcodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveSpecialBarcodeMutation, RemoveSpecialBarcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveSpecialBarcodeMutation, RemoveSpecialBarcodeMutationVariables>(RemoveSpecialBarcodeDocument, options);
      }
export type RemoveSpecialBarcodeMutationHookResult = ReturnType<typeof useRemoveSpecialBarcodeMutation>;
export type RemoveSpecialBarcodeMutationResult = ReturnType<typeof useRemoveSpecialBarcodeMutation>;
export type RemoveSpecialBarcodeMutationOptions = Apollo.MutationOptions<RemoveSpecialBarcodeMutation, RemoveSpecialBarcodeMutationVariables>;
export const CreateSystemSettingDocument = gql`
    mutation CreateSystemSetting($input: CreateSystemSettingInputDto!) {
  createSystemSetting(input: $input) {
    settingKey
    value
    dataType
  }
}
    `;

/**
 * __useCreateSystemSettingMutation__
 *
 * To run a mutation, you first call `useCreateSystemSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSystemSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSystemSettingMutation, { data, loading, error }] = useCreateSystemSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSystemSettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSystemSettingMutation, CreateSystemSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSystemSettingMutation, CreateSystemSettingMutationVariables>(CreateSystemSettingDocument, options);
      }
export type CreateSystemSettingMutationHookResult = ReturnType<typeof useCreateSystemSettingMutation>;
export type CreateSystemSettingMutationResult = ReturnType<typeof useCreateSystemSettingMutation>;
export type CreateSystemSettingMutationOptions = Apollo.MutationOptions<CreateSystemSettingMutation, CreateSystemSettingMutationVariables>;
export const UpdateSystemSettingDocument = gql`
    mutation UpdateSystemSetting($input: UpdateSystemSettingInputDto!) {
  updateSystemSetting(input: $input) {
    settingKey
    value
  }
}
    `;

/**
 * __useUpdateSystemSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSystemSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemSettingMutation, { data, loading, error }] = useUpdateSystemSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSystemSettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSystemSettingMutation, UpdateSystemSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSystemSettingMutation, UpdateSystemSettingMutationVariables>(UpdateSystemSettingDocument, options);
      }
export type UpdateSystemSettingMutationHookResult = ReturnType<typeof useUpdateSystemSettingMutation>;
export type UpdateSystemSettingMutationResult = ReturnType<typeof useUpdateSystemSettingMutation>;
export type UpdateSystemSettingMutationOptions = Apollo.MutationOptions<UpdateSystemSettingMutation, UpdateSystemSettingMutationVariables>;
export const BatchUpdateSystemSettingsDocument = gql`
    mutation BatchUpdateSystemSettings($input: BatchUpdateSystemSettingsInputDto!) {
  batchUpdateSystemSettings(input: $input) {
    settingKey
    value
  }
}
    `;

/**
 * __useBatchUpdateSystemSettingsMutation__
 *
 * To run a mutation, you first call `useBatchUpdateSystemSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateSystemSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateSystemSettingsMutation, { data, loading, error }] = useBatchUpdateSystemSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchUpdateSystemSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchUpdateSystemSettingsMutation, BatchUpdateSystemSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchUpdateSystemSettingsMutation, BatchUpdateSystemSettingsMutationVariables>(BatchUpdateSystemSettingsDocument, options);
      }
export type BatchUpdateSystemSettingsMutationHookResult = ReturnType<typeof useBatchUpdateSystemSettingsMutation>;
export type BatchUpdateSystemSettingsMutationResult = ReturnType<typeof useBatchUpdateSystemSettingsMutation>;
export type BatchUpdateSystemSettingsMutationOptions = Apollo.MutationOptions<BatchUpdateSystemSettingsMutation, BatchUpdateSystemSettingsMutationVariables>;
export const ResetSystemSettingToDefaultDocument = gql`
    mutation ResetSystemSettingToDefault($settingKey: String!) {
  resetSystemSettingToDefault(settingKey: $settingKey) {
    settingKey
    value
    defaultValue
  }
}
    `;

/**
 * __useResetSystemSettingToDefaultMutation__
 *
 * To run a mutation, you first call `useResetSystemSettingToDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSystemSettingToDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSystemSettingToDefaultMutation, { data, loading, error }] = useResetSystemSettingToDefaultMutation({
 *   variables: {
 *      settingKey: // value for 'settingKey'
 *   },
 * });
 */
export function useResetSystemSettingToDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetSystemSettingToDefaultMutation, ResetSystemSettingToDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetSystemSettingToDefaultMutation, ResetSystemSettingToDefaultMutationVariables>(ResetSystemSettingToDefaultDocument, options);
      }
export type ResetSystemSettingToDefaultMutationHookResult = ReturnType<typeof useResetSystemSettingToDefaultMutation>;
export type ResetSystemSettingToDefaultMutationResult = ReturnType<typeof useResetSystemSettingToDefaultMutation>;
export type ResetSystemSettingToDefaultMutationOptions = Apollo.MutationOptions<ResetSystemSettingToDefaultMutation, ResetSystemSettingToDefaultMutationVariables>;
export const DeleteSystemSettingDocument = gql`
    mutation DeleteSystemSetting($settingKey: String!) {
  deleteSystemSetting(settingKey: $settingKey)
}
    `;

/**
 * __useDeleteSystemSettingMutation__
 *
 * To run a mutation, you first call `useDeleteSystemSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSystemSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSystemSettingMutation, { data, loading, error }] = useDeleteSystemSettingMutation({
 *   variables: {
 *      settingKey: // value for 'settingKey'
 *   },
 * });
 */
export function useDeleteSystemSettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSystemSettingMutation, DeleteSystemSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSystemSettingMutation, DeleteSystemSettingMutationVariables>(DeleteSystemSettingDocument, options);
      }
export type DeleteSystemSettingMutationHookResult = ReturnType<typeof useDeleteSystemSettingMutation>;
export type DeleteSystemSettingMutationResult = ReturnType<typeof useDeleteSystemSettingMutation>;
export type DeleteSystemSettingMutationOptions = Apollo.MutationOptions<DeleteSystemSettingMutation, DeleteSystemSettingMutationVariables>;
export const PaginatedBabyAiListDocument = gql`
    query PaginatedBabyAiList($listOptions: BabyAiListOptions!) {
  paginatedBabyAiList(listOptions: $listOptions) {
    nodes {
      seq
      barcode
      babySeq
      userSeq
      hospitalSeq
      hospitalRoomSeq
      deviceSeq
      fileId
      captureImageS3FileKey
      hiddenBabyImageS3FileKey
      babyMagicImageS3FileKey
      visibleFlag
      billableVisibleFlag
      capturedAt
      createdAt
      updatedAt
      captureUrl
      hiddenBabyUrl
      babyMagicUrl
      signedCaptureUrl
      signedHiddenBabyUrl
      signedBabyMagicUrl
      webhookSentAt
      hospital {
        ...HospitalFragment
      }
      hospitalRoom {
        ...HospitalRoomFragment
      }
    }
    meta {
      page
      limit
      totalCount
      totalPage
      offset
    }
  }
}
    ${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}`;

/**
 * __usePaginatedBabyAiListQuery__
 *
 * To run a query within a React component, call `usePaginatedBabyAiListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedBabyAiListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedBabyAiListQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedBabyAiListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedBabyAiListQuery, PaginatedBabyAiListQueryVariables> & ({ variables: PaginatedBabyAiListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedBabyAiListQuery, PaginatedBabyAiListQueryVariables>(PaginatedBabyAiListDocument, options);
      }
export function usePaginatedBabyAiListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedBabyAiListQuery, PaginatedBabyAiListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedBabyAiListQuery, PaginatedBabyAiListQueryVariables>(PaginatedBabyAiListDocument, options);
        }
// @ts-ignore
export type PaginatedBabyAiListQueryHookResult = ReturnType<typeof usePaginatedBabyAiListQuery>;
export type PaginatedBabyAiListLazyQueryHookResult = ReturnType<typeof usePaginatedBabyAiListLazyQuery>;
export type PaginatedBabyAiListQueryResult = ReturnType<typeof usePaginatedBabyAiListQuery>;
export const UltrasoundCapturesDocument = gql`
    query UltrasoundCaptures($searchDateInput: SearchDateInput!) {
  ultrasoundCaptures(searchDateInput: $searchDateInput) {
    ...UltrasoundCaptureFragment
    hospital {
      ...HospitalFragment
    }
    hospitalRoom {
      ...HospitalRoomFragment
    }
    device {
      ...DeviceFragment
    }
  }
}
    ${UltrasoundCaptureFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${DeviceFragmentDoc}`;

/**
 * __useUltrasoundCapturesQuery__
 *
 * To run a query within a React component, call `useUltrasoundCapturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltrasoundCapturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltrasoundCapturesQuery({
 *   variables: {
 *      searchDateInput: // value for 'searchDateInput'
 *   },
 * });
 */
export function useUltrasoundCapturesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UltrasoundCapturesQuery, UltrasoundCapturesQueryVariables> & ({ variables: UltrasoundCapturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UltrasoundCapturesQuery, UltrasoundCapturesQueryVariables>(UltrasoundCapturesDocument, options);
      }
export function useUltrasoundCapturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UltrasoundCapturesQuery, UltrasoundCapturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UltrasoundCapturesQuery, UltrasoundCapturesQueryVariables>(UltrasoundCapturesDocument, options);
        }
// @ts-ignore
export type UltrasoundCapturesQueryHookResult = ReturnType<typeof useUltrasoundCapturesQuery>;
export type UltrasoundCapturesLazyQueryHookResult = ReturnType<typeof useUltrasoundCapturesLazyQuery>;
export type UltrasoundCapturesQueryResult = ReturnType<typeof useUltrasoundCapturesQuery>;
export const PaginatedUltrasoundCapturesDocument = gql`
    query PaginatedUltrasoundCaptures($listOptions: UltrasoundCaptureListOptions!) {
  paginatedUltrasoundCaptures(listOptions: $listOptions) {
    nodes {
      ...UltrasoundCaptureFragment
      hospital {
        ...HospitalFragment
      }
      hospitalRoom {
        ...HospitalRoomFragment
      }
      device {
        ...DeviceFragment
      }
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${UltrasoundCaptureFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${DeviceFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedUltrasoundCapturesQuery__
 *
 * To run a query within a React component, call `usePaginatedUltrasoundCapturesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedUltrasoundCapturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedUltrasoundCapturesQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedUltrasoundCapturesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedUltrasoundCapturesQuery, PaginatedUltrasoundCapturesQueryVariables> & ({ variables: PaginatedUltrasoundCapturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedUltrasoundCapturesQuery, PaginatedUltrasoundCapturesQueryVariables>(PaginatedUltrasoundCapturesDocument, options);
      }
export function usePaginatedUltrasoundCapturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedUltrasoundCapturesQuery, PaginatedUltrasoundCapturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedUltrasoundCapturesQuery, PaginatedUltrasoundCapturesQueryVariables>(PaginatedUltrasoundCapturesDocument, options);
        }
// @ts-ignore
export type PaginatedUltrasoundCapturesQueryHookResult = ReturnType<typeof usePaginatedUltrasoundCapturesQuery>;
export type PaginatedUltrasoundCapturesLazyQueryHookResult = ReturnType<typeof usePaginatedUltrasoundCapturesLazyQuery>;
export type PaginatedUltrasoundCapturesQueryResult = ReturnType<typeof usePaginatedUltrasoundCapturesQuery>;
export const UltrasoundCapturesByRecordingSeqDocument = gql`
    query UltrasoundCapturesByRecordingSeq($recordingSeq: Float!) {
  ultrasoundCapturesByRecordingSeq(recordingSeq: $recordingSeq) {
    ...UltrasoundCaptureFragment
    hospital {
      ...HospitalFragment
    }
    hospitalRoom {
      ...HospitalRoomFragment
    }
    device {
      ...DeviceFragment
    }
  }
}
    ${UltrasoundCaptureFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${DeviceFragmentDoc}`;

/**
 * __useUltrasoundCapturesByRecordingSeqQuery__
 *
 * To run a query within a React component, call `useUltrasoundCapturesByRecordingSeqQuery` and pass it any options that fit your needs.
 * When your component renders, `useUltrasoundCapturesByRecordingSeqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUltrasoundCapturesByRecordingSeqQuery({
 *   variables: {
 *      recordingSeq: // value for 'recordingSeq'
 *   },
 * });
 */
export function useUltrasoundCapturesByRecordingSeqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UltrasoundCapturesByRecordingSeqQuery, UltrasoundCapturesByRecordingSeqQueryVariables> & ({ variables: UltrasoundCapturesByRecordingSeqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UltrasoundCapturesByRecordingSeqQuery, UltrasoundCapturesByRecordingSeqQueryVariables>(UltrasoundCapturesByRecordingSeqDocument, options);
      }
export function useUltrasoundCapturesByRecordingSeqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UltrasoundCapturesByRecordingSeqQuery, UltrasoundCapturesByRecordingSeqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UltrasoundCapturesByRecordingSeqQuery, UltrasoundCapturesByRecordingSeqQueryVariables>(UltrasoundCapturesByRecordingSeqDocument, options);
        }
// @ts-ignore
export type UltrasoundCapturesByRecordingSeqQueryHookResult = ReturnType<typeof useUltrasoundCapturesByRecordingSeqQuery>;
export type UltrasoundCapturesByRecordingSeqLazyQueryHookResult = ReturnType<typeof useUltrasoundCapturesByRecordingSeqLazyQuery>;
export type UltrasoundCapturesByRecordingSeqQueryResult = ReturnType<typeof useUltrasoundCapturesByRecordingSeqQuery>;
export const CrmsDocument = gql`
    query Crms($searchOptions: SearchDateInput) {
  crms(searchOptions: $searchOptions) {
    ...CrmFragment
    crmType {
      ...CrmTypeFragment
    }
    hospital {
      ...HospitalFragment
    }
    hospitalRoom {
      ...HospitalRoomFragment
    }
  }
}
    ${CrmFragmentDoc}
${CrmTypeFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}`;

/**
 * __useCrmsQuery__
 *
 * To run a query within a React component, call `useCrmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmsQuery({
 *   variables: {
 *      searchOptions: // value for 'searchOptions'
 *   },
 * });
 */
export function useCrmsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CrmsQuery, CrmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CrmsQuery, CrmsQueryVariables>(CrmsDocument, options);
      }
export function useCrmsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CrmsQuery, CrmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CrmsQuery, CrmsQueryVariables>(CrmsDocument, options);
        }
// @ts-ignore
export type CrmsQueryHookResult = ReturnType<typeof useCrmsQuery>;
export type CrmsLazyQueryHookResult = ReturnType<typeof useCrmsLazyQuery>;
export type CrmsQueryResult = ReturnType<typeof useCrmsQuery>;
export const PaginatedCrmsDocument = gql`
    query PaginatedCrms($listOptions: CrmListOptions!) {
  paginatedCrms(listOptions: $listOptions) {
    nodes {
      ...CrmFragment
      crmType {
        ...CrmTypeFragment
      }
      hospital {
        ...HospitalFragment
      }
      hospitalRoom {
        ...HospitalRoomFragment
      }
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${CrmFragmentDoc}
${CrmTypeFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedCrmsQuery__
 *
 * To run a query within a React component, call `usePaginatedCrmsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedCrmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedCrmsQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedCrmsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedCrmsQuery, PaginatedCrmsQueryVariables> & ({ variables: PaginatedCrmsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedCrmsQuery, PaginatedCrmsQueryVariables>(PaginatedCrmsDocument, options);
      }
export function usePaginatedCrmsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedCrmsQuery, PaginatedCrmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedCrmsQuery, PaginatedCrmsQueryVariables>(PaginatedCrmsDocument, options);
        }
// @ts-ignore
export type PaginatedCrmsQueryHookResult = ReturnType<typeof usePaginatedCrmsQuery>;
export type PaginatedCrmsLazyQueryHookResult = ReturnType<typeof usePaginatedCrmsLazyQuery>;
export type PaginatedCrmsQueryResult = ReturnType<typeof usePaginatedCrmsQuery>;
export const CrmsByCrmTypesDocument = gql`
    query CrmsByCrmTypes {
  crmTypes {
    ...CrmTypeFragment
    crms {
      ...CrmFragment
    }
  }
}
    ${CrmTypeFragmentDoc}
${CrmFragmentDoc}`;

/**
 * __useCrmsByCrmTypesQuery__
 *
 * To run a query within a React component, call `useCrmsByCrmTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmsByCrmTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmsByCrmTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmsByCrmTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CrmsByCrmTypesQuery, CrmsByCrmTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CrmsByCrmTypesQuery, CrmsByCrmTypesQueryVariables>(CrmsByCrmTypesDocument, options);
      }
export function useCrmsByCrmTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CrmsByCrmTypesQuery, CrmsByCrmTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CrmsByCrmTypesQuery, CrmsByCrmTypesQueryVariables>(CrmsByCrmTypesDocument, options);
        }
// @ts-ignore
export type CrmsByCrmTypesQueryHookResult = ReturnType<typeof useCrmsByCrmTypesQuery>;
export type CrmsByCrmTypesLazyQueryHookResult = ReturnType<typeof useCrmsByCrmTypesLazyQuery>;
export type CrmsByCrmTypesQueryResult = ReturnType<typeof useCrmsByCrmTypesQuery>;
export const CrmTypesDocument = gql`
    query CrmTypes {
  crmTypes {
    ...CrmTypeFragment
  }
}
    ${CrmTypeFragmentDoc}`;

/**
 * __useCrmTypesQuery__
 *
 * To run a query within a React component, call `useCrmTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CrmTypesQuery, CrmTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CrmTypesQuery, CrmTypesQueryVariables>(CrmTypesDocument, options);
      }
export function useCrmTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CrmTypesQuery, CrmTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CrmTypesQuery, CrmTypesQueryVariables>(CrmTypesDocument, options);
        }
// @ts-ignore
export type CrmTypesQueryHookResult = ReturnType<typeof useCrmTypesQuery>;
export type CrmTypesLazyQueryHookResult = ReturnType<typeof useCrmTypesLazyQuery>;
export type CrmTypesQueryResult = ReturnType<typeof useCrmTypesQuery>;
export const ChannelTalkRequestsDocument = gql`
    query ChannelTalkRequests($listOptions: ChannelTalkRequestFilter!) {
  channelTalkRequests(listOptions: $listOptions) {
    nodes {
      ...ChannelTalkRequestFragment
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${ChannelTalkRequestFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __useChannelTalkRequestsQuery__
 *
 * To run a query within a React component, call `useChannelTalkRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelTalkRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelTalkRequestsQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function useChannelTalkRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChannelTalkRequestsQuery, ChannelTalkRequestsQueryVariables> & ({ variables: ChannelTalkRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChannelTalkRequestsQuery, ChannelTalkRequestsQueryVariables>(ChannelTalkRequestsDocument, options);
      }
export function useChannelTalkRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChannelTalkRequestsQuery, ChannelTalkRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChannelTalkRequestsQuery, ChannelTalkRequestsQueryVariables>(ChannelTalkRequestsDocument, options);
        }
// @ts-ignore
export type ChannelTalkRequestsQueryHookResult = ReturnType<typeof useChannelTalkRequestsQuery>;
export type ChannelTalkRequestsLazyQueryHookResult = ReturnType<typeof useChannelTalkRequestsLazyQuery>;
export type ChannelTalkRequestsQueryResult = ReturnType<typeof useChannelTalkRequestsQuery>;
export const GetRecordingPresignedUrlDocument = gql`
    query GetRecordingPresignedUrl($seq: Float!) {
  getRecordingPresignedUrl(seq: $seq) {
    affected
    status
    message
  }
}
    `;

/**
 * __useGetRecordingPresignedUrlQuery__
 *
 * To run a query within a React component, call `useGetRecordingPresignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingPresignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingPresignedUrlQuery({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useGetRecordingPresignedUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRecordingPresignedUrlQuery, GetRecordingPresignedUrlQueryVariables> & ({ variables: GetRecordingPresignedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecordingPresignedUrlQuery, GetRecordingPresignedUrlQueryVariables>(GetRecordingPresignedUrlDocument, options);
      }
export function useGetRecordingPresignedUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecordingPresignedUrlQuery, GetRecordingPresignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecordingPresignedUrlQuery, GetRecordingPresignedUrlQueryVariables>(GetRecordingPresignedUrlDocument, options);
        }
// @ts-ignore
export type GetRecordingPresignedUrlQueryHookResult = ReturnType<typeof useGetRecordingPresignedUrlQuery>;
export type GetRecordingPresignedUrlLazyQueryHookResult = ReturnType<typeof useGetRecordingPresignedUrlLazyQuery>;
export type GetRecordingPresignedUrlQueryResult = ReturnType<typeof useGetRecordingPresignedUrlQuery>;
export const ActivityLogsDocument = gql`
    query ActivityLogs($searchDateInput: SearchDateInput) {
  activityLogs(searchDateInput: $searchDateInput) {
    ...ActivityLogFragment
  }
}
    ${ActivityLogFragmentDoc}`;

/**
 * __useActivityLogsQuery__
 *
 * To run a query within a React component, call `useActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogsQuery({
 *   variables: {
 *      searchDateInput: // value for 'searchDateInput'
 *   },
 * });
 */
export function useActivityLogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
      }
export function useActivityLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
        }
// @ts-ignore
export type ActivityLogsQueryHookResult = ReturnType<typeof useActivityLogsQuery>;
export type ActivityLogsLazyQueryHookResult = ReturnType<typeof useActivityLogsLazyQuery>;
export type ActivityLogsQueryResult = ReturnType<typeof useActivityLogsQuery>;
export const PaginatedActivityLogsDocument = gql`
    query PaginatedActivityLogs($listOptions: ActivityLogListOptions!) {
  paginatedActivityLogs(listOptions: $listOptions) {
    nodes {
      ...ActivityLogFragment
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${ActivityLogFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedActivityLogsQuery__
 *
 * To run a query within a React component, call `usePaginatedActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedActivityLogsQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedActivityLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedActivityLogsQuery, PaginatedActivityLogsQueryVariables> & ({ variables: PaginatedActivityLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedActivityLogsQuery, PaginatedActivityLogsQueryVariables>(PaginatedActivityLogsDocument, options);
      }
export function usePaginatedActivityLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedActivityLogsQuery, PaginatedActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedActivityLogsQuery, PaginatedActivityLogsQueryVariables>(PaginatedActivityLogsDocument, options);
        }
// @ts-ignore
export type PaginatedActivityLogsQueryHookResult = ReturnType<typeof usePaginatedActivityLogsQuery>;
export type PaginatedActivityLogsLazyQueryHookResult = ReturnType<typeof usePaginatedActivityLogsLazyQuery>;
export type PaginatedActivityLogsQueryResult = ReturnType<typeof usePaginatedActivityLogsQuery>;
export const FailedUploadRecoveryDocument = gql`
    query FailedUploadRecovery($failedUploadRecoveryInputDto: FailedUploadRecoveryInputDto!) {
  failedUploadRecovery(
    failedUploadRecoveryInputDto: $failedUploadRecoveryInputDto
  ) {
    urls
    status
    message
  }
}
    `;

/**
 * __useFailedUploadRecoveryQuery__
 *
 * To run a query within a React component, call `useFailedUploadRecoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedUploadRecoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedUploadRecoveryQuery({
 *   variables: {
 *      failedUploadRecoveryInputDto: // value for 'failedUploadRecoveryInputDto'
 *   },
 * });
 */
export function useFailedUploadRecoveryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FailedUploadRecoveryQuery, FailedUploadRecoveryQueryVariables> & ({ variables: FailedUploadRecoveryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FailedUploadRecoveryQuery, FailedUploadRecoveryQueryVariables>(FailedUploadRecoveryDocument, options);
      }
export function useFailedUploadRecoveryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FailedUploadRecoveryQuery, FailedUploadRecoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FailedUploadRecoveryQuery, FailedUploadRecoveryQueryVariables>(FailedUploadRecoveryDocument, options);
        }
// @ts-ignore
export type FailedUploadRecoveryQueryHookResult = ReturnType<typeof useFailedUploadRecoveryQuery>;
export type FailedUploadRecoveryLazyQueryHookResult = ReturnType<typeof useFailedUploadRecoveryLazyQuery>;
export type FailedUploadRecoveryQueryResult = ReturnType<typeof useFailedUploadRecoveryQuery>;
export const PaginatedUploadLogsDocument = gql`
    query PaginatedUploadLogs($listOptions: UploadListOptions!) {
  paginatedUploadLogs(listOptions: $listOptions) {
    nodes {
      deviceName
      hospitalName
      roomName
      fullBarcode
      fileId
      status
      scannedAt
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedUploadLogsQuery__
 *
 * To run a query within a React component, call `usePaginatedUploadLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedUploadLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedUploadLogsQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedUploadLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedUploadLogsQuery, PaginatedUploadLogsQueryVariables> & ({ variables: PaginatedUploadLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedUploadLogsQuery, PaginatedUploadLogsQueryVariables>(PaginatedUploadLogsDocument, options);
      }
export function usePaginatedUploadLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedUploadLogsQuery, PaginatedUploadLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedUploadLogsQuery, PaginatedUploadLogsQueryVariables>(PaginatedUploadLogsDocument, options);
        }
// @ts-ignore
export type PaginatedUploadLogsQueryHookResult = ReturnType<typeof usePaginatedUploadLogsQuery>;
export type PaginatedUploadLogsLazyQueryHookResult = ReturnType<typeof usePaginatedUploadLogsLazyQuery>;
export type PaginatedUploadLogsQueryResult = ReturnType<typeof usePaginatedUploadLogsQuery>;
export const PaginatedSessionsDocument = gql`
    query PaginatedSessions($listOptions: SessionListOptions!) {
  paginatedSessions(listOptions: $listOptions) {
    nodes {
      ...SessionFragment
      device {
        ...DeviceFragment
      }
      hospital {
        ...HospitalFragment
      }
      hospitalRoom {
        ...HospitalRoomFragment
      }
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${SessionFragmentDoc}
${DeviceFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedSessionsQuery__
 *
 * To run a query within a React component, call `usePaginatedSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedSessionsQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedSessionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedSessionsQuery, PaginatedSessionsQueryVariables> & ({ variables: PaginatedSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedSessionsQuery, PaginatedSessionsQueryVariables>(PaginatedSessionsDocument, options);
      }
export function usePaginatedSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedSessionsQuery, PaginatedSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedSessionsQuery, PaginatedSessionsQueryVariables>(PaginatedSessionsDocument, options);
        }
// @ts-ignore
export type PaginatedSessionsQueryHookResult = ReturnType<typeof usePaginatedSessionsQuery>;
export type PaginatedSessionsLazyQueryHookResult = ReturnType<typeof usePaginatedSessionsLazyQuery>;
export type PaginatedSessionsQueryResult = ReturnType<typeof usePaginatedSessionsQuery>;
export const DevicesDocument = gql`
    query Devices($hospitalSeq: Float) {
  devices(hospitalSeq: $hospitalSeq) {
    ...DeviceFragment
    hospitalRoom {
      roomName
    }
  }
}
    ${DeviceFragmentDoc}`;

/**
 * __useDevicesQuery__
 *
 * To run a query within a React component, call `useDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesQuery({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useDevicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DevicesQuery, DevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevicesQuery, DevicesQueryVariables>(DevicesDocument, options);
      }
export function useDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevicesQuery, DevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevicesQuery, DevicesQueryVariables>(DevicesDocument, options);
        }
// @ts-ignore
export type DevicesQueryHookResult = ReturnType<typeof useDevicesQuery>;
export type DevicesLazyQueryHookResult = ReturnType<typeof useDevicesLazyQuery>;
export type DevicesQueryResult = ReturnType<typeof useDevicesQuery>;
export const DevicesWithStateDocument = gql`
    query DevicesWithState($hospitalSeq: Float) {
  devices(hospitalSeq: $hospitalSeq) {
    ...DeviceFragment
    deviceState {
      ...DeviceStateFragment
    }
    agentState {
      ...AgentStateFragment
    }
  }
}
    ${DeviceFragmentDoc}
${DeviceStateFragmentDoc}
${AgentStateFragmentDoc}`;

/**
 * __useDevicesWithStateQuery__
 *
 * To run a query within a React component, call `useDevicesWithStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesWithStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesWithStateQuery({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useDevicesWithStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DevicesWithStateQuery, DevicesWithStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevicesWithStateQuery, DevicesWithStateQueryVariables>(DevicesWithStateDocument, options);
      }
export function useDevicesWithStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevicesWithStateQuery, DevicesWithStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevicesWithStateQuery, DevicesWithStateQueryVariables>(DevicesWithStateDocument, options);
        }
// @ts-ignore
export type DevicesWithStateQueryHookResult = ReturnType<typeof useDevicesWithStateQuery>;
export type DevicesWithStateLazyQueryHookResult = ReturnType<typeof useDevicesWithStateLazyQuery>;
export type DevicesWithStateQueryResult = ReturnType<typeof useDevicesWithStateQuery>;
export const PaginatedDevicesDocument = gql`
    query PaginatedDevices($listOptions: DeviceListOptions!) {
  paginatedDevices(listOptions: $listOptions) {
    nodes {
      ...DeviceFragment
      deviceState {
        version
        status
        updatedAt
      }
      agentState {
        agentVersion
      }
      hospital {
        ...HospitalFragment
      }
      hospitalRoom {
        ...HospitalRoomFragment
      }
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${DeviceFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedDevicesQuery__
 *
 * To run a query within a React component, call `usePaginatedDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedDevicesQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedDevicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedDevicesQuery, PaginatedDevicesQueryVariables> & ({ variables: PaginatedDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedDevicesQuery, PaginatedDevicesQueryVariables>(PaginatedDevicesDocument, options);
      }
export function usePaginatedDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedDevicesQuery, PaginatedDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedDevicesQuery, PaginatedDevicesQueryVariables>(PaginatedDevicesDocument, options);
        }
// @ts-ignore
export type PaginatedDevicesQueryHookResult = ReturnType<typeof usePaginatedDevicesQuery>;
export type PaginatedDevicesLazyQueryHookResult = ReturnType<typeof usePaginatedDevicesLazyQuery>;
export type PaginatedDevicesQueryResult = ReturnType<typeof usePaginatedDevicesQuery>;
export const DeviceVersionsDocument = gql`
    query DeviceVersions {
  deviceVersions {
    seq
    versionName
    buildNum
    buildHash
    versionDescription
    versionDate
    visibleFlag
    autoUpdate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useDeviceVersionsQuery__
 *
 * To run a query within a React component, call `useDeviceVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceVersionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DeviceVersionsQuery, DeviceVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeviceVersionsQuery, DeviceVersionsQueryVariables>(DeviceVersionsDocument, options);
      }
export function useDeviceVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeviceVersionsQuery, DeviceVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeviceVersionsQuery, DeviceVersionsQueryVariables>(DeviceVersionsDocument, options);
        }
// @ts-ignore
export type DeviceVersionsQueryHookResult = ReturnType<typeof useDeviceVersionsQuery>;
export type DeviceVersionsLazyQueryHookResult = ReturnType<typeof useDeviceVersionsLazyQuery>;
export type DeviceVersionsQueryResult = ReturnType<typeof useDeviceVersionsQuery>;
export const GetBoxLogDocument = gql`
    query GetBoxLog($deviceName: String!, $date: DateTime!) {
  getBoxLog(deviceName: $deviceName, date: $date) {
    rawLog
    sessionLogs {
      barcode
      startedAt
      fileId
      segment
      motion {
        start
        end
        duration
      }
      scan {
        scanned
        scannedAt
      }
      record {
        start
        end
        duration
      }
      upload {
        status
        uploadedAt
      }
    }
  }
}
    `;

/**
 * __useGetBoxLogQuery__
 *
 * To run a query within a React component, call `useGetBoxLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoxLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoxLogQuery({
 *   variables: {
 *      deviceName: // value for 'deviceName'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetBoxLogQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBoxLogQuery, GetBoxLogQueryVariables> & ({ variables: GetBoxLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBoxLogQuery, GetBoxLogQueryVariables>(GetBoxLogDocument, options);
      }
export function useGetBoxLogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBoxLogQuery, GetBoxLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBoxLogQuery, GetBoxLogQueryVariables>(GetBoxLogDocument, options);
        }
// @ts-ignore
export type GetBoxLogQueryHookResult = ReturnType<typeof useGetBoxLogQuery>;
export type GetBoxLogLazyQueryHookResult = ReturnType<typeof useGetBoxLogLazyQuery>;
export type GetBoxLogQueryResult = ReturnType<typeof useGetBoxLogQuery>;
export const DeviceNotificationsDocument = gql`
    query DeviceNotifications($deviceName: String!, $date: DateTime!, $listOptions: DeviceNotificationListOptions!) {
  deviceNotifications(
    deviceName: $deviceName
    date: $date
    listOptions: $listOptions
  ) {
    nodes {
      id
      occurredAt
      severity
      code
      message
      barcode
      fileId
      statusSummary
      slackStatus
      slackPermalink
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${PaginationMetaFragmentDoc}`;

/**
 * __useDeviceNotificationsQuery__
 *
 * To run a query within a React component, call `useDeviceNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceNotificationsQuery({
 *   variables: {
 *      deviceName: // value for 'deviceName'
 *      date: // value for 'date'
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function useDeviceNotificationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeviceNotificationsQuery, DeviceNotificationsQueryVariables> & ({ variables: DeviceNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeviceNotificationsQuery, DeviceNotificationsQueryVariables>(DeviceNotificationsDocument, options);
      }
export function useDeviceNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeviceNotificationsQuery, DeviceNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeviceNotificationsQuery, DeviceNotificationsQueryVariables>(DeviceNotificationsDocument, options);
        }
// @ts-ignore
export type DeviceNotificationsQueryHookResult = ReturnType<typeof useDeviceNotificationsQuery>;
export type DeviceNotificationsLazyQueryHookResult = ReturnType<typeof useDeviceNotificationsLazyQuery>;
export type DeviceNotificationsQueryResult = ReturnType<typeof useDeviceNotificationsQuery>;
export const GetCropTemplatesDocument = gql`
    query GetCropTemplates {
  getCropTemplates
}
    `;

/**
 * __useGetCropTemplatesQuery__
 *
 * To run a query within a React component, call `useGetCropTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCropTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCropTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCropTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCropTemplatesQuery, GetCropTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCropTemplatesQuery, GetCropTemplatesQueryVariables>(GetCropTemplatesDocument, options);
      }
export function useGetCropTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCropTemplatesQuery, GetCropTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCropTemplatesQuery, GetCropTemplatesQueryVariables>(GetCropTemplatesDocument, options);
        }
// @ts-ignore
export type GetCropTemplatesQueryHookResult = ReturnType<typeof useGetCropTemplatesQuery>;
export type GetCropTemplatesLazyQueryHookResult = ReturnType<typeof useGetCropTemplatesLazyQuery>;
export type GetCropTemplatesQueryResult = ReturnType<typeof useGetCropTemplatesQuery>;
export const TestAutoRecordingDocument = gql`
    query testAutoRecording($deviceName: String!, $barcode: String!) {
  testAutoRecording(deviceName: $deviceName, barcode: $barcode) {
    status
    message
  }
}
    `;

/**
 * __useTestAutoRecordingQuery__
 *
 * To run a query within a React component, call `useTestAutoRecordingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestAutoRecordingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestAutoRecordingQuery({
 *   variables: {
 *      deviceName: // value for 'deviceName'
 *      barcode: // value for 'barcode'
 *   },
 * });
 */
export function useTestAutoRecordingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TestAutoRecordingQuery, TestAutoRecordingQueryVariables> & ({ variables: TestAutoRecordingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TestAutoRecordingQuery, TestAutoRecordingQueryVariables>(TestAutoRecordingDocument, options);
      }
export function useTestAutoRecordingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TestAutoRecordingQuery, TestAutoRecordingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TestAutoRecordingQuery, TestAutoRecordingQueryVariables>(TestAutoRecordingDocument, options);
        }
// @ts-ignore
export type TestAutoRecordingQueryHookResult = ReturnType<typeof useTestAutoRecordingQuery>;
export type TestAutoRecordingLazyQueryHookResult = ReturnType<typeof useTestAutoRecordingLazyQuery>;
export type TestAutoRecordingQueryResult = ReturnType<typeof useTestAutoRecordingQuery>;
export const MyDownloadsDocument = gql`
    query MyDownloads($status: DownloadJobStatus, $limit: Int) {
  myDownloads(status: $status, limit: $limit) {
    jobId
    deviceName
    filePath
    fileSize
    status
    progress
    totalChunks
    completedChunks
    downloadUrl
    createdAt
    completedAt
    expiresAt
    networkQuality
    uploadSpeed
    errorMessage
  }
}
    `;

/**
 * __useMyDownloadsQuery__
 *
 * To run a query within a React component, call `useMyDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDownloadsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMyDownloadsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyDownloadsQuery, MyDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyDownloadsQuery, MyDownloadsQueryVariables>(MyDownloadsDocument, options);
      }
export function useMyDownloadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyDownloadsQuery, MyDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyDownloadsQuery, MyDownloadsQueryVariables>(MyDownloadsDocument, options);
        }
// @ts-ignore
export type MyDownloadsQueryHookResult = ReturnType<typeof useMyDownloadsQuery>;
export type MyDownloadsLazyQueryHookResult = ReturnType<typeof useMyDownloadsLazyQuery>;
export type MyDownloadsQueryResult = ReturnType<typeof useMyDownloadsQuery>;
export const ActiveDownloadsDocument = gql`
    query ActiveDownloads {
  activeDownloads {
    jobId
    deviceName
    filePath
    status
    progress
    downloadUrl
    networkQuality
    uploadSpeed
  }
}
    `;

/**
 * __useActiveDownloadsQuery__
 *
 * To run a query within a React component, call `useActiveDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveDownloadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveDownloadsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveDownloadsQuery, ActiveDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActiveDownloadsQuery, ActiveDownloadsQueryVariables>(ActiveDownloadsDocument, options);
      }
export function useActiveDownloadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveDownloadsQuery, ActiveDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActiveDownloadsQuery, ActiveDownloadsQueryVariables>(ActiveDownloadsDocument, options);
        }
// @ts-ignore
export type ActiveDownloadsQueryHookResult = ReturnType<typeof useActiveDownloadsQuery>;
export type ActiveDownloadsLazyQueryHookResult = ReturnType<typeof useActiveDownloadsLazyQuery>;
export type ActiveDownloadsQueryResult = ReturnType<typeof useActiveDownloadsQuery>;
export const DownloadJobDocument = gql`
    query DownloadJob($jobId: String!) {
  downloadJob(jobId: $jobId) {
    jobId
    status
    progress
    downloadUrl
    errorMessage
  }
}
    `;

/**
 * __useDownloadJobQuery__
 *
 * To run a query within a React component, call `useDownloadJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDownloadJobQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DownloadJobQuery, DownloadJobQueryVariables> & ({ variables: DownloadJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DownloadJobQuery, DownloadJobQueryVariables>(DownloadJobDocument, options);
      }
export function useDownloadJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DownloadJobQuery, DownloadJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DownloadJobQuery, DownloadJobQueryVariables>(DownloadJobDocument, options);
        }
// @ts-ignore
export type DownloadJobQueryHookResult = ReturnType<typeof useDownloadJobQuery>;
export type DownloadJobLazyQueryHookResult = ReturnType<typeof useDownloadJobLazyQuery>;
export type DownloadJobQueryResult = ReturnType<typeof useDownloadJobQuery>;
export const GetGoogleSheetDevicesDocument = gql`
    query GetGoogleSheetDevices {
  getGoogleSheetDevices {
    seq
    deviceName
    activeFlag
    installFlag
    hospitalName
    hospitalRoomName
    version
    status
    updatedAt
    cfg1_max_recording_time
    cfg1_motion_threshold
    cfg1_use_printer_cp1300
    cfg1_use_diary_capture
    cfg1_capture_sw_mode
    cfg1_recording_brightness
    cfg1_recording_contrast
    cfg1_recording_card_select_mode
  }
}
    `;

/**
 * __useGetGoogleSheetDevicesQuery__
 *
 * To run a query within a React component, call `useGetGoogleSheetDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleSheetDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleSheetDevicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleSheetDevicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGoogleSheetDevicesQuery, GetGoogleSheetDevicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGoogleSheetDevicesQuery, GetGoogleSheetDevicesQueryVariables>(GetGoogleSheetDevicesDocument, options);
      }
export function useGetGoogleSheetDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGoogleSheetDevicesQuery, GetGoogleSheetDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGoogleSheetDevicesQuery, GetGoogleSheetDevicesQueryVariables>(GetGoogleSheetDevicesDocument, options);
        }
// @ts-ignore
export type GetGoogleSheetDevicesQueryHookResult = ReturnType<typeof useGetGoogleSheetDevicesQuery>;
export type GetGoogleSheetDevicesLazyQueryHookResult = ReturnType<typeof useGetGoogleSheetDevicesLazyQuery>;
export type GetGoogleSheetDevicesQueryResult = ReturnType<typeof useGetGoogleSheetDevicesQuery>;
export const GetGoogleSheetHospitalsDocument = gql`
    query GetGoogleSheetHospitals {
  getGoogleSheetHospitals {
    seq
    hospitalName
    city
    address
    telephone
    useTelemedicineFlag
    useNiptFlag
    useLibreFlag
    migrationServiceProvider
    migrationServiceActiveFlag
    defaultBlindRecording
    defaultBlindCapture
    activeFlag
  }
}
    `;

/**
 * __useGetGoogleSheetHospitalsQuery__
 *
 * To run a query within a React component, call `useGetGoogleSheetHospitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleSheetHospitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleSheetHospitalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleSheetHospitalsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGoogleSheetHospitalsQuery, GetGoogleSheetHospitalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGoogleSheetHospitalsQuery, GetGoogleSheetHospitalsQueryVariables>(GetGoogleSheetHospitalsDocument, options);
      }
export function useGetGoogleSheetHospitalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGoogleSheetHospitalsQuery, GetGoogleSheetHospitalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGoogleSheetHospitalsQuery, GetGoogleSheetHospitalsQueryVariables>(GetGoogleSheetHospitalsDocument, options);
        }
// @ts-ignore
export type GetGoogleSheetHospitalsQueryHookResult = ReturnType<typeof useGetGoogleSheetHospitalsQuery>;
export type GetGoogleSheetHospitalsLazyQueryHookResult = ReturnType<typeof useGetGoogleSheetHospitalsLazyQuery>;
export type GetGoogleSheetHospitalsQueryResult = ReturnType<typeof useGetGoogleSheetHospitalsQuery>;
export const GetGoogleSheetRecordingsDocument = gql`
    query GetGoogleSheetRecordings {
  getGoogleSheetRecordings {
    seq
    barcode
    deviceName
    hospitalName
    description
    hospitalRoomName
    deleteFlag
    videoLength
    recordedAt
    createdAt
  }
}
    `;

/**
 * __useGetGoogleSheetRecordingsQuery__
 *
 * To run a query within a React component, call `useGetGoogleSheetRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleSheetRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleSheetRecordingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleSheetRecordingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGoogleSheetRecordingsQuery, GetGoogleSheetRecordingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGoogleSheetRecordingsQuery, GetGoogleSheetRecordingsQueryVariables>(GetGoogleSheetRecordingsDocument, options);
      }
export function useGetGoogleSheetRecordingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGoogleSheetRecordingsQuery, GetGoogleSheetRecordingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGoogleSheetRecordingsQuery, GetGoogleSheetRecordingsQueryVariables>(GetGoogleSheetRecordingsDocument, options);
        }
// @ts-ignore
export type GetGoogleSheetRecordingsQueryHookResult = ReturnType<typeof useGetGoogleSheetRecordingsQuery>;
export type GetGoogleSheetRecordingsLazyQueryHookResult = ReturnType<typeof useGetGoogleSheetRecordingsLazyQuery>;
export type GetGoogleSheetRecordingsQueryResult = ReturnType<typeof useGetGoogleSheetRecordingsQuery>;
export const GetGoogleSheetCapturesDocument = gql`
    query GetGoogleSheetCaptures {
  getGoogleSheetCaptures {
    seq
    hospitalName
    hospitalRoomName
    deviceName
    barcode
    deleteFlag
    capturedAt
  }
}
    `;

/**
 * __useGetGoogleSheetCapturesQuery__
 *
 * To run a query within a React component, call `useGetGoogleSheetCapturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleSheetCapturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleSheetCapturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleSheetCapturesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGoogleSheetCapturesQuery, GetGoogleSheetCapturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGoogleSheetCapturesQuery, GetGoogleSheetCapturesQueryVariables>(GetGoogleSheetCapturesDocument, options);
      }
export function useGetGoogleSheetCapturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGoogleSheetCapturesQuery, GetGoogleSheetCapturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGoogleSheetCapturesQuery, GetGoogleSheetCapturesQueryVariables>(GetGoogleSheetCapturesDocument, options);
        }
// @ts-ignore
export type GetGoogleSheetCapturesQueryHookResult = ReturnType<typeof useGetGoogleSheetCapturesQuery>;
export type GetGoogleSheetCapturesLazyQueryHookResult = ReturnType<typeof useGetGoogleSheetCapturesLazyQuery>;
export type GetGoogleSheetCapturesQueryResult = ReturnType<typeof useGetGoogleSheetCapturesQuery>;
export const HospitalsDocument = gql`
    query Hospitals {
  hospitals {
    ...HospitalFragment
  }
}
    ${HospitalFragmentDoc}`;

/**
 * __useHospitalsQuery__
 *
 * To run a query within a React component, call `useHospitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHospitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHospitalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHospitalsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HospitalsQuery, HospitalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HospitalsQuery, HospitalsQueryVariables>(HospitalsDocument, options);
      }
export function useHospitalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HospitalsQuery, HospitalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HospitalsQuery, HospitalsQueryVariables>(HospitalsDocument, options);
        }
// @ts-ignore
export type HospitalsQueryHookResult = ReturnType<typeof useHospitalsQuery>;
export type HospitalsLazyQueryHookResult = ReturnType<typeof useHospitalsLazyQuery>;
export type HospitalsQueryResult = ReturnType<typeof useHospitalsQuery>;
export const PaginatedHospitalsDocument = gql`
    query PaginatedHospitals($listOptions: HospitalListOptions!) {
  paginatedHospitals(listOptions: $listOptions) {
    nodes {
      ...HospitalFragment
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${HospitalFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedHospitalsQuery__
 *
 * To run a query within a React component, call `usePaginatedHospitalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedHospitalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedHospitalsQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedHospitalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedHospitalsQuery, PaginatedHospitalsQueryVariables> & ({ variables: PaginatedHospitalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedHospitalsQuery, PaginatedHospitalsQueryVariables>(PaginatedHospitalsDocument, options);
      }
export function usePaginatedHospitalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedHospitalsQuery, PaginatedHospitalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedHospitalsQuery, PaginatedHospitalsQueryVariables>(PaginatedHospitalsDocument, options);
        }
// @ts-ignore
export type PaginatedHospitalsQueryHookResult = ReturnType<typeof usePaginatedHospitalsQuery>;
export type PaginatedHospitalsLazyQueryHookResult = ReturnType<typeof usePaginatedHospitalsLazyQuery>;
export type PaginatedHospitalsQueryResult = ReturnType<typeof usePaginatedHospitalsQuery>;
export const HospitalRoomsDocument = gql`
    query HospitalRooms($hospitalSeq: Float!) {
  hospitalRooms(hospitalSeq: $hospitalSeq) {
    ...HospitalRoomFragment
  }
}
    ${HospitalRoomFragmentDoc}`;

/**
 * __useHospitalRoomsQuery__
 *
 * To run a query within a React component, call `useHospitalRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHospitalRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHospitalRoomsQuery({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useHospitalRoomsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HospitalRoomsQuery, HospitalRoomsQueryVariables> & ({ variables: HospitalRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HospitalRoomsQuery, HospitalRoomsQueryVariables>(HospitalRoomsDocument, options);
      }
export function useHospitalRoomsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HospitalRoomsQuery, HospitalRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HospitalRoomsQuery, HospitalRoomsQueryVariables>(HospitalRoomsDocument, options);
        }
// @ts-ignore
export type HospitalRoomsQueryHookResult = ReturnType<typeof useHospitalRoomsQuery>;
export type HospitalRoomsLazyQueryHookResult = ReturnType<typeof useHospitalRoomsLazyQuery>;
export type HospitalRoomsQueryResult = ReturnType<typeof useHospitalRoomsQuery>;
export const HospitalRoomsWithDevicesDocument = gql`
    query HospitalRoomsWithDevices($hospitalSeq: Float!) {
  hospitalRooms(hospitalSeq: $hospitalSeq) {
    ...HospitalRoomFragment
    devices {
      ...DeviceFragment
      deviceState {
        ...DeviceStateFragment
      }
      agentState {
        ...AgentStateFragment
      }
    }
  }
}
    ${HospitalRoomFragmentDoc}
${DeviceFragmentDoc}
${DeviceStateFragmentDoc}
${AgentStateFragmentDoc}`;

/**
 * __useHospitalRoomsWithDevicesQuery__
 *
 * To run a query within a React component, call `useHospitalRoomsWithDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHospitalRoomsWithDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHospitalRoomsWithDevicesQuery({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useHospitalRoomsWithDevicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HospitalRoomsWithDevicesQuery, HospitalRoomsWithDevicesQueryVariables> & ({ variables: HospitalRoomsWithDevicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HospitalRoomsWithDevicesQuery, HospitalRoomsWithDevicesQueryVariables>(HospitalRoomsWithDevicesDocument, options);
      }
export function useHospitalRoomsWithDevicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HospitalRoomsWithDevicesQuery, HospitalRoomsWithDevicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HospitalRoomsWithDevicesQuery, HospitalRoomsWithDevicesQueryVariables>(HospitalRoomsWithDevicesDocument, options);
        }
// @ts-ignore
export type HospitalRoomsWithDevicesQueryHookResult = ReturnType<typeof useHospitalRoomsWithDevicesQuery>;
export type HospitalRoomsWithDevicesLazyQueryHookResult = ReturnType<typeof useHospitalRoomsWithDevicesLazyQuery>;
export type HospitalRoomsWithDevicesQueryResult = ReturnType<typeof useHospitalRoomsWithDevicesQuery>;
export const HospitalLoginsDocument = gql`
    query HospitalLogins($hospitalSeq: Float!) {
  hospitalLogins(hospitalSeq: $hospitalSeq) {
    ...HospitalLoginFragment
    permission {
      ...HospitalLoginPermissionFragment
    }
  }
}
    ${HospitalLoginFragmentDoc}
${HospitalLoginPermissionFragmentDoc}`;

/**
 * __useHospitalLoginsQuery__
 *
 * To run a query within a React component, call `useHospitalLoginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHospitalLoginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHospitalLoginsQuery({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useHospitalLoginsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HospitalLoginsQuery, HospitalLoginsQueryVariables> & ({ variables: HospitalLoginsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HospitalLoginsQuery, HospitalLoginsQueryVariables>(HospitalLoginsDocument, options);
      }
export function useHospitalLoginsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HospitalLoginsQuery, HospitalLoginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HospitalLoginsQuery, HospitalLoginsQueryVariables>(HospitalLoginsDocument, options);
        }
// @ts-ignore
export type HospitalLoginsQueryHookResult = ReturnType<typeof useHospitalLoginsQuery>;
export type HospitalLoginsLazyQueryHookResult = ReturnType<typeof useHospitalLoginsLazyQuery>;
export type HospitalLoginsQueryResult = ReturnType<typeof useHospitalLoginsQuery>;
export const HospitalSubscriptionInfoDocument = gql`
    query HospitalSubscriptionInfo($hospitalSeq: Float!) {
  hospitalSubscriptionInfo(hospitalSeq: $hospitalSeq) {
    ...SubscriptionInfoFragment
  }
}
    ${SubscriptionInfoFragmentDoc}`;

/**
 * __useHospitalSubscriptionInfo__
 *
 * To run a query within a React component, call `useHospitalSubscriptionInfo` and pass it any options that fit your needs.
 * When your component renders, `useHospitalSubscriptionInfo` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHospitalSubscriptionInfo({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useHospitalSubscriptionInfo(baseOptions: ApolloReactHooks.QueryHookOptions<HospitalSubscriptionInfoQuery, HospitalSubscriptionInfoQueryVariables> & ({ variables: HospitalSubscriptionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HospitalSubscriptionInfoQuery, HospitalSubscriptionInfoQueryVariables>(HospitalSubscriptionInfoDocument, options);
      }
export function useHospitalSubscriptionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HospitalSubscriptionInfoQuery, HospitalSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HospitalSubscriptionInfoQuery, HospitalSubscriptionInfoQueryVariables>(HospitalSubscriptionInfoDocument, options);
        }
// @ts-ignore
export type HospitalSubscriptionInfoHookResult = ReturnType<typeof useHospitalSubscriptionInfo>;
export type HospitalSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useHospitalSubscriptionInfoLazyQuery>;
export type HospitalSubscriptionInfoQueryResult = ReturnType<typeof useHospitalSubscriptionInfo>;
export const RecordingsDocument = gql`
    query Recordings($searchDateInput: SearchDateInput!) {
  recordings(searchDateInput: $searchDateInput) {
    ...RecordingFragment
    hospital {
      ...HospitalFragment
    }
    hospitalRoom {
      ...HospitalRoomFragment
    }
    device {
      ...DeviceFragment
    }
  }
}
    ${RecordingFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${DeviceFragmentDoc}`;

/**
 * __useRecordingsQuery__
 *
 * To run a query within a React component, call `useRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingsQuery({
 *   variables: {
 *      searchDateInput: // value for 'searchDateInput'
 *   },
 * });
 */
export function useRecordingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecordingsQuery, RecordingsQueryVariables> & ({ variables: RecordingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecordingsQuery, RecordingsQueryVariables>(RecordingsDocument, options);
      }
export function useRecordingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecordingsQuery, RecordingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecordingsQuery, RecordingsQueryVariables>(RecordingsDocument, options);
        }
// @ts-ignore
export type RecordingsQueryHookResult = ReturnType<typeof useRecordingsQuery>;
export type RecordingsLazyQueryHookResult = ReturnType<typeof useRecordingsLazyQuery>;
export type RecordingsQueryResult = ReturnType<typeof useRecordingsQuery>;
export const PaginatedRecordingsDocument = gql`
    query PaginatedRecordings($listOptions: RecordingListOptions!) {
  paginatedRecordings(listOptions: $listOptions) {
    nodes {
      ...RecordingFragment
      hospital {
        ...HospitalFragment
      }
      hospitalRoom {
        ...HospitalRoomFragment
      }
      device {
        ...DeviceFragment
      }
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${RecordingFragmentDoc}
${HospitalFragmentDoc}
${HospitalRoomFragmentDoc}
${DeviceFragmentDoc}
${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedRecordingsQuery__
 *
 * To run a query within a React component, call `usePaginatedRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedRecordingsQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedRecordingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedRecordingsQuery, PaginatedRecordingsQueryVariables> & ({ variables: PaginatedRecordingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedRecordingsQuery, PaginatedRecordingsQueryVariables>(PaginatedRecordingsDocument, options);
      }
export function usePaginatedRecordingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedRecordingsQuery, PaginatedRecordingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedRecordingsQuery, PaginatedRecordingsQueryVariables>(PaginatedRecordingsDocument, options);
        }
// @ts-ignore
export type PaginatedRecordingsQueryHookResult = ReturnType<typeof usePaginatedRecordingsQuery>;
export type PaginatedRecordingsLazyQueryHookResult = ReturnType<typeof usePaginatedRecordingsLazyQuery>;
export type PaginatedRecordingsQueryResult = ReturnType<typeof usePaginatedRecordingsQuery>;
export const FirstRecordingBarcodesDocument = gql`
    query FirstRecordingBarcodes($input: FirstRecordingBarcodeExportInput!) {
  firstRecordingBarcodes(input: $input) {
    barcode
    recordedAt
    hospitalSeq
    hospitalName
    userName
    userPhoneNumber
  }
}
    `;

/**
 * __useFirstRecordingBarcodesQuery__
 *
 * To run a query within a React component, call `useFirstRecordingBarcodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirstRecordingBarcodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstRecordingBarcodesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFirstRecordingBarcodesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FirstRecordingBarcodesQuery, FirstRecordingBarcodesQueryVariables> & ({ variables: FirstRecordingBarcodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FirstRecordingBarcodesQuery, FirstRecordingBarcodesQueryVariables>(FirstRecordingBarcodesDocument, options);
      }
export function useFirstRecordingBarcodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FirstRecordingBarcodesQuery, FirstRecordingBarcodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FirstRecordingBarcodesQuery, FirstRecordingBarcodesQueryVariables>(FirstRecordingBarcodesDocument, options);
        }
// @ts-ignore
export type FirstRecordingBarcodesQueryHookResult = ReturnType<typeof useFirstRecordingBarcodesQuery>;
export type FirstRecordingBarcodesLazyQueryHookResult = ReturnType<typeof useFirstRecordingBarcodesLazyQuery>;
export type FirstRecordingBarcodesQueryResult = ReturnType<typeof useFirstRecordingBarcodesQuery>;
export const SendFirstRecordingBarcodeMessagesDocument = gql`
    mutation SendFirstRecordingBarcodeMessages($input: FirstRecordingBarcodeMessageSendInput!) {
  sendFirstRecordingBarcodeMessages(input: $input) {
    status
    requestedCount
    sentCount
    skippedCount
    failedCount
    message
  }
}
    `;

/**
 * __useSendFirstRecordingBarcodeMessagesMutation__
 *
 * To run a mutation, you first call `useSendFirstRecordingBarcodeMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFirstRecordingBarcodeMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFirstRecordingBarcodeMessagesMutation, { data, loading, error }] = useSendFirstRecordingBarcodeMessagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFirstRecordingBarcodeMessagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendFirstRecordingBarcodeMessagesMutation, SendFirstRecordingBarcodeMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendFirstRecordingBarcodeMessagesMutation, SendFirstRecordingBarcodeMessagesMutationVariables>(SendFirstRecordingBarcodeMessagesDocument, options);
      }
export type SendFirstRecordingBarcodeMessagesMutationHookResult = ReturnType<typeof useSendFirstRecordingBarcodeMessagesMutation>;
export type SendFirstRecordingBarcodeMessagesMutationResult = ReturnType<typeof useSendFirstRecordingBarcodeMessagesMutation>;
export type SendFirstRecordingBarcodeMessagesMutationOptions = Apollo.MutationOptions<SendFirstRecordingBarcodeMessagesMutation, SendFirstRecordingBarcodeMessagesMutationVariables>;
export const GetUltrasoundCapturesByRecordingDocument = gql`
    query GetUltrasoundCapturesByRecording($seq: Float!) {
  getUltrasoundCaptureByRecording(seq: $seq) {
    captures {
      ...UltrasoundCaptureFragment
    }
    count
  }
}
    ${UltrasoundCaptureFragmentDoc}`;

/**
 * __useGetUltrasoundCapturesByRecordingQuery__
 *
 * To run a query within a React component, call `useGetUltrasoundCapturesByRecordingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUltrasoundCapturesByRecordingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUltrasoundCapturesByRecordingQuery({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useGetUltrasoundCapturesByRecordingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUltrasoundCapturesByRecordingQuery, GetUltrasoundCapturesByRecordingQueryVariables> & ({ variables: GetUltrasoundCapturesByRecordingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUltrasoundCapturesByRecordingQuery, GetUltrasoundCapturesByRecordingQueryVariables>(GetUltrasoundCapturesByRecordingDocument, options);
      }
export function useGetUltrasoundCapturesByRecordingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUltrasoundCapturesByRecordingQuery, GetUltrasoundCapturesByRecordingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUltrasoundCapturesByRecordingQuery, GetUltrasoundCapturesByRecordingQueryVariables>(GetUltrasoundCapturesByRecordingDocument, options);
        }
// @ts-ignore
export type GetUltrasoundCapturesByRecordingQueryHookResult = ReturnType<typeof useGetUltrasoundCapturesByRecordingQuery>;
export type GetUltrasoundCapturesByRecordingLazyQueryHookResult = ReturnType<typeof useGetUltrasoundCapturesByRecordingLazyQuery>;
export type GetUltrasoundCapturesByRecordingQueryResult = ReturnType<typeof useGetUltrasoundCapturesByRecordingQuery>;
export const GetMothersMembersDocument = gql`
    query GetMothersMembers($listOptions: ListOptions!) {
  getMothersMembers(listOptions: $listOptions) {
    nodes {
      mIdx
      mId
      mPhone
      mName
      mNickname
      mEmail
      mRegiste
      mHidx
      mChartNum
      mDateOfBirth
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${PaginationMetaFragmentDoc}`;

/**
 * __useGetMothersMembersQuery__
 *
 * To run a query within a React component, call `useGetMothersMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMothersMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMothersMembersQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function useGetMothersMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMothersMembersQuery, GetMothersMembersQueryVariables> & ({ variables: GetMothersMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMothersMembersQuery, GetMothersMembersQueryVariables>(GetMothersMembersDocument, options);
      }
export function useGetMothersMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMothersMembersQuery, GetMothersMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMothersMembersQuery, GetMothersMembersQueryVariables>(GetMothersMembersDocument, options);
        }
// @ts-ignore
export type GetMothersMembersQueryHookResult = ReturnType<typeof useGetMothersMembersQuery>;
export type GetMothersMembersLazyQueryHookResult = ReturnType<typeof useGetMothersMembersLazyQuery>;
export type GetMothersMembersQueryResult = ReturnType<typeof useGetMothersMembersQuery>;
export const GetMothersVideosDocument = gql`
    query GetMothersVideos($chartnumber: String!) {
  getMothersVideos(chartnumber: $chartnumber) {
    seq
    checked
    s3StorageClass
    migrationStatus
    migrationStatusMessage
    vHname
    vLocation
    vChartnumber
    vOriginChartnumber
    vRegiste
    vFilelocation
    vFilename
    vFilesize
  }
}
    `;

/**
 * __useGetMothersVideosQuery__
 *
 * To run a query within a React component, call `useGetMothersVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMothersVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMothersVideosQuery({
 *   variables: {
 *      chartnumber: // value for 'chartnumber'
 *   },
 * });
 */
export function useGetMothersVideosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMothersVideosQuery, GetMothersVideosQueryVariables> & ({ variables: GetMothersVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMothersVideosQuery, GetMothersVideosQueryVariables>(GetMothersVideosDocument, options);
      }
export function useGetMothersVideosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMothersVideosQuery, GetMothersVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMothersVideosQuery, GetMothersVideosQueryVariables>(GetMothersVideosDocument, options);
        }
// @ts-ignore
export type GetMothersVideosQueryHookResult = ReturnType<typeof useGetMothersVideosQuery>;
export type GetMothersVideosLazyQueryHookResult = ReturnType<typeof useGetMothersVideosLazyQuery>;
export type GetMothersVideosQueryResult = ReturnType<typeof useGetMothersVideosQuery>;
export const GetHumangateMembersDocument = gql`
    query GetHumangateMembers($listOptions: ListOptions!) {
  getHumangateMembers(listOptions: $listOptions) {
    nodes {
      seq
      no
      name
      phone
      barcode
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${PaginationMetaFragmentDoc}`;

/**
 * __useGetHumangateMembersQuery__
 *
 * To run a query within a React component, call `useGetHumangateMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHumangateMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHumangateMembersQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function useGetHumangateMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHumangateMembersQuery, GetHumangateMembersQueryVariables> & ({ variables: GetHumangateMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHumangateMembersQuery, GetHumangateMembersQueryVariables>(GetHumangateMembersDocument, options);
      }
export function useGetHumangateMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHumangateMembersQuery, GetHumangateMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHumangateMembersQuery, GetHumangateMembersQueryVariables>(GetHumangateMembersDocument, options);
        }
// @ts-ignore
export type GetHumangateMembersQueryHookResult = ReturnType<typeof useGetHumangateMembersQuery>;
export type GetHumangateMembersLazyQueryHookResult = ReturnType<typeof useGetHumangateMembersLazyQuery>;
export type GetHumangateMembersQueryResult = ReturnType<typeof useGetHumangateMembersQuery>;
export const GetHumangateVideosDocument = gql`
    query GetHumangateVideos($barcode: String!) {
  getHumangateVideos(barcode: $barcode) {
    fileName
    fileSize
    recordedAt
  }
}
    `;

/**
 * __useGetHumangateVideosQuery__
 *
 * To run a query within a React component, call `useGetHumangateVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHumangateVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHumangateVideosQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *   },
 * });
 */
export function useGetHumangateVideosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHumangateVideosQuery, GetHumangateVideosQueryVariables> & ({ variables: GetHumangateVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHumangateVideosQuery, GetHumangateVideosQueryVariables>(GetHumangateVideosDocument, options);
      }
export function useGetHumangateVideosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHumangateVideosQuery, GetHumangateVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHumangateVideosQuery, GetHumangateVideosQueryVariables>(GetHumangateVideosDocument, options);
        }
// @ts-ignore
export type GetHumangateVideosQueryHookResult = ReturnType<typeof useGetHumangateVideosQuery>;
export type GetHumangateVideosLazyQueryHookResult = ReturnType<typeof useGetHumangateVideosLazyQuery>;
export type GetHumangateVideosQueryResult = ReturnType<typeof useGetHumangateVideosQuery>;
export const SearchRecordingsByBarcodeDocument = gql`
    query SearchRecordingsByBarcode($barcode: String!) {
  searchRecordingsByBarcode(barcode: $barcode) {
    seq
    fileId
    hospitalName
    hospitalRoomName
    recordedAt
    videoLength
  }
}
    `;

/**
 * __useSearchRecordingsByBarcodeQuery__
 *
 * To run a query within a React component, call `useSearchRecordingsByBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRecordingsByBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRecordingsByBarcodeQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *   },
 * });
 */
export function useSearchRecordingsByBarcodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchRecordingsByBarcodeQuery, SearchRecordingsByBarcodeQueryVariables> & ({ variables: SearchRecordingsByBarcodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchRecordingsByBarcodeQuery, SearchRecordingsByBarcodeQueryVariables>(SearchRecordingsByBarcodeDocument, options);
      }
export function useSearchRecordingsByBarcodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchRecordingsByBarcodeQuery, SearchRecordingsByBarcodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchRecordingsByBarcodeQuery, SearchRecordingsByBarcodeQueryVariables>(SearchRecordingsByBarcodeDocument, options);
        }
// @ts-ignore
export type SearchRecordingsByBarcodeQueryHookResult = ReturnType<typeof useSearchRecordingsByBarcodeQuery>;
export type SearchRecordingsByBarcodeLazyQueryHookResult = ReturnType<typeof useSearchRecordingsByBarcodeLazyQuery>;
export type SearchRecordingsByBarcodeQueryResult = ReturnType<typeof useSearchRecordingsByBarcodeQuery>;
export const StoppedRecordingRestoreSummaryDocument = gql`
    query StoppedRecordingRestoreSummary($barcode: String!) {
  stoppedRecordingRestoreSummary(barcode: $barcode) {
    hospitalSeq
    hospitalName
    disabledCount
    restorableCount
    unrestorableCount
  }
}
    `;

/**
 * __useStoppedRecordingRestoreSummaryQuery__
 *
 * To run a query within a React component, call `useStoppedRecordingRestoreSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoppedRecordingRestoreSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoppedRecordingRestoreSummaryQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *   },
 * });
 */
export function useStoppedRecordingRestoreSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoppedRecordingRestoreSummaryQuery, StoppedRecordingRestoreSummaryQueryVariables> & ({ variables: StoppedRecordingRestoreSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoppedRecordingRestoreSummaryQuery, StoppedRecordingRestoreSummaryQueryVariables>(StoppedRecordingRestoreSummaryDocument, options);
      }
export function useStoppedRecordingRestoreSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoppedRecordingRestoreSummaryQuery, StoppedRecordingRestoreSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoppedRecordingRestoreSummaryQuery, StoppedRecordingRestoreSummaryQueryVariables>(StoppedRecordingRestoreSummaryDocument, options);
        }
// @ts-ignore
export type StoppedRecordingRestoreSummaryQueryHookResult = ReturnType<typeof useStoppedRecordingRestoreSummaryQuery>;
export type StoppedRecordingRestoreSummaryLazyQueryHookResult = ReturnType<typeof useStoppedRecordingRestoreSummaryLazyQuery>;
export type StoppedRecordingRestoreSummaryQueryResult = ReturnType<typeof useStoppedRecordingRestoreSummaryQuery>;
export const StoppedRecordingRestoreCandidatesDocument = gql`
    query StoppedRecordingRestoreCandidates($barcode: String!, $hospitalSeq: Int!) {
  stoppedRecordingRestoreCandidates(barcode: $barcode, hospitalSeq: $hospitalSeq) {
    seq
    fullBarcode
    fileId
    recordedAt
    currentS3FileKey
    expectedS3FileKey
    restorable
    failureReason
  }
}
    `;

/**
 * __useStoppedRecordingRestoreCandidatesQuery__
 *
 * To run a query within a React component, call `useStoppedRecordingRestoreCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoppedRecordingRestoreCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoppedRecordingRestoreCandidatesQuery({
 *   variables: {
 *      barcode: // value for 'barcode'
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useStoppedRecordingRestoreCandidatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoppedRecordingRestoreCandidatesQuery, StoppedRecordingRestoreCandidatesQueryVariables> & ({ variables: StoppedRecordingRestoreCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoppedRecordingRestoreCandidatesQuery, StoppedRecordingRestoreCandidatesQueryVariables>(StoppedRecordingRestoreCandidatesDocument, options);
      }
export function useStoppedRecordingRestoreCandidatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoppedRecordingRestoreCandidatesQuery, StoppedRecordingRestoreCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoppedRecordingRestoreCandidatesQuery, StoppedRecordingRestoreCandidatesQueryVariables>(StoppedRecordingRestoreCandidatesDocument, options);
        }
// @ts-ignore
export type StoppedRecordingRestoreCandidatesQueryHookResult = ReturnType<typeof useStoppedRecordingRestoreCandidatesQuery>;
export type StoppedRecordingRestoreCandidatesLazyQueryHookResult = ReturnType<typeof useStoppedRecordingRestoreCandidatesLazyQuery>;
export type StoppedRecordingRestoreCandidatesQueryResult = ReturnType<typeof useStoppedRecordingRestoreCandidatesQuery>;
export const PaginatedStoppedRecordingRestoreHistoriesDocument = gql`
    query PaginatedStoppedRecordingRestoreHistories($listOptions: StoppedRecordingRestoreHistoryListOptions!) {
  paginatedStoppedRecordingRestoreHistories(listOptions: $listOptions) {
    nodes {
      seq
      hospitalSeq
      hospitalName
      barcode
      actorIdentity
      reason
      requestedCount
      restoredCount
      failedCount
      createdAt
      recordings {
        recordingSeq
        fullBarcode
        fileId
        fromS3FileKey
        toS3FileKey
        status
        failureReason
      }
    }
    meta {
      ...PaginationMetaFragment
    }
  }
}
    ${PaginationMetaFragmentDoc}`;

/**
 * __usePaginatedStoppedRecordingRestoreHistoriesQuery__
 *
 * To run a query within a React component, call `usePaginatedStoppedRecordingRestoreHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedStoppedRecordingRestoreHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedStoppedRecordingRestoreHistoriesQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedStoppedRecordingRestoreHistoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaginatedStoppedRecordingRestoreHistoriesQuery, PaginatedStoppedRecordingRestoreHistoriesQueryVariables> & ({ variables: PaginatedStoppedRecordingRestoreHistoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedStoppedRecordingRestoreHistoriesQuery, PaginatedStoppedRecordingRestoreHistoriesQueryVariables>(PaginatedStoppedRecordingRestoreHistoriesDocument, options);
      }
export function usePaginatedStoppedRecordingRestoreHistoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedStoppedRecordingRestoreHistoriesQuery, PaginatedStoppedRecordingRestoreHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedStoppedRecordingRestoreHistoriesQuery, PaginatedStoppedRecordingRestoreHistoriesQueryVariables>(PaginatedStoppedRecordingRestoreHistoriesDocument, options);
        }
// @ts-ignore
export type PaginatedStoppedRecordingRestoreHistoriesQueryHookResult = ReturnType<typeof usePaginatedStoppedRecordingRestoreHistoriesQuery>;
export type PaginatedStoppedRecordingRestoreHistoriesLazyQueryHookResult = ReturnType<typeof usePaginatedStoppedRecordingRestoreHistoriesLazyQuery>;
export type PaginatedStoppedRecordingRestoreHistoriesQueryResult = ReturnType<typeof usePaginatedStoppedRecordingRestoreHistoriesQuery>;
export const PaginatedSpecialBarcodesDocument = gql`
    query PaginatedSpecialBarcodes($listOptions: SpecialBarcodeListOptions) {
  paginatedSpecialBarcodes(listOptions: $listOptions) {
    nodes {
      seq
      barcode
      type
      reason
      createdBy
      createdAt
      updatedAt
    }
    meta {
      totalCount
      page
      limit
    }
  }
}
    `;

/**
 * __usePaginatedSpecialBarcodesQuery__
 *
 * To run a query within a React component, call `usePaginatedSpecialBarcodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedSpecialBarcodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedSpecialBarcodesQuery({
 *   variables: {
 *      listOptions: // value for 'listOptions'
 *   },
 * });
 */
export function usePaginatedSpecialBarcodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaginatedSpecialBarcodesQuery, PaginatedSpecialBarcodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaginatedSpecialBarcodesQuery, PaginatedSpecialBarcodesQueryVariables>(PaginatedSpecialBarcodesDocument, options);
      }
export function usePaginatedSpecialBarcodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedSpecialBarcodesQuery, PaginatedSpecialBarcodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaginatedSpecialBarcodesQuery, PaginatedSpecialBarcodesQueryVariables>(PaginatedSpecialBarcodesDocument, options);
        }
// @ts-ignore
export type PaginatedSpecialBarcodesQueryHookResult = ReturnType<typeof usePaginatedSpecialBarcodesQuery>;
export type PaginatedSpecialBarcodesLazyQueryHookResult = ReturnType<typeof usePaginatedSpecialBarcodesLazyQuery>;
export type PaginatedSpecialBarcodesQueryResult = ReturnType<typeof usePaginatedSpecialBarcodesQuery>;
export const SpecialBarcodeDocument = gql`
    query SpecialBarcode($seq: Int!) {
  specialBarcode(seq: $seq) {
    seq
    barcode
    type
    reason
    createdBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSpecialBarcodeQuery__
 *
 * To run a query within a React component, call `useSpecialBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialBarcodeQuery({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useSpecialBarcodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SpecialBarcodeQuery, SpecialBarcodeQueryVariables> & ({ variables: SpecialBarcodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SpecialBarcodeQuery, SpecialBarcodeQueryVariables>(SpecialBarcodeDocument, options);
      }
export function useSpecialBarcodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SpecialBarcodeQuery, SpecialBarcodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SpecialBarcodeQuery, SpecialBarcodeQueryVariables>(SpecialBarcodeDocument, options);
        }
// @ts-ignore
export type SpecialBarcodeQueryHookResult = ReturnType<typeof useSpecialBarcodeQuery>;
export type SpecialBarcodeLazyQueryHookResult = ReturnType<typeof useSpecialBarcodeLazyQuery>;
export type SpecialBarcodeQueryResult = ReturnType<typeof useSpecialBarcodeQuery>;
export const GetSystemSettingsDocument = gql`
    query GetSystemSettings {
  systemSettings {
    id
    settingKey
    description
    value
    defaultValue
    dataType
    constraints
    availableValues
    isRequired
    isActive
    displayOrder
    createdAt
    updatedAt
    updatedBy
  }
}
    `;

/**
 * __useGetSystemSettingsQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSystemSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(GetSystemSettingsDocument, options);
      }
export function useGetSystemSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSystemSettingsQuery, GetSystemSettingsQueryVariables>(GetSystemSettingsDocument, options);
        }
// @ts-ignore
export type GetSystemSettingsQueryHookResult = ReturnType<typeof useGetSystemSettingsQuery>;
export type GetSystemSettingsLazyQueryHookResult = ReturnType<typeof useGetSystemSettingsLazyQuery>;
export type GetSystemSettingsQueryResult = ReturnType<typeof useGetSystemSettingsQuery>;
export const GetSystemSettingDocument = gql`
    query GetSystemSetting($settingKey: String!) {
  systemSetting(settingKey: $settingKey) {
    settingKey
    description
    value
    defaultValue
    dataType
    constraints
    availableValues
  }
}
    `;

/**
 * __useGetSystemSettingQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingQuery({
 *   variables: {
 *      settingKey: // value for 'settingKey'
 *   },
 * });
 */
export function useGetSystemSettingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSystemSettingQuery, GetSystemSettingQueryVariables> & ({ variables: GetSystemSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSystemSettingQuery, GetSystemSettingQueryVariables>(GetSystemSettingDocument, options);
      }
export function useGetSystemSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSystemSettingQuery, GetSystemSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSystemSettingQuery, GetSystemSettingQueryVariables>(GetSystemSettingDocument, options);
        }
// @ts-ignore
export type GetSystemSettingQueryHookResult = ReturnType<typeof useGetSystemSettingQuery>;
export type GetSystemSettingLazyQueryHookResult = ReturnType<typeof useGetSystemSettingLazyQuery>;
export type GetSystemSettingQueryResult = ReturnType<typeof useGetSystemSettingQuery>;
export const GetSystemSettingValueDocument = gql`
    query GetSystemSettingValue($settingKey: String!) {
  systemSettingValue(settingKey: $settingKey)
}
    `;

/**
 * __useGetSystemSettingValueQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingValueQuery({
 *   variables: {
 *      settingKey: // value for 'settingKey'
 *   },
 * });
 */
export function useGetSystemSettingValueQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables> & ({ variables: GetSystemSettingValueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>(GetSystemSettingValueDocument, options);
      }
export function useGetSystemSettingValueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>(GetSystemSettingValueDocument, options);
        }
// @ts-ignore
export type GetSystemSettingValueQueryHookResult = ReturnType<typeof useGetSystemSettingValueQuery>;
export type GetSystemSettingValueLazyQueryHookResult = ReturnType<typeof useGetSystemSettingValueLazyQuery>;
export type GetSystemSettingValueQueryResult = ReturnType<typeof useGetSystemSettingValueQuery>;
export const GetTestBarcodeDocument = gql`
    query GetTestBarcode($countryCode: String!, $hospitalSeq: Float!, $recordedAt: String!) {
  getTestBarcode(
    countryCode: $countryCode
    hospitalSeq: $hospitalSeq
    recordedAt: $recordedAt
  ) {
    barcode
  }
}
    `;

/**
 * __useGetTestBarcodeQuery__
 *
 * To run a query within a React component, call `useGetTestBarcodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestBarcodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestBarcodeQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      hospitalSeq: // value for 'hospitalSeq'
 *      recordedAt: // value for 'recordedAt'
 *   },
 * });
 */
export function useGetTestBarcodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTestBarcodeQuery, GetTestBarcodeQueryVariables> & ({ variables: GetTestBarcodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTestBarcodeQuery, GetTestBarcodeQueryVariables>(GetTestBarcodeDocument, options);
      }
export function useGetTestBarcodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTestBarcodeQuery, GetTestBarcodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTestBarcodeQuery, GetTestBarcodeQueryVariables>(GetTestBarcodeDocument, options);
        }
// @ts-ignore
export type GetTestBarcodeQueryHookResult = ReturnType<typeof useGetTestBarcodeQuery>;
export type GetTestBarcodeLazyQueryHookResult = ReturnType<typeof useGetTestBarcodeLazyQuery>;
export type GetTestBarcodeQueryResult = ReturnType<typeof useGetTestBarcodeQuery>;
export const AdminUserDocument = gql`
    query AdminUser($userPassword: String!) {
  adminUser(userPassword: $userPassword) {
    status
    affected
    message
    seq
    userDisplayName
    userEmail
    enabledFlag
    superFlag
    accessToken
  }
}
    `;

/**
 * __useAdminUserQuery__
 *
 * To run a query within a React component, call `useAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQuery({
 *   variables: {
 *      userPassword: // value for 'userPassword'
 *   },
 * });
 */
export function useAdminUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminUserQuery, AdminUserQueryVariables> & ({ variables: AdminUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
      }
export function useAdminUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUserQuery, AdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, options);
        }
// @ts-ignore
export type AdminUserQueryHookResult = ReturnType<typeof useAdminUserQuery>;
export type AdminUserLazyQueryHookResult = ReturnType<typeof useAdminUserLazyQuery>;
export type AdminUserQueryResult = ReturnType<typeof useAdminUserQuery>;
export const DeviceUpdateDocument = gql`
    subscription DeviceUpdate($hospitalSeq: Float!) {
  deviceUpdate(hospitalSeq: $hospitalSeq) {
    seq
    deviceName
    hospitalSeq
    hospitalRoomSeq
    deviceState {
      ...DeviceStateFragment
    }
    agentState {
      ...AgentStateFragment
    }
  }
}
    ${DeviceStateFragmentDoc}
${AgentStateFragmentDoc}`;

/**
 * __useDeviceUpdateSubscription__
 *
 * To run a query within a React component, call `useDeviceUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeviceUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceUpdateSubscription({
 *   variables: {
 *      hospitalSeq: // value for 'hospitalSeq'
 *   },
 * });
 */
export function useDeviceUpdateSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<DeviceUpdateSubscription, DeviceUpdateSubscriptionVariables> & ({ variables: DeviceUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<DeviceUpdateSubscription, DeviceUpdateSubscriptionVariables>(DeviceUpdateDocument, options);
      }
export type DeviceUpdateSubscriptionHookResult = ReturnType<typeof useDeviceUpdateSubscription>;
export type DeviceUpdateSubscriptionResult = ReturnType<typeof useDeviceUpdateSubscription>;
